
; bm.show_response_status = false;
$.form_no_textarea_autosize = true;
$.scrollbar_horizontal_without_bar_step = "auto";
$.extend($.paginator_config, {
    next: app.next,
    prev: app.prev,
    first: app.first,
    last: app.last
})
; (function() {
    var widget_uuid = 0;
    window.WCUIWidget = function() {}

    WCUIWidget.prototype = {
        _createWidget: function( options, element ) {
            this.element = $( element );
            this.uuid = widget_uuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;

            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();
            this.options = $.extend( {},
                this.options,
                this._getCreateOptions(),
                options );

            this._create();
            this._trigger( "create", null, this._getCreateEventData() );
            this._init();
        },
        _getCreateOptions: $.noop,
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,

        destroy: function() {
            this._destroy();
            // we can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element
                .unbind( this.eventNamespace )
                .removeData( this.widgetFullName )
                // support: jquery <1.6.3
                // http://bugs.jquery.com/ticket/9413
                .removeData( $.camelCase( this.widgetFullName ) );
            this.widget()
                .unbind( this.eventNamespace )
                .removeAttr( "aria-disabled" )
                .removeClass(
                this.widgetFullName + "-disabled " +
                "ui-state-disabled" );

            // clean up events and states
            this.bindings.unbind( this.eventNamespace );
            this.hoverable.removeClass( "ui-state-hover" );
            this.focusable.removeClass( "ui-state-focus" );
        },
        _destroy: $.noop,

        widget: function() {
            return this.element;
        },

        option: function( key, value ) {
            var options = key,
                parts,
                curOption,
                i;

            if ( arguments.length === 0 ) {
                // don't return a reference to the internal hash
                return $.widget.extend( {}, this.options );
            }

            if ( typeof key === "string" ) {
                // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split( "." );
                key = parts.shift();
                if ( parts.length ) {
                    curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
                    for ( i = 0; i < parts.length - 1; i++ ) {
                        curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
                        curOption = curOption[ parts[ i ] ];
                    }
                    key = parts.pop();
                    if ( arguments.length === 1 ) {
                        return curOption[ key ] === undefined ? null : curOption[ key ];
                    }
                    curOption[ key ] = value;
                } else {
                    if ( arguments.length === 1 ) {
                        return this.options[ key ] === undefined ? null : this.options[ key ];
                    }
                    options[ key ] = value;
                }
            }

            this._setOptions( options );

            return this;
        },
        _setOptions: function( options ) {
            var key;

            for ( key in options ) {
                this._setOption( key, options[ key ] );
            }

            return this;
        },
        _setOption: function( key, value ) {
            this.options[ key ] = value;

            if ( key === "disabled" ) {
                this.widget()
                    .toggleClass( this.widgetFullName + "-disabled", !!value );

                // If the widget is becoming disabled, then nothing is interactive
                if ( value ) {
                    this.hoverable.removeClass( "ui-state-hover" );
                    this.focusable.removeClass( "ui-state-focus" );
                }
            }

            return this;
        },

        enable: function() {
            return this._setOptions({ disabled: false });
        },
        disable: function() {
            return this._setOptions({ disabled: true });
        },

        _on: function( suppressDisabledCheck, element, handlers ) {
            var delegateElement,
                instance = this;

            // no suppressDisabledCheck flag, shuffle arguments
            if ( typeof suppressDisabledCheck !== "boolean" ) {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }

            // no element argument, shuffle and use this.element
            if ( !handlers ) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                element = delegateElement = $( element );
                this.bindings = this.bindings.add( element );
            }

            $.each( handlers, function( event, handler ) {
                function handlerProxy() {
                    // allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if ( !suppressDisabledCheck &&
                        ( instance.options.disabled === true ||
                        $( this ).hasClass( "ui-state-disabled" ) ) ) {
                        return;
                    }
                    return ( typeof handler === "string" ? instance[ handler ] : handler )
                        .apply( instance, arguments );
                }

                // copy the guid so direct unbinding works
                if ( typeof handler !== "string" ) {
                    handlerProxy.guid = handler.guid =
                        handler.guid || handlerProxy.guid || $.guid++;
                }

                var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
                    eventName = match[1] + instance.eventNamespace,
                    selector = match[2];
                if ( selector ) {
                    delegateElement.delegate( selector, eventName, handlerProxy );
                } else {
                    element.bind( eventName, handlerProxy );
                }
            });
        },

        _off: function( element, eventName ) {
            eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
            this.eventNamespace;
            element.unbind( eventName ).undelegate( eventName );

            // Clear the stack to avoid memory leaks (#10056)
            this.bindings = $( this.bindings.not( element ).get() );
            this.focusable = $( this.focusable.not( element ).get() );
            this.hoverable = $( this.hoverable.not( element ).get() );
        },

        _delay: function( handler, delay ) {
            function handlerProxy() {
                return ( typeof handler === "string" ? instance[ handler ] : handler )
                    .apply( instance, arguments );
            }
            var instance = this;
            return setTimeout( handlerProxy, delay || 0 );
        },

        _hoverable: function( element ) {
            this.hoverable = this.hoverable.add( element );
            this._on( element, {
                mouseenter: function( event ) {
                    $( event.currentTarget ).addClass( "ui-state-hover" );
                },
                mouseleave: function( event ) {
                    $( event.currentTarget ).removeClass( "ui-state-hover" );
                }
            });
        },

        _focusable: function( element ) {
            this.focusable = this.focusable.add( element );
            this._on( element, {
                focusin: function( event ) {
                    $( event.currentTarget ).addClass( "ui-state-focus" );
                },
                focusout: function( event ) {
                    $( event.currentTarget ).removeClass( "ui-state-focus" );
                }
            });
        },

        _trigger: function( type, event, data ) {
            var prop, orig,
                callback = this.options[ type ];

            data = data || {};
            event = $.Event( event );
            event.type = ( type === this.widgetEventPrefix ?
                type :
            this.widgetEventPrefix + type ).toLowerCase();
            // the original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[ 0 ];

            // copy original event properties over to the new event
            orig = event.originalEvent;
            if ( orig ) {
                for ( prop in orig ) {
                    if ( !( prop in event ) ) {
                        event[ prop ] = orig[ prop ];
                    }
                }
            }

            this.element.trigger( event, data );
            return !( $.isFunction( callback ) &&
            callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
            event.isDefaultPrevented() );
        }
    };
})();

; /*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright 2015 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type="mousewheel","detail"in g&&(m=-1*g.detail),"wheelDelta"in g&&(m=g.wheelDelta),"wheelDeltaY"in g&&(m=g.wheelDeltaY),"wheelDeltaX"in g&&(l=-1*g.wheelDeltaX),"axis"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,"deltaY"in g&&(m=-1*g.deltaY,j=m),"deltaX"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,"mousewheel-line-height");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,"mousewheel-page-height");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?"floor":"ceil"](j/f),l=Math[l>=1?"floor":"ceil"](l/f),m=Math[m>=1?"floor":"ceil"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&"mousewheel"===a.type&&b%120===0}var e,f,g=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],h="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,"mousewheel-line-height",k.getLineHeight(this)),a.data(this,"mousewheel-page-height",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,"mousewheel-line-height"),a.removeData(this,"mousewheel-page-height")},getLineHeight:function(b){var c=a(b),d=c["offsetParent"in a.fn?"offsetParent":"parent"]();return d.length||(d=a("body")),parseInt(d.css("fontSize"),10)||parseInt(c.css("fontSize"),10)||16},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.unbind("mousewheel",a)}})});
; (function() {
    $.hotkeys = {
        version: "0.8+",
        specialKeys: {
            8: "backspace", 9: "tab", 13: "return", 16: "shift", 17: "ctrl", 18: "alt", 19: "pause",
            20: "capslock", 27: "esc", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home",
            37: "left", 38: "up", 39: "right", 40: "down", 45: "insert", 46: "del",
            96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7",
            104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111 : "/",
            112: "f1", 113: "f2", 114: "f3", 115: "f4", 116: "f5", 117: "f6", 118: "f7", 119: "f8",
            120: "f9", 121: "f10", 122: "f11", 123: "f12", 144: "numlock", 145: "scroll", 188: ",", 190: ".",
            191: "/", 224: "meta"
        },
        shiftNums: {
            "`": "~", "1": "!", "2": "@", "3": "#", "4": "$", "5": "%", "6": "^", "7": "&",
            "8": "*", "9": "(", "0": ")", "-": "_", "=": "+", ";": ": ", "'": "\"", ",": "<",
            ".": ">", "/": "?", "\\": "|"
        }
    };

    function keyHandler( handleObj ) {
        var origHandler = handleObj.handler, all_namespaces = (handleObj.namespace || "").toLowerCase().split(".");
        var keys = [];
        var namespace
        $.each(all_namespaces, function() {
            var isHot = (this != "" && this != "autocomplete" && (/^(key|alt|ctrl|meta|shift)_/.test(this)))
            if(isHot) {
                keys.push(/^key_/.test(this) ? this.substring(4) : this)
            } else {
                if(namespace) {
                    namespace += "." + this
                } else {
                    namespace = this
                }
            }
        })
        if(keys.length == 0) {
            return;
        }
        handleObj.namespace = namespace
        handleObj.handler = function( event ) {
            if ( this !== event.target && (/textarea|select/i.test( event.target.nodeName ) ||
                event.target.type === "text" || $(event.target).prop('contenteditable') == 'true' )) {
                return;
            }
            var special = $.hotkeys.specialKeys[ event.which || event.keyCode ], character = String.fromCharCode( event.which ).toLowerCase(), modif = "", possible = {};
            if ( event.altKey && special !== "alt" ) {
                modif += "alt_";
            }
            if ( event.ctrlKey && special !== "ctrl" ) {
                modif += "ctrl_";
            }
            if ( event.metaKey && !event.ctrlKey && special !== "meta" ) {
                modif += "meta_";
            }
            if ( event.shiftKey && special !== "shift" ) {
                modif += "shift_";
            }
            if ( special ) {
                possible[ modif + special ] = true;
            } else {
                possible[ modif + character ] = true;
                possible[ modif + $.hotkeys.shiftNums[ character ] ] = true;
                if ( modif === "shift_" ) {
                    possible[ $.hotkeys.shiftNums[ character ] ] = true;
                }
            }
            for ( var i = 0, l = keys.length; i < l; i++ ) {
                if ( possible[ keys[i] ] ) {
                    return origHandler.apply( this, arguments );
                }
            }
        };
    }
    $.each([ "keydown", "keyup", "keypress" ], function() {
        $.event.special[ this ] = { add: keyHandler };
    });
})();
; var CHECKERS = {
    /**
     * Milliseconds for a value the date picker wrote ("yyyy-MM-dd", with or without " HH:mm" / " HH:mm:ss"),
     * read as local time; NaN when it is none of those.
     */
    pickerDateTime: function (value) {
        var formats = ["yyyy-MM-dd HH:mm:ss", "yyyy-MM-dd HH:mm", "yyyy-MM-dd"];
        for (var i = 0; i < formats.length; i++) {
            var date = Date.parseFormatted($.trim(value || ""), formats[i]);
            if (date) {
                return date.getTime();
            }
        }
        return NaN;
    },
    validateByLength: function (value, rangeValue, type) {
        var status = true;
        if (!value) {
            return true;
        }
        switch (type) {
            case "range" :
                if (value < parseFloat(rangeValue[0], 10) || value > parseFloat(rangeValue[1], 10)) {
                    status = false;
                }
                break;
            case "max":
                if (value > parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "min":
                if (value < parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "multipleOf":
                if (value % parseInt(rangeValue[0], 10) != 0) {
                    status = false;
                }
                break;
            case "gt":
                if (value <= parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "gte":
                if (value < parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "lt":
                if (value >= parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "lte":
                if (value > parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "rangelength":
                var count = value.byteCount()
                if (count < parseFloat(rangeValue[0], 10) || count > parseFloat(rangeValue[1], 10)) {
                    status = false;
                }
                break;
            case "maxlength":
                if (value.byteCount() > parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "minlength":
                if (value.byteCount() < parseFloat(rangeValue[0], 10)) {
                    status = false;
                }
                break;
            case "default":
                status = false;
                break;
        }
        return status;
    },
    validateByCompare: function (value, compareWith, type, method) {
        var compareWithText = compareWith;
        var status = true;
        var msg_code;
        var alphabetToDecimal = function (target) {
            var res = 0;
            target = target.split('').reverse().join('');
            for (var i = target.length - 1; i >= 0; i--) {
                res += Math.pow(26, i) * (target.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
            }
            return res;
        };
        var decimalToAlphabet = function (target) {
            var res = "";
            while (target > 0) {
                target--;
                var rem = target % 26;
                res = String.fromCharCode(rem + 'A'.charCodeAt(0)) + res;
                target = (target - rem) / 26;
            }
            return res;
        };
        if (type == "number") {
            if (value.length > 16 || compareWith.length > 16) {
                return {msg_template: $.i18n.prop('num.of.digits.less.than.n', [16])}
            }
            value = parseFloat(value, 10);
            compareWith = parseFloat(compareWith, 10);
        } else if (type === "date") {
            value = CHECKERS.pickerDateTime(value);
            compareWith = CHECKERS.pickerDateTime(compareWith);
        } else if (type == "alphabetic") {
            compareWithText = decimalToAlphabet(compareWith);
            value = alphabetToDecimal(value);
        }
        var parsedMethod = method.split(" ")[0]
        switch (parsedMethod) {
            case "gt":
                if (value <= compareWith) {
                    status = false;
                    msg_code = "value.must.greater";
                }
                break;
            case "gte":
                if (value < compareWith) {
                    status = false;
                    msg_code = "value.must.greater.equal";
                }
                break;
            case "diff":
                var parsedMethodValue = method.split(" ")[1]
                var diffMinMax = value - compareWith
                if(parsedMethodValue){
                    var parsedIntValue = parseInt(parsedMethodValue)
                    if (value < compareWith) {
                        status = false;
                        msg_code = "value.must.greater.equal";
                        var lessValue = diffMinMax;
                        compareWithText = value + lessValue
                    }
                }
                break;
            case "eq":
                if (value != compareWith) {
                    status = false;
                    msg_code = "value.must.equal";
                }
                break;
            case "confirmEmail":
                if (value != compareWith) {
                    status = false;
                    msg_code = "email.confirmation.does.not.match";
                }
                break;
            case "ne":
                if (value == compareWith) {
                    status = false;
                    msg_code = "value.must.not.equal";
                }
                break;
            case "nep":
                if (value == compareWith) {
                    status = false;
                    msg_code = "value.must.not.equal.pass";
                }
                break;
            case "lte":
                if (value > compareWith) {
                    status = false;
                    msg_code = "value.must.less.equal";
                }
                break;
            case "lt":
                if (value >= compareWith) {
                    status = false;
                    msg_code = "value.must.less";
                }
                break;
            case "mod":
                if (value % compareWith != 0) {
                    status = false;
                    msg_code = "value.must.multiple.of";
                }
                break;
            case "default":
                status = false;
                msg_code = "unsupported.comparison.type";
                break;
        }
        return status || {msg_template: msg_code, msg_params: [compareWithText]};
    },
    validateUrl: function(value) {
        return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)+)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value)
    },
    detectWhitespace: function(value) {
        return /^\S*$/i.test(value)
    }
}

var VALIDATION_RULES = {
    alphabetic: {
        check: function (value) {
            if (value)
                return /^[a-zA-Z ]+$/.test(value);
            return true;
        },
        msg_template: "enter.valid.alphabetic"
    },
    alphanumeric: {
        check: function (value) {
            if (value)
                return /^[a-zA-Z0-9]+$/.test(value);
            return true;
        },
        msg_template: "enter.valid.alphanumeric"
    },
    cardnumber: {
        check: function (value, ranges) {
            value = $.trim(value);
            var regex = {
                visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
                master: /^5[1-5][0-9]{14}$/,
                diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
                unionpay: /^(62|88)\d+$/,
                amex: /^3[47][0-9]{13}$/,
                custom: /^\d+$/
            }
            ranges = ranges.filter("this != ''")
            if (ranges.length == 0) {
                ranges = ["custom"]
            }
            var result = false
            for (var i = 0; i < ranges.length; i++) {
                if (regex[ranges[i].trim()].test(value)) {
                    result = true
                    break;
                }
            }
            return result
        },
        msg_template: "incorrect.card.number"
    },
    commaSeparated4digit: {
        check: function (value) {
            if (value)
                return /^[1-9]\d{0,3}(?:(?:,[1-9]\d{0,3})*)$/.test(value);
            return true;
        },
        msg_template: "enter.comma.seperated.four.digit.numeric"
    },
    compare: {
        check: function (value, ranges) {
            if (!value) {
                return true;
            }
            var validated = CHECKERS.validateByCompare(value, $("#" + ranges[0].trim()).val(), ranges[1].trim(), ranges[2].trim())
            if (validated !== true) {
                return {msg_template: validated.msg_template, msg_params: validated.msg_params};
            }
            return true
        }
    },
    eq: {
        check: function (value, params) {
            var compareWith = $("#" + params[0].trim()).val();
            if(compareWith && !value){
                return {msg_template: "field.required"}
            }
            if(value != compareWith) {
                return {msg_params: [compareWith]}
            }
            return true
        },
        msg_template: "value.must.equal"
    },
    creditCardExpiryDate: {
        check: function (value, ranges) {
            if (!value || !$("#" + ranges[0].trim()).val()) {
                return true;
            }
            var currentMonth = new Date().getMonth() + 1;
            var currentYear = new Date().getFullYear().toString().substring(2, 4);
            var inputMonth = value;
            var inputYear = $("#" + ranges[0].trim()).val();
            if (inputYear < currentYear || (inputMonth < currentMonth && inputYear <= currentYear)) {
                return {msg_template: "card.expired"};
            }
            return true;
        }
    },

    cardExpiryDate: {
        check: function (value, uniqueId) {
            if (value && value.contains("/")) {
                value = value.substring(0, 5);
            } else if(value){
                value = value.substring(0, 4);
            }
            value = value.split('/').join('');
            if(value.length > 0){
                value = value.match(/.{1,2}/g).join('/');
                $("#" + uniqueId).val(value)
            }
            value = value.split('/')
            var currentMonth = new Date().getMonth() + 1;
            var currentYear = new Date().getFullYear().toString().substring(2, 4);
            var inputMonth = value[0];
            if (inputMonth > 12 || inputMonth < 1) {
                return {msg_template: "invalid.month"};
            }
            var inputYear = value[1];
            if (inputYear < currentYear || (inputMonth < currentMonth && inputYear <= currentYear)) {
                return {msg_template: "card.expired"};
            }
            return true;
        }
    },

    anyCreditCardNumber: {
        response: function (isValid, value, uniqueId) {
            value = value.replace(/\D/g, "");
            value = value.replace(/(.{4})/g, "$1 ");
            value = value.trim();
            $("#" + uniqueId).val(value)
            return isValid
        },
        check: function (value, uniqueId) {
            value = value.split(' ').join('');
            if (/[^0-9-]+/.test(value))
                return this.response(false, value, uniqueId);
            var nCheck = 0,
                nDigit = 0,
                bEven = false;
            for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n);
                var nDigit = parseInt(cDigit, 10);
                if (bEven) {
                    if ((nDigit *= 2) > 9)
                        nDigit -= 9;
                }
                nCheck += nDigit;
                bEven = !bEven;
            }
            if ((nCheck % 10) == 0) {
                return this.response(true, value, uniqueId);
            }
            return this.response(false, value, uniqueId);
        },
        msg_template: "enter.valid.creditcard"
    },

    creditcard: {
        check: function (value) {
            if (/[^0-9-]+/.test(value))
                return false;
            var nCheck = 0,
                nDigit = 0,
                bEven = false;
            value = value.replace(/\D/g, "");
            for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n);
                var nDigit = parseInt(cDigit, 10);
                if (bEven) {
                    if ((nDigit *= 2) > 9)
                        nDigit -= 9;
                }
                nCheck += nDigit;
                bEven = !bEven;
            }
            if ((nCheck % 10) == 0)
                return true
            return false
        },
        msg_template: "enter.valid.creditcard"
    },
    cvv: {
        check: function (value) {
            if (value) {
                return value.length > 2 && value.length < 5 && /^\d+$/.test(value);
            }
            return true;
        },
        msg_template: "cvv.invalid"
    },
    date: {
        check: function (value, param) {
            if (!value) {
                return true;
            }
            var format = "yyyy-MM-dd";
            if (param) {
                format = param;
            }
            this.msg_params = [format];
            return !!Date.parseFormatted(value, format);
        },
        msg_template: "date.should.formatted"
    },
    digits: {
        check: function (value) {
            value = $.trim(value);
            if (value) {
                if (value.length > 16) {
                    this.msg_template = $.i18n.prop('num.of.digits.less.than.n', [16]);
                    return false;
                }
                return /^\d+$/.test(value);
            }
            return true;
        },
        msg_template: "only.digits.allowed"
    },
    either_required: {
        check: function (value, param) {
            var otherValue = $("#" + param[0]).val();
            if (value || otherValue)
                return true;
            else {
                this.msg_params = [param[1], param[2]];
                return false;
            }
        },
        msg_template: "either.required"
    },
    fax: {
        check: function (value, single) {
            if (value) {
                var faxPattern = "\\+?[0-9\\s\\-\\.()]{7,15}";
                var repeatFaxPattern = single ? faxPattern : (faxPattern + "(\\s*[;]\\s*" + faxPattern + ")*;?");
                return new RegExp("^\\s*" + repeatFaxPattern + "\\s*$").test(value);
            }
            return true;
        },
        msg_template: "enter.valid.fax"
    },

    email: {
        check: function (value, single) {
            if (value) {
                var emailPattern = "(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))";
                var withNamePattern = "[^<>,;]+\\s*<" + emailPattern + ">";
                var jointEmailPattern = "((" + emailPattern + ")|(" + withNamePattern + "))";
                var repeatJointEmailPattern = single ? jointEmailPattern : (jointEmailPattern + "([,;]\\s*" + jointEmailPattern + ")*;?");
                return new RegExp("^\\s*" + repeatJointEmailPattern + "\\s*$").test(value);
            }
            return true;
        },
        msg_template: "enter.valid.email"
    },
    single_email: {
        check: function (value) {
            if (value) {
                return VALIDATION_RULES.email.check(value, true);
            }
            return true;
        },
        msg_template: "enter.valid.email"
    },
    empty: {
        check: function (value) {
            if ($.trim(value)) {
                return false;
            } else {
                return true;
            }
        },
        msg_template: "field.must.empty"
    },
    eval: {
        check: function (value, param) {
            try {
                return eval(param[0]);
            } catch (k) {
                return false;
            }
        },
        msg_template: "entry.invalid"
    },
    "drop-file-required": {
        check: function (value, param, input) {
            if (value) {
                return true;
            }
            var name = input.attr("name")
            var form = input.closest("form");
            var fileData = form.data("form-extra-data");
            if (!fileData) {
                return false;
            }
            if (window.File) {
                if (fileData.value instanceof File && fileData.name == name) {
                    return true;
                }
                if ($.isArray(fileData)) {
                    var fileobj;
                    fileData.everyCustomFunc(function () {
                        if (this.value instanceof window.File && this.name == name) {
                            fileobj = this;
                            return false;
                        }
                    })
                    if (fileobj) {
                        return true;
                    }
                }
            }
            return false;
        },
        msg_template: "no.file.selected"
    },
    "function": {
        check: function (value, param, input) {
            try {
                return bm.prop(window, param[0]).call(input, value, VALIDATION_RULES["function"]);
            } catch (k) {
                return false;
            }
        },
        msg_template: "entry.invalid"
    },
    gt: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "gt");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.greater"
    },
    gte: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "gte");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.greater.equal"
    },
    lt: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "lt");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.less"
    },
    lte: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "lte");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.less.equal"
    },
    hexColor: {
        check: function (value) {
            value = $.trim(value);
            if (value)
                return /^#?[0-9a-fA-F]{6}$/.test(value);
        },
        msg_template: "invalid.hexadecimal.color"
    },
    // Like hexColor, but also accepts the short #RGB form (as the order-flag API does).
    hexColorShortOrLong: {
        check: function (value) {
            value = $.trim(value);
            if (value) {
                return /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);
            }
            return true;
        },
        msg_template: "invalid.hexadecimal.color"
    },
    hexDigit: {
        check: function (value) {
            value = $.trim(value);
            if (value) {
                return /[0-9a-fA-F]$/.test(value);
            } else {
                return true;
            }
        },
        msg_template: "invalid.hexadecimal.digit"
    },
    identifier: {
        check: function (value, param) {
            if (value) {
                if (param == "multi") {
                    return /^[a-zA-Z_][a-zA-Z_0-9]*(\s+[a-zA-Z_][a-zA-Z_0-9]*)*$/.test(value);
                }
                return /^[a-zA-Z_][a-zA-Z_0-9]*$/.test(value);
            }
            return true;
        },
        msg_template: "only.alphanumeric.underscore.supported"
    },
    least_selection: {
        check: function (x, y, field) {
            return !!field.find(":checked").length
        },
        msg_template: "least.option.must.select"
    },
    match: {
        /**
         * @param value
         * @param param supported format is - <regular expression>,<sample value> <br>
         *     <regular expression>
         *     <blockquote>Any regular expression that should be matched with input value</blockquote>
         *     <sample value>
         *     <blockquote>A sample value to display in error message</blockquote>
         *     N.B. - if any comma(,) be exist in sample or expression that must be enclosed within ( and ) <br>
         *     e.g. - for 1,2,3 - (1,2,3)
         */
        check: function (value, param) {
            if (value) {
                var exp = new RegExp(param[0]);
                if (!exp.test(value)) {
                    return {msg_template: "invalid.format.use.like", msg_params: [param[1]]};
                }
            }
            return true;
        }
    },
    max: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "max");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.less.equal"
    },
    maxlength: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "maxlength");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "enter.no.more.characters"
    },
    maxprecision: {
        check: function (value, param1) {
            var integer = param1.length == 1 ? undefined : param1[0]
            var floated = param1.length == 1 ? param1[0] : param1[1]
            var regex = new RegExp("^(\\+|-)?\\d" + (integer ? "{0," + integer + "}" : "*") + "(?:\\.\\d{0," + floated + "})?$")
            var msg_params
            if (integer) {
                this.msg_template = "maximum.number.precision.allowed"
                msg_params = [integer, floated]
            } else {
                this.msg_template = "maximum.precision.allowed"
                msg_params = [floated]
            }
            if (!regex.test(value)) {
                return {msg_params: msg_params};
            }
            return true;
        }
    },
    maxInteger: {
        check: function (value, maxInteger) {
            var regex = new RegExp("^(\\+|-)?\\d" + (maxInteger ? "{0," + maxInteger + "}" : "*") + "?$");
            var msg_params;
            this.msg_template = "maximum.integral.digits.allowed";
            msg_params = [maxInteger];
            if (!regex.test(value)) {
                return {msg_params: msg_params};
            }
            return true;
        }
    },
    price: {
        check: function (value) {
            if(VALIDATION_RULES.number.check.apply(this, [value, []])) {
                return VALIDATION_RULES.maxprecision.check.apply(this, [value, [9, +app.maxPricePrecision]]);
            } else {
                return {msg_template: "enter.valid.price"};
            }
        }
    },
    integer: {
        check: function (value) {
            return VALIDATION_RULES.maxInteger.check.apply(this, [value, 9]);
        }
    },
    min: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "min");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.greater.equal"
    },
    min_age: {
        check: function (value, param) {
            if (!value || value.trim() === '') {
                return true;
            }
            try {
                var dateParts = value.split('-');
                if (dateParts.length !== 3) {
                    return { msg_params: param };
                }
                var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                var today = new Date();
                var age = today.getFullYear() - birthDate.getFullYear();
                var monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                var minAge = parseInt(param[0], 10);
                if (age < minAge) {
                    return { msg_params: param };
                }
                return true;
            } catch (e) {
                return { msg_params: param };
            }
        },
        msg_template: "you.need.to.be.x.years.old.to.register"
    },
    minlength: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "minlength");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "enter.least.characters"
    },
    multipleOf: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "multipleOf");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.multiple.of"
    },
    number: {
        check: function (value) {
            value = $.trim(value);
            if (value) {
                return /^(\+|-)?\d*(?:\.\d+)?$/.test(value);
            }
            return true;
        },
        msg_template: "enter.valid.number"
    },
    percent_number: {
        check: function (value) {
            value = $.trim(value);
            if (value == "%") {
                return false
            } else if (value) {
                return /^(\+|-)?\d*(?:\.\d+)?%?$/.test(value);
            }
            return true;
        },
        msg_template: "enter.valid.number"
    },
    partial_url: {
        check: function (value) {
            value = $.trim(value);
            if (value)
                return /^(((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)+)(:\d*)?))?(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value)
            return true;
        },
        msg_template: "enter.valid.url"
    },
    phone: {
        check: function (value) {
            value = $.trim(value);
            if (value)
                return /^\+?[0-9\(\)\-\.\s]+$/.test(value);
            return true;
        },
        msg_template: "phone.invalid"
    },
    postCode: {
        check: function (value) {
            value = $.trim(value);
            if (value.length > 10) {
                return false
            } else if (value)
                return /^\+?[0-9\-\A-z\s]+$/.test(value);
            return true;
        },
        msg_template: "post.code.invalid"
    },
    range: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "range");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.between"
    },
    rangelength: {
        check: function (value, param) {
            var message = CHECKERS.validateByLength(value, param, "rangelength");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "value.must.length.between"
    },
    required: {
        check: function (value, param) {
            if ($.trim(value)) {
                return true;
            } else {
                return false;
            }
        },
      msg_template: "field.required"
    },
    checked: {
        check: function (value, param, field) {
            return !!(field && field.is(":checked"));
        },
        msg_template: "field.required"
    },
    noSpace: {
        check: function (value) {
            if (value && !CHECKERS.detectWhitespace(value)) {
                return false;
            }
            return true;
        },
        msg_template: "please.remove.whitespace"
    },
    skuLength: {
        check: function (value, param = [100]) {
            var message = CHECKERS.validateByLength(value, param, "maxlength");
            if (message !== true) {
                return {msg_params: param};
            }
            return true;
        },
        msg_template: "enter.no.more.characters"
    },
    required_2: {
        check: function (value, param) {
            if ($.trim(value)) {
                return true;
            } else {
                if(param){
                    return {msg_params: param}
                }
                return false;
            }
        },
        msg_template: "field.is.required"
    },
    password: {
        check: function (value, param) {
            if (value) {
                return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{}|\\:',./<>?])[A-Za-z\d!@#$%^&*()_+=[\]{}|\\:',./<>?]{8,}$/.test(value);
            }
            return true
        },
      msg_template: "password.strength.msg"
    },
    restricted_chars: {
        check: function (value, param) {
            var index = 0;
            if (value) {
                $.each(param, function () {
                    index = value.indexOf(this);
                    if (index > -1) {
                        return false;
                    }
                });
                if (index > -1) {
                    return {msg_params: [param.join(",")]};
                }
            }
            return true;
        },
        msg_template: "characters.not.supported"
    },
    url: {
        check: function (value) {
            value = $.trim(value);
            if(value && value === '#'){
                return true;
            }
            if (value) {
                return /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)+)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value)
            }
            return true;
        },
        msg_template: "enter.valid.url"
    },
    site_base_url: {
        check: function (value) {
            if(value && value === '#'){
                return true;
            }
            if (value) {
                if(!CHECKERS.detectWhitespace(value)) {
                    return {msg_template: "please.remove.whitespace.from.url"}
                } else if(!CHECKERS.validateUrl(value)) {
                    return {msg_template: "enter.valid.url"}
                }
            }
            return true;
        }
    },
    user_name: {
        check: function (value) {
            if (value) {
                return value.match(/^[A-Za-z][A-Za-z0-9_]{5,29}$/) != null
            }
            return true
        },
        msg_template: "enter.valid.user.name"
    },
    alias_name: {
        check: function (value) {
            if (value) {
                return /^(?!:\/\/)([a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(value);
            }
            return true
        },
        msg_template: "enter.valid.domain.name"
    },
    domain_name: {
        check: function (value) {
            if (value) {
                return value.match(/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/) != null
            }
            return true
        },
        msg_template: "enter.valid.domain.name"
    },
    url_folder: {
        check: function (value) {
            if (value) {
                return /^(([a-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+$/i.test(value);
            }
            return true;
        },
        msg_template: "enter.valid.url.path"
    },
    file_name_temp: {
        check: function (value) {
            if (value) {
                return /^(([a-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+$/i.test(value);
            }
            return true;
        },
        msg_template: "enter.valid.file.name"
    },
    non_symbolic: {
        check: function (value) {
            if (value) {
                return /^( *[a-zA-Z0-9\-_]+)+$/.test(value);
            }
            return true;
        },
        msg_template: "enter.valid.non.symbolic"
    },
    alphanumeric_and_underscore: {
        check: function (value) {
            if (value) {
                return /^[a-zA-Z0-9+_]*$/.test(value);
            }
            return true;
        },
        msg_template: "enter.valid.format"
    },
    // special rule to skip further processing
    skip: {},
    // special rule to skip next rule processing
    skip_next: {},
    // special rule to skip further processing if any condition is false
    check: {},
    // special rule to skip next rule processing if any condition is false
    check_next: {},
    // special to always fail
    fail: {}
}

var ValidationRule = (function () {
    function fetchParam(str, index) {
        var skip = true;
        var terminate = index;
        while (skip) {
            terminate = str.indexOf("]", terminate);
            if (terminate == -1) {
                throw Error("No Param Terminator ']'");
            }
            skip = str.charAt(terminate + 1) == "]";
            if (skip) {
                terminate += 2
            }
        }
        return str.substring(index, terminate);
    }

    function fetchIfOrNot(str, index) {
        var returnMap = {condition: {}};
        var condition_char = str.charAt(index)
        if (condition_char == 'i') {
            returnMap.condition.type = "if";
            index += 3;
        } else if (condition_char == 'v') {
            returnMap.condition.type = "if";
            returnMap.parsedIndex = index + 6;
            returnMap.condition.check_type = "self";
            returnMap.condition.selector = ":visible";
            return returnMap;
        } else if (condition_char == 'h') {
            returnMap.condition.type = "if";
            returnMap.parsedIndex = index + 5;
            returnMap.condition.check_type = "self";
            returnMap.condition.selector = ":hidden";
            return returnMap;
        } else {
            returnMap.condition.type = "not";
            index += 4;
        }

        var right;
        if (str.charAt(index) == 'g') {
            index += 7;
            right = str.indexOf("}", index);
            if (right == -1) {
                throw Error("Invalid Rule Format/Name");
            }
            returnMap.condition.check_type = "global";
            returnMap.condition.selector = str.substring(index, right);
        } else if (str.charAt(index) == 't') {
            index += 5;
            right = str.indexOf("}", index);
            if (right == -1) {
                throw Error("Invalid Rule Format/Name");
            }
            returnMap.condition.check_type = "this";
            returnMap.condition.selector = str.substring(index, right);
        } else if (str.charAt(index) == 's') {
            index += 5;
            right = str.indexOf("}", index);
            if (right == -1) {
                throw Error("Invalid Rule Format/Name");
            }
            returnMap.condition.check_type = "self";
            returnMap.condition.selector = str.substring(index, right);
        } else {
            returnMap.condition.check_type = "rule";
            index += 5;
            var right = str.indexOf("}", index + 1);
            var lbra = str.indexOf("{", index + 1);
            while (right != -1 && (lbra != -1 && lbra < right)) {
                right = str.indexOf("}", right + 1);
                lbra = str.indexOf("{", lbra + 1);
            }
            if (right == -1) {
                throw Error("Invalid Rule Format/Name");
            }
            var validRuleString = str.substring(index, right);
            returnMap.condition.rules = ValidationRule.createRules(validRuleString);
        }
        returnMap.parsedIndex = right;
        return returnMap;
    }

    return {
        addRule: function (name, rule) {
            VALIDATION_RULES[name] = rule;
        },
        getRule: function (name) {
            return VALIDATION_RULES[name];
        },
        createRules: function (str, startFrom) {
            startFrom = startFrom || 0;
            var len = str.length;
            if (startFrom >= len) {
                return [];
            }
            var space = str.indexOf(" ", startFrom);
            if (space == -1) {
                space = len;
            }
            var openBracket = str.indexOf("[", startFrom);
            if (openBracket == -1) {
                openBracket = len;
            }
            var at = str.indexOf("@", startFrom);
            if (at == -1) {
                at = len;
            }
            var closeBrace = str.indexOf("}", startFrom);
            if (closeBrace == -1) {
                closeBrace = len;
            }
            var startBrace = str.indexOf("{", startFrom);
            if (startBrace == -1) {
                startBrace = len;
            }
            var name = str.substring(startFrom, Math.min(openBracket, at, space, closeBrace, startBrace));
            if (name == "") {
                return ValidationRule.createRules(str, startFrom + 1);
            }
            var rule = VALIDATION_RULES[name];
            if (rule == null) {
                throw Error("Invalid Rule Format/Name");
            }
            var v_rules = [];
            var rule = {rule: rule};
            v_rules.push(rule);
            var cursor = startFrom + name.length;

            var fetchAllCondition = function () {
                while (str.charAt(at) == "@") {
                    var ifornot = fetchIfOrNot(str, at + 1);
                    if (!rule.condition) {
                        rule.condition = ifornot.condition;
                    } else if ($.isArray(rule.condition)) {
                        rule.condition.push(ifornot.condition);
                    } else {
                        rule.condition = [rule.condition, ifornot.condition]
                    }
                    at = ifornot.parsedIndex + 1;
                }
                cursor = at;
            }

            if (cursor == openBracket && openBracket != len) {
                var param = fetchParam(str, openBracket + 1);
                cursor += param.length + 2;
                rule.param = param.replace(/\]\]/g, "]").exSplit();
                if (at == cursor && openBracket != len) {
                    fetchAllCondition();
                }
            } else if (at == cursor && startBrace != len) {
                fetchAllCondition();
            }

            if (cursor != len && str.charAt(cursor) == " ") {
                var hrules = ValidationRule.createRules(str, cursor + 1);
                $.each(hrules, function () {
                    v_rules.push(this);
                })
            }
            return v_rules;
        }
    }
})();

(function () {
    var DEFAULTS = {
        validate_on: { //blur, change, immediate, keyup, keydown
            text: ["blur"],
            password: ["blur"],
            select: ["change"],
            radio: ["change"],
            file: ["change"],
            checkbox: ["change"],
            container: ["change"]
        },
        validate_on_call_only: false,
        clear_on_focus: true,
        show_error: true,
        attribute_name: "validation",
        error_class: "validation-error",
        re_init_on_valid: false,
        error_position: "after", //before, after, parent-after, parent-before, positioned-up, positioned-below, positioned-right
        error_parent_ref_class: undefined,
        show_error_close: true,
        error_template: "<div class='errorlist'><span class='pointer'></span><span class='close-btn'></span><div class='animated fadeIn message-block message-text'></div></div>",
        displayError: undefined //override of defined showError method
    }

    var instance_counter = 0;

    function checkValidators(field, validators) {
        var len = validators.length;
        var error = null;

        for (var type = 0; type < len; type++) {
            var validator = validators[type];
            if (typeof validator.error != "undefined") {
                return validator.error;
            }
            var check = true;
            if (validator.condition) {
                var conditions = $.isArray(validator.condition) ? validator.condition : [validator.condition];
                var condCount = conditions.length;
                for (var p = condCount - 1; p > -1; p--) {
                    var pass = true;
                    var condition = conditions[p];
                    switch (condition.check_type) {
                        case "global":
                            if ($(condition.selector).length == 0) {
                                pass = false;
                            }
                            break;
                        case "self":
                            if (condition.selector == ":blank") {
                                var val = field.val();
                                pass = $.trim(val) == "";
                            } else {
                                pass = field.is(condition.selector);
                            }
                            break;
                        case "this":
                            pass = field.find(condition.selector).length != 0
                            break;
                        case "rule":
                            pass = checkValidators(field, condition.rules) == null;
                    }
                    if ((condition.type == "if" && !pass) || (condition.type == "not" && pass)) {
                        check = false;
                        break;
                    }
                }
            }
            var rule = validator.rule;
            if (rule == VALIDATION_RULES.skip) {
                if (check) {
                    break;
                } else {
                    continue;
                }
            }
            if (rule == VALIDATION_RULES.skip_next) {
                if (check) {
                    type++;
                }
                continue;
            }
            if (rule == VALIDATION_RULES.check) {
                if (check) {
                    continue;
                } else {
                    break;
                }
            }
            if (rule == VALIDATION_RULES.check_next) {
                if (!check) {
                    type++;
                }
                continue;
            }
            if (rule == VALIDATION_RULES.fail) {
                if (check) {
                    var params = field.attr("message_params_" + type) || field.attr("message_params");
                    if (params) {
                        params = params.split(" ")
                    }
                    return {
                        msg_template: field.attr("message_template_" + type) || field.attr("message_template") || "entry.invalid",
                        msg_params: params || [],
                        rule: rule
                    };
                } else {
                    continue;
                }
            }

            if (check) {
                var param = validator.param;
                var isvalid = rule.check(field.val(), param, field);
                if (isvalid !== true) {
                    var template = field.attr("message_template_" + type) || field.attr("message_template")
                    if(validator.rule["msg_template"] == "field.required" && field.attr("required-validation-message")){
                        template = field.attr("required-validation-message");
                    }

                    if (!template) {
                        template = isvalid.msg_template || rule.msg_template;
                    }
                    if (!template) {
                        template = "";
                    }

                    var msgParams = field.attr("message_params_" + type) || field.attr("message_params");
                    if (!msgParams) {
                        msgParams = isvalid.msg_params || rule.msg_params;
                    } else {
                        msgParams = msgParams.exSplit(" ");
                    }
                    if (!msgParams) {
                        msgParams = [];
                    }

                    error = {
                        msg_template: template,
                        msg_params: msgParams,
                        rule: rule
                    }
                }
            }

            if (error != null) {
                break;
            }
        }

        return error;
    }

    /*
     * Panel factory
     */
    var Panel = function (panel/*$_Dom*/, options/*Object*/) {
        this.fields = [];
        this.elm = panel;
        this.instance_count = instance_counter++;
        var tagOptions = panel.config("validation")
        $.extend(true, this, DEFAULTS, tagOptions, options);
        this.attribute_name = tagOptions.attr || this.attribute_name;
        this.attach(panel.find("[" + this.attribute_name + "]"));
    };
    window.ValidationPanel = Panel;

    Panel.prototype = {
        attach: function (fields/*$_Dom*/, options/*Object*/) {
            var _panel = this;
            fields.each(function () {
                var _field = $(this);
                _field.on("jqclean", function () {
                    _panel.detach(_field)
                });
                var field = new Field(_field, _panel, options)
                _field.data("validator-filed-inst", field)
                _panel.fields.push(field);
            });
        },
        isValid: function () {
            $.each(this.fields, function () {
                this.validate();
            });
            var rtrn = true;
            $.each(this.fields, function () {
                if (!this.valid) {
                    rtrn = false;
                    return false;  // to break;
                }
            });
            return rtrn;
        },
        detach: function (elem) {
            if (elem.length) {
                elem = elem[0];
            }
            var rIndex = -1;
            $.each(this.fields, function (index) {
                if (this.elm[0] == elem) {
                    rIndex = index;
                    this.destroy();
                    return false;
                }
            });
            if (rIndex > -1) {
                this.fields.splice(rIndex, 1);
            }
        },
        getValidatorRules: function (elem) {
            if (elem.length) {
                elem = elem[0];
            }
            var returnData;
            $.each(this.fields, function () {
                if (this.elm[0] == elem) {
                    returnData = this.validatorRules;
                    return false;
                }
            });
            return returnData;
        },
        addValidatorRule: function (elem, ruleString, message) {
            if (elem.length) {
                elem = elem[0];
            }
            var found = false;
            $.each(this.fields, function () {
                if (this.elm[0] == elem) {
                    var rules;
                    if (typeof ruleString == "string") {
                        rules = ValidationRule.createRules(ruleString);
                    } else {
                        rules = [{rule: {check: ruleString, msg_template: message}}];
                    }
                    var tt_ = this;
                    $.each(rules, function () {
                        tt_.validatorRules.push(this);
                    });
                    found = true;
                    return false;
                }
            })
            if (!found) {
                this.attach($(elem), this);
            }
        },
        destroy: function () {
            $.each(this.fields, function () {
                this.destroy();
            })
            this.fields = [];
        },
        reInit: function () {
            this.destroy();
            this.attach(this.elm.find("[" + this.attribute_name + "]"), this);
        },
        position: function () {
            this.fields.each(function () {
                if (!this.valid) {
                    this.showError(this.error)
                }
            })
        },
        state: function () {
            return this.fields.collect("valid").all()
        }
    };

    /*
     * Field factory
     */
    var Field = function (field/*$_Dom*/, panel/*Object*/, options) {
        this.elm = field;
        var tagOptions = field.config("validation")
        this.options = $.extend(true, {}, bm.omit(panel, ["fields", "elm", "instance_count"], true), tagOptions, options);
        this.instance_count = instance_counter++;
        this.valid = true;
        if (this.options.displayError) {
            this.showError = this.options.displayError;
        }
        this.options.error_position = field.attr("error-position") || (panel.elm ? panel.elm.attr("error-position") : undefined) || this.options.error_position;
        this.options.validate_on_call_only = field.attr("validate-on") ? field.attr("validate-on") == "call-only" : (this.options.validate_on == "call-only" || this.options.validate_on_call_only);

        if (this.options.attribute_name) {
            var validation = field.attr(this.options.attribute_name);
            if ($.trim(validation) == "") {
                this.validatorRules = [];
            } else {
                try {
                    this.validatorRules = ValidationRule.createRules(validation);
                } catch (ex) {
                    this.validatorRules = [
                        {error: "invalid.rule.format.name"}
                    ];
                    return;
                }
            }
        } else {
            this.validatorRules = [];
        }

        if (!this.options.detached) {
            this.initEvents();
        }
    };

    window.ValidationField = {
        createDetachedField: function (field, options) {
            options = $.extend({detached: true}, options);
            return new Field(field, $.extend(true, {}, DEFAULTS, options));
        },
        validateAs: function (field/*$_Dom*/, ruleString/*String*/) {
            try {
                return checkValidators(field, ValidationRule.createRules(ruleString))
            } catch (ex) {
                return {
                    msg_template: $.i18n.prop("unable.validate"),
                    msg_params: [],
                    rule: undefined
                };
            }
        }
    };

    Field.prototype = {
        initEvents: function () {
            var field = this.elm;

            var evNamespace = ".validator_" + this.instance_count;
            field.off(evNamespace);
            var obj = this;
            field.on("validate" + evNamespace, function () {
                obj.validate();
            });

            if (!this.options.validate_on_call_only) {
                function bindEvent(field, evNamespace) {
                    var tagType;
                    if (field.is("select")) {
                        tagType = "select";
                    } else if (field.is("textarea")) {
                        tagType = "text";
                    } else if (field.is("[type='file']")) {
                        tagType = "file";
                    } else if (field.is("[type='text']")) {
                        tagType = "text";
                    } else if (field.is("[type='password']")) {
                        tagType = "password";
                    } else if (field.is("[type='radio']")) {
                        tagType = "radio";
                    } else if (field.is("[type='checkbox']")) {
                        tagType = "checkbox";
                    } else {
                        tagType = "container";
                    }
                    var evName = field.attr("validate-on")
                    if (evName) {
                        evName = evName.split(",");
                    } else {
                        evName = obj.options.validate_on[tagType];
                    }
                    if (!$.isArray(evName)) {
                        evName = [evName];
                    }
                    //blur, change, immediate, keyup, keydown
                    $.each(evName, function () {
                        switch ("" + this) {
                            case "immediate":
                                field.on("ichange" + evNamespace, function () {
                                    obj.validate();
                                });
                                break;
                            default:
                                field.on(this + evNamespace, function () {
                                    obj.validate();
                                });
                        }
                    });
                }

                bindEvent(field, evNamespace);
                var dependsOn = this.elm.attr("depends");
                if (dependsOn) {
                    dependsOn = $(dependsOn);
                    if (dependsOn.length) {
                        var id = field.attr("id");
                        if (!id) {
                            id = bm.getUUID();
                            field.attr("id", id);
                        }
                        var evNamespace = ".validator_" + this.instance_count + "_" + id;
                        field.off(evNamespace);
                        bindEvent(dependsOn, evNamespace)
                    }
                }
            }

            if (this.options.clear_on_focus) {
                field.bind("focus" + evNamespace, function () {
                    obj.clear();
                });
            }
        },
        validate: function () {
            var obj = this,
                field = obj.elm;
            var validators = obj.validatorRules;
            if (!validators) {
                return true;
            }
            obj.clear();

            function sendError(error) {
                obj.valid = false;
                obj.error = error;
                error.validator = obj;
                var proceed = obj.elm.trigger("invalid", error);
                if (proceed === false) {
                    return;
                }
                if (obj.options.show_error) {
                    obj.showError(error);
                }
            }

            try {
                var error = checkValidators(field, validators);
                if (error != null) {
                    sendError(error);
                } else {
                    obj.valid = true;
                    obj.elm.trigger("valid");
                }
            } catch (k) {
                sendError({
                    msg_template: k.message,
                    msg_params: [],
                    rule: undefined
                })
            }

            return obj.valid
        },
        clear: function () {
            if (!this.errorBlock) {
                return;
            }
            var errorOn = this.elm.removeClass(this.options.error_class).attr("error-on");
            if (errorOn) {
                errorOn = $("#" + errorOn);
                errorOn.removeClass(this.options.error_class);
            } else {
                errorOn = this.elm
            }
            if (this.options.error_position == "inline") {
                var inlineErrorOn = errorOn
                if (errorOn.find(".inline-error-target").length) {
                    inlineErrorOn = errorOn.find(".inline-error-target")
                }
                if (inlineErrorOn.attr("type") == "password") {
                    var cloned = errorOn[0].inlineErrorProxy
                    if (cloned) {
                        cloned.remove()
                        delete errorOn[0].inlineErrorProxy
                    }
                    errorOn.css("visibility", "visible")
                } else {
                    var cache = inlineErrorOn.attr("value-cache");
                    inlineErrorOn.val(cache);
                    inlineErrorOn.removeAttr("value-cache");
                }
            }
            var otherErrors = this.errorBlock.siblings(".message-block");
            if (!otherErrors.length) {
                this.errorBlock.closest(".errorlist").remove();
                this.elm.removeClass("error-field-error")
            } else {
                this.errorBlock.remove();
            }
            this.errorBlock = null;
            this.elm.trigger("clear-error");
        },
        destroy: function () {
            this.clear();
            this.elm.off(".validator_" + this.instance_count);
        },
        showError: function (error) {
            var errorlist
            if (this.errorBlock) {
                this.clear();
            }
            if (typeof this.options.error_template == "function") {
                errorlist = this.options.error_template.call(this, error);
            } else {
                errorlist = $(this.options.error_template);
            }
            this.elm.addClass("error-field-error");
            var errorOn = this.elm.addClass(this.options.error_class).attr("error-on");
            if (errorOn) {
                errorOn = $("#" + errorOn);
                errorOn.addClass(this.options.error_class);
            } else {
                errorOn = this.elm;
            }
            var errorBlock = errorlist.find(".message-block");
            var messageBlock = errorBlock.is(".message-text") ? errorBlock : errorBlock.find(".message-text");
            messageBlock.append($.i18n.prop(error.msg_template, error.msg_params));
            //after, before, parent-after, parent-before, positioned-up, positioned-below, positioned-right
            errorlist.addClass(this.options.error_position);
            errorOn.closest(".form-row").find(".errorlist").remove()
            switch (this.options.error_position) {
                case "inline":
                    if (errorOn.find(".inline-error-target").length) {
                        errorOn = errorOn.find(".inline-error-target")
                    }
                    if (errorOn.attr("type") == "password") {
                        var cloned = errorOn.clone()
                        cloned.attr("type", "text")
                        errorOn.after(cloned)
                        cloned.val(messageBlock.text()).addClass("inline-error")
                        cloned.focus(function () {
                            cloned.remove()
                            errorOn.css("visibility", "visible")[0].focus()
                            delete errorOn[0].inlineErrorProxy
                        }).css({position: "absolute"}).offset(errorOn.offset())
                        errorOn.css("visibility", "hidden")
                        errorOn[0].inlineErrorProxy = cloned
                    } else {
                        var valueCache = errorOn.val();
                        errorOn.val(messageBlock.text()).addClass("inline-error");
                        errorOn.attr("value-cache", valueCache);
                    }
                    break;
                case "after":
                    var nextDiv = errorOn.next(".errorlist");
                    if (nextDiv.length) {
                        nextDiv.remove()
                        errorOn.after(errorlist);
                    } else {
                        errorOn.after(errorlist);
                    }
                    break;
                case "before":
                    var prevDiv = errorOn.prev(".errorlist");
                    if (prevDiv.length) {
                        prevDiv.find(".message-block:last").after(errorBlock)
                    } else {
                        errorOn.before(errorlist);
                    }
                    break;
                case "parent-after":
                    var parentDiv;
                    if (this.options.error_parent_ref_class) {
                        parentDiv = errorOn.closest("." + this.options.error_parent_ref_class);
                    } else {
                        parentDiv = errorOn.parent();
                    }
                    var prevDiv = parentDiv.next(".errorlist");
                    if (prevDiv.length) {
                        prevDiv.find(".message-block:last").after(errorBlock)
                    } else {
                        parentDiv.after(errorlist);
                    }
                    break;
                case "parent-before":
                    var parentDiv;
                    if (this.options.error_parent_ref_class) {
                        parentDiv = errorOn.closest("." + this.options.error_parent_ref_class);
                    } else {
                        parentDiv = errorOn.parent();
                    }
                    var prevDiv = parentDiv.prev(".errorlist");
                    if (prevDiv.length) {
                        prevDiv.find(".message-block:last").after(errorBlock)
                    } else {
                        parentDiv.before(errorlist);
                    }
                    break;
                case "none":
                    break;
                default:
                    errorlist.addClass("positioned-error");
                    var position = this.options.error_position.substring(11);
                    var nextDiv = errorOn.next(".errorlist");
                    if (nextDiv.length) {
                        nextDiv.find(".message-block:last").after(errorBlock)
                    } else {
                        errorOn.after(errorlist);
                        nextDiv = errorlist;
                    }
                    switch (position) {
                        case "up":
                            nextDiv.position({
                                my: "left bottom",
                                at: "left+50 top-" + nextDiv.bottomRib(true, false, false),
                                of: errorOn,
                                collision: "none"
                            });
                            break;
                        case "below":
                            nextDiv.position({
                                my: "left top",
                                at: "left+50 bottom+" + nextDiv.topRib(true, false, false),
                                of: errorOn,
                                collision: "none"
                            });
                            break;
                        case "right":
                            nextDiv.position({
                                my: "left top",
                                at: "right+" + nextDiv.leftRib(true, false, false) + " top-" + nextDiv.outerHeight() * .33,
                                of: errorOn,
                                collision: "none"
                            });
                            break;
                        case "left":
                            nextDiv.position({
                                my: "right top",
                                at: "left-" + nextDiv.leftRib(true, false, false) + " top-" + nextDiv.outerHeight() * .33,
                                of: errorOn,
                                collision: "none"
                            });
                    }
            }
            this.errorBlock = errorBlock;
            if (this.options.show_error_close) {
                errorlist.find(".close-btn").click(function () {
                    errorlist.hide();
                })
            } else {
                errorlist.find(".close-btn").remove();
            }
        },
        isValid: function() {
            this.validate()
            return this.valid
        }
    };

    /*
     Validation extends by jQuery prototype
     */
    $.extend($.fn, {
        attachValidator: function (options) {
            return this.each(function () {
                var elm = $(this);
                var panel = new Panel(elm, options || {});
                elm.data("validator-inst", panel);
            });
        },
        valid: function (options) {
            var isValid = true;
            this.each(function () {
                var _self = $(this);
                var validator = _self.data("validator-inst") || _self.data("validator-filed-inst");
                if (!validator) {
                    _self.attachValidator(options || {});
                    validator = _self.data("validator-inst");
                } else if (typeof options == "string") {
                    return validator[options]()
                } else if (validator.re_init_on_valid) {
                    validator.reInit();
                }
                var _isValid = validator.isValid();
                isValid = isValid && _isValid;
            });
            return isValid;
        },
        clearValidator: function () {
            this.each(function () {
                var elm = $(this);
                var panel = elm.data("validator-inst");
                if (panel) {
                    panel.destroy();
                    elm.removeData("validator-inst")
                }
            });
        },
        updateValidator: function (options) {
            this.clearValidator();
            return this.attachValidator(options || {});
        },
        clearValidationMessage: function (options) {
            this.find('.errorlist').remove();
            this.find('.validation-error').removeClass("validation-error").removeClass("error-field-error");
        }
    });

    window.validation = {
        setDefaults: function (defaults) {
            $.extend(DEFAULTS, defaults, {validate_on: $.extend({}, DEFAULTS.validate_on, defaults.validate_on)});
        }
    }
})();
; // HWC-3847 popup motion engine — SYSTEM-WIDE on/off switch (admin + editor + site).
// Set false to restore legacy popup behavior everywhere; per-popup opt-out: no_transition: true.
if (window.WCUI_POPUP_TRANSITIONS === undefined) {
    window.WCUI_POPUP_TRANSITIONS = true;
}
// Popups carrying ANY of these classes (via the clazz option OR on the el itself) keep their
// full legacy behavior — they own their entrance/exit (toasts, anchored panels, slide drawers).
// To exempt another popup family, just add its class here.
if (window.WCUI_POPUP_NO_TRANSITION_CLASSES === undefined) {
    window.WCUI_POPUP_NO_TRANSITION_CLASSES = ["notification", "floating-panel-popup", "side-drawer", "fee-non-editor-popup", "flying-cart-content"];
}
// HWC-4777: docked panels and page-like shells stay visible when covered (see _concealCovered).
// Deliberately a separate list, NOT derived from WCUI_POPUP_NO_TRANSITION_CLASSES above: that one
// answers "does this family own its own entrance/exit?", this one answers "does it stay on screen
// when something covers it?". The same four families happen to answer yes to both today — keep
// them independent so either can change without dragging the other with it.
if (window.WCUI_POPUP_KEEP_COVERED_CLASSES === undefined) {
    window.WCUI_POPUP_KEEP_COVERED_CLASSES = ["notification", "floating-panel-popup", "side-drawer", "fee-non-editor-popup"];
}

// HWC-3847 popup motion engine styles — injected from JS (like utility.js license styles) so
// every surface bundling popup.js gets them; the pending rule is load-bearing, not decoration.
(function () {
    if (document.getElementById("wcui-popup-anim-style")) {
        return;
    }
    var style = document.createElement("style");
    style.id = "wcui-popup-anim-style";
    style.textContent = '' +
        // animate.css zoomIn replica; standalone `scale` since !important transforms beat transform keyframes.
        '@keyframes wcui-popup-enter { from { opacity: 0; scale: .5; } 50% { opacity: 1; } }' +
        // transition:none — left/top transitions would add a corner fly-in over the zoom.
        '.popup.wcui-popup-enter { animation: wcui-popup-enter .3s ease-out both; transition: none !important; }' +
        // Fade-only fallback for popups on exotic transforms (rotate/skew/pre-scaled).
        '@keyframes wcui-popup-fade { from { opacity: 0; } }' +
        '.popup.wcui-popup-enter-fade { animation: wcui-popup-fade .3s ease-out both; transition: none !important; }' +
        '@keyframes wcui-mask-fade { from { opacity: 0; } }' +
        '.popup-mask.wcui-mask-fade { animation: wcui-mask-fade .25s ease-out; }' +
        // wcui-popup-loader: the canonical wc-loader comet, in WHITE — this pending spinner sits on
        // the dark popup mask, so it uses the light (white) loader. Same element/markup; pure restyle.
        '.wcui-popup-loader { width: 36px; height: 36px; border-radius: 50%; box-sizing: border-box; ' +
            'display: inline-block; ' +
            'background: conic-gradient(from 0deg, transparent, #fff); ' +
            '-webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px)); ' +
            'mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px)); ' +
            'animation: wcui-popup-rotate 0.9s linear infinite; }' +
        // Halo keeps the ring readable over busy content — and, with the global design's white arc,
        // stops that half disappearing when the spinner lands on a light background.
        '.wcui-popup-pending-loader .wcui-popup-loader { filter: drop-shadow(0 2px 8px rgba(0,0,0,.35)); }' +
        '.wcui-popup-pending-loader { position: fixed; left: 50%; top: 50%; transform: translate(-50%, -50%); }' +
        // visibility beats the !important left/top some popup families force, and keeps layout measurable.
        '.popup.wcui-popup-pending, .popup.wcui-popup-pending * { visibility: hidden !important; transition: none !important; }' +
        // wcui- prefixed on purpose: this stylesheet is injected into document.head, so reusing the
        // global `rotate` / `prixClipFix` names (tempEditor.css:1190, :1195) would redefine those
        // animations for every other element on the page.
        '@keyframes wcui-popup-rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }' +
        '@keyframes wcui-popup-clip { ' +
            '0% { clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0); } ' +
            '50% { clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0); } ' +
            '75%, 100% { clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%); } }' +
        // No prefers-reduced-motion on purpose — the rest of the product ignores it too.
        '';
    document.head.appendChild(style);
})();

var POPUP_STATICS = {
    z_index: {
        active: 8000,
        modal_base: 3000,
        no_modal: 1000,
        always_up: 79990
    },
    active_stack: [],
    next_instance_identifier: 1,
    modal_mask: undefined,
    minimized_placeholder: undefined
};

var _popup_defaults = {
    clazz: '', //extra classes for popup
    minimized_clazz: '',  //TODO: yet to add support
    animation_clazz: '',
    closing_animation_clazz: '',
    closing_animation_duration: 300,
    show_title: true,
    title: null,
    minimized_title: null,  //TODO: yet to add support
    draggable: false,
    drag_handle: ".title-bar",
    drag_cancel: ":input",
    disable_text_selection: false,
    resizable: false,    //TODO: yet to add support
    maximizable: false,  //TODO: yet to add support
    minimizable: false,  //TODO: yet to add support
    modal: true,
    show_close: true,
    masking: true,
    // false = do not add the .inactive-mask dim to the popup this one covers (see setActive).
    dim_inactive: true,
    // false = keep the covered popup visible instead of hiding it (see _concealCovered).
    hide_inactive: true,
    do_not_change_active_stack: false,
    close_on_mask_click: false,
    close_on_blur: false,
    hide_on_blur: false,
    close_on_escape: true,
    auto_close: false,
    reset_close_timer_on_hover: true,
    width: "auto",
    max_width: null,
    height: "auto",
    top: null, //will supersede ui_position
    left: null, //will supersede ui_position
    ui_position: null,
    is_fixed: false,
    is_center: true,
    is_always_up: false,
    always_up_z_index: undefined,
    auto_active: true,
    auto_active_on_focus: true,
    ajax_url: undefined,
    ajax_caller: bm.ajax,
    ajax_settings: {},
    on_load_loader: true,
    no_transition: false, // HWC-3847: per-popup opt-out of the motion engine
    content: '',
    act_as_body: false,
    content_clazz: '', // extra class in content container
    template: '<div>\
        <div class="title-bar fee-identical-sewc-elm fee-popup__header">\
            <span class="title fee-identical-sewc-elm fee-popup__title title"></span>\
            <span class="window-corner-toolbar fee-identical-sewc-elm fee-popup__close">\
                <span class="minimize fee-identical-sewc-elm"  style="display: none">Min</span>\
                <span class="maximize fee-identical-sewc-elm">Max</span>\
                <span class="close fee-identical-sewc-elm"></span>\
            </span>\
        </div>\
        <div class="content fee-identical-sewc-elm fee-popup__body"></div>\
    </div>',
    minimized_content: '',        //TODO: yet to add support
    minimized_template: '<div class="fee-identical-sewc-elm">\
        <span class="title fee-identical-sewc-elm"></span>\
        <span class="content fee-identical-sewc-elm"></span>\
    </div>',                     //TODO: yet to add support
    parent: undefined,
    events: {
        beforeClose: undefined, //preventable
        close: undefined,
        beforeMinimize: undefined, //preventable
        minimize: undefined,
        beforeRestore: undefined, //preventable
        restore: undefined,
        maximize: undefined,
        beforeMaximize: undefined, //preventable
        render: undefined,
        beforeRender: undefined,
        beforeInactive: undefined,  //preventable
        inactive: undefined,
        beforeActive: undefined,
        active: undefined,
        content_loaded: undefined
    }
};

//props for internal use
/*
 * el, instance_identifier, z_index, childs, is_maximized, is_minimized, is_rendered, is_active, auto_close_timer, event_handlers, is_closed, is_hidden
 */

var POPUP = function (settings) {
    $.extend(this, _popup_defaults, settings);
    this.instance_identifier = POPUP_STATICS.next_instance_identifier++;
    this.z_index = this.is_always_up ? (this.always_up_z_index || POPUP_STATICS.z_index.always_up) : (this.modal ? (POPUP_STATICS.z_index.modal_base += 10) : POPUP_STATICS.z_index.no_modal);
    this.is_rendered = false;
    this.is_active = false;
    this._concealed_popup = null;
    this.event_handlers = $({});
    if (this.parent) {
        this.parent.addChild(this);
    }
    this.createPopup();
    this.render();
    this._observeResize();
    if(this.disable_background_scroll) {
        bm.disableBackgroundScroll();
    }
    if (this.auto_active) {
        this.setActive();
    }
};

var _p = POPUP.prototype;


// HWC-3847: gate for the popup motion engine. Flag-gated per surface (window.WCUI_POPUP_TRANSITIONS,
// currently set only by the FEE editor feature board). When ON, the engine also SUPERSEDES
// legacy animation_clazz/closing_animation_clazz (those play offscreen and never actually
// showed) so every popup gets the same open/close motion. Notifications and auto-close
// toasts keep their exact current behavior.
_p._transitionsEnabled = function () {
    return window.WCUI_POPUP_TRANSITIONS === true &&
        !this.no_transition &&
        !this.auto_close &&
        !this.act_as_body && // full-page panels (FEE Products/Orders/Settings pages) keep legacy behavior
        !this._hasNoTransitionClass();
};

// True when the popup carries any of the given classes — checked on the clazz option AND the
// element (families like side-drawer put their classes on the el only).
_p._hasClassFrom = function (classNames) {
    var names = classNames || [];
    for (var i = 0; i < names.length; i++) {
        if ((" " + (this.clazz || "") + " ").indexOf(" " + names[i] + " ") > -1 ||
            (this.el && this.el.hasClass && this.el.hasClass(names[i]))) {
            return true;
        }
    }
    return false;
};

_p._hasNoTransitionClass = function () {
    return this._hasClassFrom(window.WCUI_POPUP_NO_TRANSITION_CLASSES);
};

_p._keepsCoveredVisible = function () {
    return this._hasClassFrom(window.WCUI_POPUP_KEEP_COVERED_CLASSES);
};

// HWC-3847: one-shot entrance animation, applied right after first placement (element is placed
// synchronously pre-paint, so the keyframe is visible from the first painted frame).
_p._playEnter = function (force) {
    if ((this.is_rendered && !force) || !this._transitionsEnabled()) {
        return;
    }
    var _self = this;
    var tinfo = this._transformInfo();
    var enterClass = tinfo.zoomSafe ? "wcui-popup-enter" : "wcui-popup-enter-fade";
    var done = function () {
        _self.el.removeClass(enterClass).off("animationend.wcuiEnter");
        clearTimeout(_self._enter_timer);
    };
    // Kill any in-flight jQuery tween (position() can route through animate) and pin the
    // scale origin via an inline !important — stylesheet rules can't win.
    this.el.stop(true, true);
    if (tinfo.zoomSafe) {
        this._pinZoomOrigin(tinfo.tx, tinfo.ty);
    }
    this.el.addClass(enterClass);
    // animationend BUBBLES — a child's unrelated animation finishing would strip the enter
    // class mid-flight (popup then "pops" open). Only settle on OUR keyframe by name,
    // with a timeout fallback in case the event never fires.
    this.el.on("animationend.wcuiEnter", function (e) {
        var name = e.originalEvent && e.originalEvent.animationName;
        if (name === "wcui-popup-enter" || name === "wcui-popup-fade") {
            done();
        }
    });
    this._enter_timer = setTimeout(done, 600);
};

// HWC-3847: the zoom must converge on the CENTER OF THE SCREEN — popups are often not
// perfectly centered (oversized or offset), and a zoom anchored to the element's own
// center then reads as "coming from a corner". The standalone `scale` resolves its origin
// against the element's LAYOUT box (any transform translate is NOT part of it — verified
// empirically), so compensate with the translation to hit the visual screen center.
_p._pinZoomOrigin = function (tx, ty) {
    // Anchored popups (ui_position / explicit top-left / non-centered) must zoom from their
    // OWN center, not the screen's — a corner menu zooming toward mid-screen reads as broken.
    if (this.ui_position || this.top !== null || this.left !== null || !this.is_center) {
        return;
    }
    var rect = this.el[0].getBoundingClientRect();
    var originX = window.innerWidth / 2 - (rect.left - (tx || 0));
    var originY = window.innerHeight / 2 - (rect.top - (ty || 0));
    this.el[0].style.setProperty("transform-origin", originX + "px " + originY + "px", "important");
};

// Reads the element's computed transform translation (0,0 when none/identity) and whether
// the transform is zoom-safe. Pure translations (incl. the responsive translate(-50%,-50%)
// centering) are safe — the standalone `scale` keyframe composes over them. Anything that
// already scales/rotates gets the fade fallback.
_p._transformInfo = function () {
    var t = getComputedStyle(this.el[0]).transform;
    if (!t || t === "none") { return {tx: 0, ty: 0, zoomSafe: true}; }
    var m = t.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (!m) { return {tx: 0, ty: 0, zoomSafe: false}; }
    var v = m[1].split(",").map(parseFloat);
    var sx, sy, tx, ty;
    if (v.length === 6) { sx = v[0]; sy = v[3]; tx = v[4]; ty = v[5]; }
    else if (v.length === 16) { sx = v[0]; sy = v[5]; tx = v[12]; ty = v[13]; }
    else { return {tx: 0, ty: 0, zoomSafe: false}; }
    var pure = Math.abs(sx - 1) < .001 && Math.abs(sy - 1) < .001 && Math.abs(v[1]) < .001;
    return {tx: tx, ty: ty, zoomSafe: pure};
};

// Hide the popup frame and show the centered wcui-popup-loader spinner (above every open popup).
_p._showPendingLoader = function () {
    this.el.addClass("wcui-popup-pending");
    // The instance z_index property goes stale: setActive() bumps the ACTIVE popup's element to
    // POPUP_STATICS.z_index.active (8000) and mask CSS classes can raise masks further. Scan the
    // real computed z-index of every popup + mask in the DOM so the spinner always lands on top —
    // including popup-opened-from-popup stacks.
    var loaderZ = this.z_index + 1;
    $(".popup, .popup-mask, .inactive-mask").each(function () {
        var z = parseInt($(this).css("zIndex"), 10);
        if (!isNaN(z) && z + 1 > loaderZ) { loaderZ = z + 1; }
    });
    if (POPUP_STATICS.modal_mask) {
        var mz = parseInt(POPUP_STATICS.modal_mask.css("zIndex"), 10);
        if (!isNaN(mz) && mz + 1 > loaderZ) { loaderZ = mz + 1; }
    }
    this._pending_loader = $('<div class="wcui-popup-pending-loader"><span class="wcui-popup-loader"></span></div>')
        .css("zIndex", loaderZ).appendTo(document.body);
};

_p._removePendingLoader = function () {
    if (this._pending_loader) {
        this._pending_loader.remove();
        this._pending_loader = null;
    }
};

// HWC-3847: enter once every inner loading mask (.div-mask from bm.mask/.loader()) is gone,
// so popups whose content spawns secondary AJAX loads reveal at their FINAL size. Bounded by a
// timeout so a stuck mask can never keep the popup hidden.
_p._revealWhenSettled = function () {
    var _self = this;
    var started = Date.now();
    var cleanPasses = 0;
    var lastHeight = -1;
    (function check() {
        if (_self.is_closed) {
            _self._removePendingLoader();
            return;
        }
        var elapsed = Date.now() - started;
        var height = _self.el.outerHeight();
        // Secondary loads can start a beat AFTER content_loaded (paginators fire their first
        // table fetch async), so reveal only when ALL of these hold: a minimum settle window
        // has passed, no inner loading mask (.div-mask) is up, and the popup height has been
        // stable across consecutive passes. Hard-capped so nothing can keep the popup hidden.
        var settling = _self.el.find(".div-mask, .wc-loader-overlay").length > 0 ||
            _self.el.find("span.loader, .wc-loader").filter(function () { return this.offsetParent !== null || $(this).css("display") !== "none"; }).length > 0 ||
            height !== lastHeight;
        lastHeight = height;
        cleanPasses = settling ? 0 : cleanPasses + 1;
        if ((cleanPasses < 2 || elapsed < 350) && elapsed < 4000) {
            _self._settle_timer = setTimeout(check, 80);
            return;
        }
        // Snap to the final spot instantly — position() may route through jQuery animate
        // (the element can already be "on screen" position-wise), and a left/top tween
        // running under the scale keyframe reads as a slide-in from the side.
        _self.position();
        _self.el.stop(true, true);
        _self._removePendingLoader();
        _self.el.removeClass("wcui-popup-pending");
        _self._playEnter(true);
    })();
};

// HWC-3847: while visible, gently re-center after large content-driven size changes
// (covers callers that inject content themselves after creation). Position only — never height.
_p._observeResize = function () {
    if (!this._transitionsEnabled() || !this.is_center || typeof ResizeObserver === "undefined") {
        return;
    }
    var _self = this;
    var lastH = this.el.outerHeight();
    this._resize_observer = new ResizeObserver(function () {
        if (_self.is_closed || _self.is_hidden || _self._dragging || _self.el.hasClass("wcui-popup-pending")) {
            return;
        }
        var h = _self.el.outerHeight();
        if (Math.abs(h - lastH) < 40) {
            return;
        }
        lastH = h;
        clearTimeout(_self._resize_recenter_timer);
        _self._resize_recenter_timer = setTimeout(function () {
            if (!_self.is_closed && !_self.is_hidden && !_self._dragging) {
                _self.position();
            }
        }, 120);
    });
    this._resize_observer.observe(this.el[0]);
};

_p._teardownMotion = function () {
    this._removePendingLoader();
    // Never leave the element parked invisible or mid-animation — hide() mid-settle would
    // otherwise strand a visibility:hidden popup that show() can't recover.
    if (this.el) {
        this.el.removeClass("wcui-popup-pending wcui-popup-enter wcui-popup-enter-fade");
    }
    if (this._resize_observer) {
        this._resize_observer.disconnect();
        this._resize_observer = null;
    }
    clearTimeout(this._resize_recenter_timer);
    clearTimeout(this._settle_timer);
    clearTimeout(this._enter_timer);
};

_p.addChild = function (popup) {
    if (!this.childs) {
        this.childs = [];
    }
    this.childs.push(popup);
    var _self = this;
    popup.on("close", function () {
        var index = _self.childs.indexOf(this);
        _self.childs.splice(index, 1);
    });
};

_p.one = function (evName, handler) {
    this.event_handlers.one(evName, $.proxy(handler, this.el));
};

_p.on = function (evName, handler) {
    this.event_handlers.on(evName, $.proxy(handler, this.el));
};

_p.off = function (evName) {
    this.event_handlers.off(evName);
};

_p.trigger = function (evName, params) {
    if (!params) {
        params = [this];
    }
    var triggerReturn;
    if (this.events[evName]) {
        triggerReturn = this.events[evName].apply(this.el, params);
    }
    if (triggerReturn !== false) {
        triggerReturn = this.event_handlers.trigger(evName, params)
    }
    if (triggerReturn !== false) {
        return this.el.trigger("wcui-popup-" + evName, params)
    }
    return false;
};

_p.render = function () {
    this.trigger("beforeRender");
    this.setMask();
    this.setContent();
    this.bindEvents();
    this.trigger("render");
    this.is_rendered = true;
};

_p.createPopup = function () {
    this._el_provided = !!this.el;
    if (!this.el) {
        this.el = $(this.template);
    }
    if (this.content_clazz) {
        this.el.find('>.content').addClass(this.content_clazz);
    }
    this.el.css({
        position: this.is_fixed ? "fixed" : "absolute",
        left: this.left || -10000,
        top: this.top || -10000,
        width: this.width,
        maxWidth: this.max_width,
        height: this.height,
        zIndex: this.z_index,
        transform: this.is_transform ? this.transform : "",
    }).appendTo(this.parent ? this.parent.el : document.body);
    // Engine popups skip the legacy animation class — its transition rules would fight the
    // keyframes (and it never visibly played anyway: it ran while parked offscreen).
    this.el.addClass(this.clazz + " popup " + (this._transitionsEnabled() ? "" : this.animation_clazz));
    // Right-edge side-drawers (the Column Config / Advanced Search / filter panels on every FEE list
    // tab) all dock to the same region and are meant to be one-at-a-time. The active-stack otherwise
    // STACKS them: opening a second drawer inactivates the first (dimmed, left half-slid in the DOM via
    // setInactive) instead of closing it — and whether the first actually closes depends on its
    // close_on_blur flag, so the hide is inconsistent between panels. When one opens, close any other
    // that is already open so it slides out through the normal close() path. Scoped to
    // :not(.fee-side-drawer) to leave the wider custom drawer variant untouched.
    if (this.el.hasClass("side-drawer") && !this.el.hasClass("fee-side-drawer")) {
        var _openingDrawer = this.el[0];
        $(".side-drawer.popup").not(".fee-side-drawer").each(function () {
            if (this !== _openingDrawer) {
                try {
                    $(this).obj(POPUP).close();
                }
                catch (ignored) {
                }
            }
        });
    }
    if (!this.show_title) {
        if (this.show_close || this.maximizable || this.minimizable) {
            this.el.find(".title-bar").removeClass("title-bar").addClass("no-title-bar")
        } else {
            this.el.find(".title-bar").remove();
        }
    }
    if (!this.show_close) {
        this.el.find("span.close").remove();
    }
    if (!this.maximizable) {
        this.el.find("span.maximize").remove();
    }
    if (!this.minimizable) {
        this.el.find("span.minimize").remove();
    }
    if (this.show_title && this.title) {
        this.el.find(".title").html(this.title)
    }
    this.el.attr("id", "popup-" + this.instance_identifier);
    this.el.attr("tabindex", "-1");
    // Lets a caller resolve the owning instance from the DOM and close() it — the only teardown
    // that releases the shared modal mask — instead of removing the element.
    this.el.data("wcuiPopupInstance", this);
};

_p.setMask = function () {
    if (this.modal) {
        if (POPUP_STATICS.modal_mask) {
            POPUP_STATICS.modal_mask.remove();
        }
        POPUP_STATICS.modal_mask = $("<div></div>").appendTo(document.body);
        var classes = ["popup-mask"];
        this.clazz.split(" ").everyCustomFunc(function () {
            if ($.trim(this)) {
                classes.push(this + "-mask")
            }
        });
        if (this._transitionsEnabled()) {
            classes.push("wcui-mask-fade");
        }
        POPUP_STATICS.modal_mask.attr("class", classes.join(" ")).css({
            zIndex: this.z_index - 5
        }).show();
    }
};


_p.hideMask = function () {
    if (this.modal) {
        // POPUP_STATICS.modal_mask starts out undefined and setMask() only builds it for a modal
        // that actually went active — a modal torn down before that reaches here with no mask.
        if (!POPUP_STATICS.modal_mask) {
            return;
        }
        if (POPUP_STATICS.active_stack.count("this.modal && !this.is_hidden") >= 1) {
            POPUP_STATICS.modal_mask.hide();
            POPUP_STATICS.modal_mask.remove()
        }
    }
};

_p.setContent = function (content) {
    var _self = this;
    var contentContainer = this.el.find(".content:first");
    if (!contentContainer.length) {
        contentContainer = this.el;
    }
    if (content || !this.ajax_url) {
        content = content || this.content;
        if (content) {
            contentContainer.html(content);
        }
        // A manual setContent() while an AJAX load is pending supersedes it — clear the
        // pending state so the popup isn't stuck invisible behind a spinner.
        this._removePendingLoader();
        this.el.removeClass("wcui-popup-pending");
        this.position();
        // Hybrid popups (gallery "Change Album" etc.) open a shell and start their real load
        // from the content_loaded handler (popupEl.loader() + ajax). The inner loader/mask may
        // therefore only exist AFTER content_loaded runs — so hold the frame hidden, fire the
        // handlers, then check: still loading → central spinner + settle; done → enter now.
        if (this._transitionsEnabled() && !this._el_provided && !this.is_rendered) {
            this.el.addClass("wcui-popup-pending");
            try {
                _self.trigger("content_loaded");
            } catch (e) {
                // A throwing handler must never leave the popup stuck invisible.
                this._teardownMotion();
                throw e;
            }
            if (this.el.find(".loader, .div-mask, .wc-loader, .wc-loader-overlay").length) {
                this._showPendingLoader();
                this._revealWhenSettled();
                return;
            }
            this.el.removeClass("wcui-popup-pending");
            this._playEnter();
            return;
        }
        this._playEnter();
        _self.trigger("content_loaded")
    } else {
        function resetWidthHeight() {
            if (_self.width == "auto") {
                _self.el.width("auto")
            }
            if (_self.height == "auto") {
                _self.el.height("auto")
            }
        }

        this.el.addClass("ajax-loading");
        if (this.on_load_loader) {
            contentContainer.html('<span class="wc-loader wc-loader--center"></span>');
        }
        // HWC-3847 loader-first pattern: while content loads, show ONLY a centered spinner over
        // the mask — the popup frame stays offscreen and enters fully sized once content is
        // ready. No tiny shell, no visible resize. Skipped for caller-provided elements (el:).
        // Loader-first needs the loader — callers that set on_load_loader:false opted out of
        // loading visuals entirely and keep the legacy path.
        var _useMotion = this._transitionsEnabled() && !this._el_provided && !this.is_rendered && this.on_load_loader !== false;
        if (_useMotion) {
            this._showPendingLoader();
        } else if (!this.is_rendered) {
            var width = this.width;
            if (width == "auto") {
                width = 300;
            }
            var height = this.height;
            if (height == "auto") {
                height = 300;
            }
            this.position(undefined, width, height);
        }
        this.ajax_caller($.extend({
            url: this.ajax_url,
            dataType: "html",
            response: function () {
                _self.el.removeClass("ajax-loading");
            },
            success: function (content) {
                contentContainer.html(content);
                _self.trigger("ajax_loaded");
                resetWidthHeight();
                if (!_useMotion) {
                    _self.position();
                    _self.trigger("content_loaded");
                    return;
                }
                // HWC-3847 loader-first pattern: content_loaded handlers may kick off secondary
                // loads (e.g. selection popups fetch their table via bm.mask/.loader()). Keep the
                // central spinner up until those inner masks (.div-mask) settle, then enter once —
                // fully sized, in one animation.
                try {
                    _self.trigger("content_loaded");
                } catch (e) {
                    // A throwing handler must never leave the popup stuck invisible.
                    _self._teardownMotion();
                    throw e;
                }
                _self._revealWhenSettled();
            },
            error: function (xhr, shortid, message) {
                _self.el.removeClass("ajax-loading");
                _self._removePendingLoader();
                // A license block (feature-disabled / limit-exceeded) returns a 403 envelope. Don't dump that raw
                // JSON into the popup body — the global upgrade popup owns that UI (utility.js reads the
                // X-License-* headers / body). Detect the block, route it through the existing "ajax-submit-error"
                // contract so the P4/P3 popup fires (idempotent), and close this shell so it's the sole focus.
                if (window.__lvIsBlock && window.__lvIsBlock(xhr)) {
                    try { $(document).trigger("ajax-submit-error", [xhr, "error", xhr && xhr.responseText]); } catch (e) {}
                    try { _self.close(); } catch (e) {}
                    return;
                }
                _self.el.addClass("http-" + xhr.status + "-error");
                content = $("<div class='ajax-loading-error'></div>").append(message);
                contentContainer.html(content);
                // HWC-3847: under the loader-first pattern the frame was never placed — bring it
                // in now so the error is visible.
                if (_useMotion && !_self.is_closed) {
                    _self.position();
                    _self.el.removeClass("wcui-popup-pending");
                    _self._playEnter(true);
                }
                _self.trigger("content_loading_error")
            }
        }, this.ajax_settings))
    }
};

/**
 * used for apply position for POPUP in viewPort
 * @public
 */
_p.position = function (region, force_width, force_height) {
    var method = this.el.offset().left < -2000 ? "css" : "animate";
    if (region) {
        this.el[method](region)
    } else if (this.ui_position && !this.ui_position.auto && !this.left && !this.top) {
        var position = this.ui_position;
        var isFloating = !position.collision || position.collision === "none";
        if (!position.using) {
            var _self = this;
            if (isFloating) {
                var bodyHeight = $(document.body).outerHeight();
                var popHeight = _self.el.outerHeight();
                position = $.extend({}, position, {
                    using: function (css) {
                        if (css.top + popHeight > bodyHeight && position.my && position.my.indexOf("top") > -1) {
                            var flipped = $.extend({}, _self.ui_position);
                            flipped.my = flipped.my.replace("top", "bottom");
                            flipped.at = flipped.at.replace(/bottom([+-]\d+)?/, function(m, offset) {
                                if (offset) {
                                    return "top" + (offset.charAt(0) === "+" ? "-" : "+") + offset.substring(1);
                                }
                                return "top";
                            });
                            delete flipped.using;
                            _self.el.position(flipped);
                        } else {
                            _self.el.css(css);
                        }
                    }
                });
            } else if (method == "animate") {
                position = $.extend({}, position, {
                    using: function (css) {
                        _self.el.animate(css)
                    }
                });
            }
        }
        this.el.position(position);
    } else if (this.is_center) {
        var scrHeight = $(window).height();
        var scrWidth = $(window).width();
        var popHeight = force_height || this.el.outerHeight();
        var popWidth = force_width || this.el.outerWidth();
        var left = this.left || (scrWidth / 2 - popWidth / 2);
        var top = this.top || (scrHeight / 2 - popHeight / 2);
        if (!this.is_fixed) {
            var scrollTop = $(window).scrollTop();
            var scrollLeft = $(window).scrollLeft();
            left = left + scrollLeft;
            top = top + scrollTop
        }
        var position = {
            left: Math.max(20, left),
            top: Math.max(20, top)
        };
        if (this.adjust_popup_height_width_content) {
            position.width = popWidth ? popWidth : this.width
            position.height = popHeight ? popHeight : this.height
        }
        if (force_width) {
            position.width = force_width;
        }
        if (force_height) {
            position.height = force_height;
        }
        this.el[method](position)
    } else {
        this.el[method]({
            left: this.left || 100,
            top: this.top || 100,
            width: force_width || this.width,
            height: force_height || this.height
        })
    }
};

_p.setActive = function () {
    if (this.is_active) {
        return;
    }

    if(!this.el.prev().length){
        return;
    }

    var _self = this;
    if (POPUP_STATICS.active_stack.length > 0) {
        var veto = true;
        var coveredPopup = POPUP_STATICS.active_stack[POPUP_STATICS.active_stack.length - 1];
        if (this.masking && !this.do_not_change_active_stack) {
            veto = coveredPopup.setInactive();
        }
        if (veto === false) {
            return;
        }
        // HWC-4202: a confirm is a question ABOUT the popup underneath, not a new working
        // surface on top of it. setInactive() gives that popup its own .inactive-mask, which
        // compounds with the shared modal mask this one is about to lay over everything —
        // rgba(48,50,51,.6) under black .4 leaves it far darker than the page behind it. Drop
        // the inner dim for those dialogs only; ordinary stacked popups keep it.
        if (this.dim_inactive === false) {
            coveredPopup.el.children(".inactive-mask").hide();
        }
        this._concealCovered(coveredPopup);
    }
    this.trigger("beforeActive");
    this.el.find(".inactive-mask").hide();
    _self.el.removeClass("inactive");
    setTimeout(function () {
        _self.el.addClass("active");
    }, 200);
    this.el.css({
        zIndex: Math.max(this.z_index, POPUP_STATICS.z_index.active)
    });
    var index_in_active_stack = POPUP_STATICS.active_stack.find(this.instance_identifier + " == this.instance_identifier");
    if (index_in_active_stack > -1) {
        POPUP_STATICS.active_stack.splice(index_in_active_stack, 1);
    }
    POPUP_STATICS.active_stack.push(this);
    this.trigger("active");
    this.is_active = true;
    var modal = this;
    while (!modal.modal) {
        if (!modal.parent) {
            break;
        }
        modal = modal.parent
    }
    if (modal.modal) {
        modal.setMask();
    }
    this.el.focus();
};

// HWC-4777: a modal opening over another modal HIDES it instead of stacking on it; close()
// restores it through _revealConcealed. Message dialogs (bm.confirm / bm.alert) and the docked /
// page-like families in WCUI_POPUP_KEEP_COVERED_CLASSES keep the covered popup on screen.
_p._concealCovered = function (coveredPopup) {
    if (this.hide_inactive === false || !this.modal || this.act_as_body || this._keepsCoveredVisible()) {
        return;
    }
    // setActive() can re-run on a popup that is already top-of-stack — never hide ourselves.
    if (!coveredPopup || coveredPopup === this || !coveredPopup.modal || coveredPopup.act_as_body) {
        return;
    }
    if (coveredPopup.is_hidden || coveredPopup.is_closed || !coveredPopup.el || !coveredPopup.el.length) {
        return;
    }
    // Conceal ONLY what setActive() actually deactivated. setInactive() is the single thing that
    // clears is_active, and setActive() skips it when masking is false or do_not_change_active_stack
    // is set — a still-active popup hidden here could never come back: show() -> setActive() would
    // hit its `if (this.is_active) return` guard, so the modal mask is never rebuilt and the popup
    // is never pushed onto active_stack again.
    if (coveredPopup.is_active) {
        return;
    }
    // el.length stays 1 for a detached node, so an instance torn down by removing its element
    // instead of calling close() still looks open here. Never conceal what is no longer on screen.
    if (!$.contains(document.documentElement, coveredPopup.el[0])) {
        return;
    }
    if (coveredPopup._keepsCoveredVisible()) {
        return;
    }
    this._concealed_popup = coveredPopup;
    coveredPopup.hide();
};

_p._revealConcealed = function () {
    var concealed = this._concealed_popup;
    this._concealed_popup = null;
    // A caller that restored it itself, or closed it meanwhile, leaves nothing to do.
    if (!concealed || concealed.is_closed || !concealed.is_hidden) {
        return;
    }
    // show() is el.show() + setActive() — neither re-places the popup, and it can sit concealed for
    // the whole life of the modal on top of it. A viewport resize, a device rotation or a content
    // change in the meantime leaves its stored coordinates stale, potentially offscreen. Make it
    // measurable, re-place it, land the tween instantly (position() routes through animate for an
    // on-screen element), and only then bring it back.
    concealed.el.show();
    concealed.position();
    concealed.el.stop(true, true);
    concealed.show();
};

_p.setInactive = function () {
    if(this.act_as_body) {
        return;
    }
    if (!this.is_active) {
        return;
    }
    var okToActive = this.trigger("beforeInactive");
    if (okToActive === false) {
        return false;
    }
    var _self = this;
    this.el.removeClass("active").addClass("inactive");
    this.el.css({
        zIndex: this.z_index
    });
    var mask = this.el.find(".inactive-mask");
    if (!mask.length) {
        mask = $("<div class='inactive-mask'></div>").appendTo(this.el);
        mask.on("mousedown", function () {
            _self.setActive()
        })
    }
    mask.show();
    this.trigger("inactive");
    this.is_active = false;
    this.hideMask();
};

_p.bindEvents = function () {
    var _self = this;
    this.el.find(".close").click(function () {
        _self.close(1);
    });

    this.el.find(".maximize").click(function () {
        this.jqObject.hide()
        _self.el.find(".minimize").show()
        _self.el.addClass("wc-full-view-popup")
    });

    this.el.find(".minimize").click(function () {
        this.jqObject.hide()
        _self.el.find(".maximize").show()
        _self.el.removeClass("wc-full-view-popup")
    });


    if(!this.maximizable){
        this.el.find(".fee-popup__close").click(function () {
            _self.close(1);
        });
    }


    if (this.close_on_mask_click === true && POPUP_STATICS.modal_mask) {
        POPUP_STATICS.modal_mask.bind("click.popup-mask-click-" + this.instance_identifier).click(function () {
            if (_self.is_active) {
                _self.close(1);
            }
        })
    }
    if (this.close_on_blur === true) {
        $(document).bind("mousedown.popup-out-click-" + this.instance_identifier, function (e) {
            var container = _self.el;
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                if (_self.is_active) {
                    _self.close(1);
                }
            }
        })
    }
    if (this.hide_on_blur === true) {
        $(document).bind("mousedown.popup-out-click-" + this.instance_identifier, function (e) {
            var container = _self.el;
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                if (_self.is_active) {
                    _self.el.jqObject.removeClass("active");
                    bm.enableBackgroundScroll();
                    setTimeout(function() {
                        _self.el.next(".popup-mask").hide()
                        _self.el.next(".popup-mask").remove()
                        _self.el.remove()
                        // This teardown bypasses close(), so do its bookkeeping by hand. Without it
                        // the instance stays on active_stack still reporting is_active with its
                        // element detached, and the next setActive() picks that corpse up as the
                        // popup it covers (see _concealCovered) or tries to re-activate it.
                        // indexOf, NOT the find(expr) idiom setActive() uses — prototype.js's find
                        // returns the matched OBJECT, not an index, so its `> -1` test never fires.
                        var index_in_active_stack = POPUP_STATICS.active_stack.indexOf(_self);
                        if (index_in_active_stack > -1) {
                            POPUP_STATICS.active_stack.splice(index_in_active_stack, 1);
                        }
                        _self.is_active = false;
                        _self.is_closed = true;
                        _self._revealConcealed()
                    },50)
                }
            }
        })
    }
    if (this.close_on_escape) {
        $(document).bind("keyup.key_esc.popup-escape-" + this.instance_identifier, function () {
            if (_self.is_active) {
                _self.close(1);
                bm.enableBackgroundScroll();
            }
        })
    }
    if (this.auto_close) {
        this.resetCloseTimer();
        if (this.reset_close_timer_on_hover) {
            this.el.hover(function () {
                _self.clearCloseTimer();
            }, function () {
                _self.resetCloseTimer();
            })
        }
    }
    if (this.auto_active_on_focus) {
        this.el.bind("focus", function () {
            _self.setActive();
        })
    }
    if (this.draggable) {
        var _self = this;
        var drag_el = this.drag_handle == "*" ? this.el : this.el.find(this.drag_handle);
        var el_offset = this.el.offset();
        var drag_el_offset = drag_el.offset();
        var top_diff = drag_el_offset.top - el_offset.top;
        var left_diff = drag_el_offset.left - el_offset.left;
        this.el.draggable({
            handle: this.drag_handle == "*" ? undefined : drag_el,
            cancel: this.drag_cancel,
            disable_text_selection: this.disable_text_selection,
            stop: function () {
                var offset = drag_el.offset();
                var adj = false;
                if (offset.left < -1 * drag_el.outerWidth() + 50) {
                    offset.left = 5;
                    adj = true;
                }
                if (offset.top < -1 * drag_el.outerHeight() + 50) {
                    offset.top = 5;
                    adj = true;
                }
                if (adj) {
                    _self.el.offset({
                        left: offset.left - left_diff,
                        top: offset.top - top_diff
                    });
                }
                if (_self.animation_clazz) {
                    //_self.el.addClass(_self.animation_clazz); // NO need this because we can't again create the popup, we just moving. so in that time no need to add animation class
                }
                _self._dragging = false;
            },
            start: function () {
                if (_self.animation_clazz) {
                    _self.el.removeClass(_self.animation_clazz);
                }
                // HWC-3847: never let the motion engine fight a drag gesture
                _self._dragging = true;
                _self.el.removeClass("wcui-popup-enter wcui-popup-enter-fade");
            }
        })
    }
};

_p.clearCloseTimer = function () {
    if (this.auto_close_timer) {
        clearTimeout(this.auto_close_timer);
        this.auto_close_timer = null;
    }
};

_p.resetCloseTimer = function () {
    this.clearCloseTimer();
    var _self = this;
    this.auto_close_timer = setTimeout(function () {
        _self.auto_close_timer = null;
        _self.close(0);
    }, this.auto_close);
};

_p.unbindEvents = function () {
    if (this.close_on_mask_click === true && POPUP_STATICS.modal_mask) {
        POPUP_STATICS.modal_mask.unbind("click.popup-mask-click-" + this.instance_identifier)
    }
    if (this.close_on_blur === true) {
        $(document).unbind("mousedown.popup-out-click-" + this.instance_identifier);
    }
    if (this.close_on_escape) {
        $(document).unbind("keyup.key_esc.popup-escape-" + this.instance_identifier);
    }
    this.clearCloseTimer()
};

(function () {
    function setNextActive() {
        if (this.is_active && POPUP_STATICS.active_stack.length) {
            var nextActive;
            while (true) {
                nextActive = POPUP_STATICS.active_stack[POPUP_STATICS.active_stack.length - 1];
                if (nextActive) {
                    if (nextActive.is_closed || nextActive.is_hidden) {
                        POPUP_STATICS.active_stack.pop();
                    } else {
                        nextActive.setActive();
                        if (nextActive.modal && (!POPUP_STATICS.modal_mask || !POPUP_STATICS.modal_mask.parent().length)) {
                            nextActive.setMask();
                        }
                        break;
                    }
                } else {
                    break;
                }
            }
        }
    }

    _p.close = function (exitCode) {
        var _self = this;
        // HWC-3847: the animated exit keeps the mask clickable for a beat — a second click
        // must not re-run close() (double events + double active_stack.pop → stack corruption).
        if (this.is_closed) {
            return;
        }
        if (this.trigger("beforeClose", [exitCode]) === false) {
            return;
        }
        this.unbindEvents();
        // HWC-3847: a popup still in loader-first PENDING state never visually entered (frame held
        // offscreen while its content loaded). Closing it here — e.g. content_loaded finds a
        // no-template response and bails — must be silent: _teardownMotion() below un-hides the
        // frame, so an exit animation would flash the never-shown popup in just to zoom it out.
        var _wasPending = !!(this.el && this.el.hasClass("wcui-popup-pending"));
        this._teardownMotion();
        if (_wasPending) {
            this.el.remove();
        } else if (this.closing_animation_clazz && !this._transitionsEnabled()) {
            this.el.removeClass("active").removeClass(this.animation_clazz).addClass(this.closing_animation_clazz);
            setTimeout(function () {
                _self.el.remove();
            }, this.closing_animation_duration);
        } else {
            this.el.remove(); // HWC-4777: closing is instant — no exit animation
        }
        this.hideMask();
        if (this.is_active) {
            POPUP_STATICS.active_stack.pop();
        }
        this.is_closed = true;
        setNextActive.call(this);
        var numberOfPopupOpen = $("#webcommander-page").find(".popup:not(.notification, .floating-panel-popup)").length
        if(!_self.not_enable_body_scroll && numberOfPopupOpen <= 1){
            bm.enableBackgroundScroll();
        }
        this.trigger("close", [exitCode]);
        // After setNextActive (it drops hidden popups from the stack) and after the caller's
        // close handlers, so a caller that restores it itself still wins.
        this._revealConcealed();
        $(".arx-control").remove();
    };

    _p.hide = function () {
        this._teardownMotion();
        this.el.hide();
        this.hideMask();
        this.is_hidden = true;
    }
})();

_p.show = function () {
    this.el.show();
    this.setActive();
    this.is_hidden = false;
    // hide() tears the resize observer down — rebuild it for the new visible session.
    if (!this._resize_observer) {
        this._observeResize();
    }
};

_p.getDom = function () {
    return this.el;
};

$.prototype.popup = function (settings) {
    var obj = this.data("popup-inst");
    if (typeof settings == "string" && obj) {
        if ($.isFunction(obj[settings])) {
            return obj[settings](Array.prototype.splice.call(arguments, 1))
        } else {
            return obj[settings];
        }
    }
    if (!obj) {
        obj = new POPUP($.extend({}, settings, {el: this}));
        this.data("popup-inst", obj);
    }
    return this;
};

; (function() {
    var DATA_KEY = "form-inst";
    var DEFAULT_OPTIONS = {
        preSubmit: undefined,
        disable_on_submit: true,
        disable_on_invalid: true,
        text_change_on_submit: true
    };

    var passwordStrengthMeterText = ["very.weak", "weak", "better", "medium", "strong", "strongest"];
    var passwordStrengthMeterClass = ["very-weak", "weak", "better", "medium", "strong", "strongest"];

    var careFunctions = $.form_care_functions = {
        checkbox: function() {
            var allchecks =  this.find("input:checkbox[name][uncheck-value]");
            allchecks.pairuncheck()
        },
        auto_toggle: function() {
            if(bm.autoToggle) {
                bm.autoToggle(this)
            }
        },
        textarea: function() {
            if($.form_no_textarea_autosize) {
                return;
            }
            this.find("textarea:not('.no-auto-size')").autosize();
        },
        events: function(obj)  {
            var dom = this;
            var form = obj.elm;
            if(dom.is(form)) { // not an appended dom
                this.bind("submit", function() {
                    if (browser.ie && browser.version == 8) {
                        var isPrevent = dom.data("ie8-prevent-submit");
                        if (isPrevent) {
                            dom.removeData("ie8-prevent-submit");
                            return false;
                        }
                    }
                    return instanceFuncs.submit.call(obj)
                });
            }
            if(!form.is("form")) {
                dom.find("input, textarea").bind("keydown.key_return", function() {
                    form.triggerHandler("submit");
                    if(browser.ie && browser.version == 8) {
                        var closestForm = form.closest("form");
                        if(closestForm.length) {
                            closestForm.data("ie8-prevent-submit", true);
                        }
                    } else {
                        return false;
                    }
                });
                if(dom.is(form)) { // not an appended dom
                    obj.submitButton.click(function () {
                        dom.triggerHandler("submit")
                    });
                    dom.find(".reset-button").click(function () {
                        dom.triggerHandler("reset");
                    });
                }
            }
        },
        validation: function(obj) {
            var validConfig = obj.validation_config || {},
                errorPosition = this.attr("error-position");
            if(errorPosition) {
                validConfig.error_position = errorPosition
            } else if (window.app && app.is_front_end) {
                var validationConfigKey = this.attr("validation-config-key");
                if (validationConfigKey) {
                    var errorPosition = app.config["validation_" + validationConfigKey + "_error_position"];
                    if (errorPosition) {
                        validConfig.error_position = errorPosition
                    }
                }
            }
            if(this.is(obj.elm)) {
                this.attachValidator(validConfig);
            } else {
                obj.elm.obj(ValidationPanel).attach(this.find("[validation]"), validConfig)
            }
        },
        restrict: function() {
            this.find(":text[restrict], :password[restrict]").each(function() {
                var input = $(this);
                input[input.attr("restrict")]();
            });
        },
        unique: function() {
            var _self = this;
            var action = this.attr("action") || this.attr("unique-action");
            if(!action) {
                return
            }
            var last = action.lastIndexOf("/");
            action = action.substring(0, last) + "/";
            var edit = this.find("input[name=id]").length;
            var uniqueFieldCount = 0;
            this.find(".unique").each(function() {
                var field = $(this);
                bm.unique({
                    url: action + (field.attr("unique-action") || "isUnique"),
                    restoreUrl: action + (field.attr("unique-restore") || "restoreFromTrash"),
                    editMode: edit,
                    elm: field,
                    form: _self,
                    uniqueFieldCount: uniqueFieldCount+=1,
                    fieldError: false,
                    inTrash: false
                })
            })
        },
        focus_on_row: function() {
            this.find(".form-row > input").focus(function() {
                $(this).parent().addClass("active-row");
            }).blur(function() {
                $(this).parent().removeClass("active-row");
            })
        },
        disable_on_invalid: function(instance) {
            var _form = this;
            if(!instance.disable_on_invalid) {
                return;
            }
            var invalid = false;
            _form.find("[validation]").each(function() {
                var lockId = bm.getUUID();
                $(this).bind("invalid.form_js", function(e) {
                    if(e.target == e.currentTarget) {
                        instanceFuncs.lock.call(instance, lockId);
                        if(!invalid) {
                            var element = $(this);
                            if(window.app && !app.is_front_end) {
                                var scrollPanel = element.parents(".scrollable.vertical");
                                if(scrollPanel.length) {
                                    scrollPanel.scrollTo(element, {offsetTop: "180"});
                                }
                            }
                        }
                        invalid = true;
                    }
                }).bind("remove.form_js clear-error.form_js", function(e) {
                    if(e.target == e.currentTarget) {
                        instanceFuncs.unlock.call(instance, lockId);
                        invalid = false;
                    }
                })
            })
        },
        password_strength_meter: function() {
            var _form = this;
            var passwords = _form.find(".password-strength-meter");
            $.each(passwords, function(index, passwordField) {
                $(passwordField).on("keyup", function() {
                    var password = $(passwordField).val();
                    var score   = 0;
                    //if password bigger than 6 give 1 point
                    if(password.length > 6) score++;
                    //if password has both lower and uppercase characters give 1 point
                    if((password.match(/[a-z]/) ) && ( password.match(/[A-Z]/) ) ) score++;
                    //if password has at least one number give 1 point
                    if(password.match(/\d+/)) score++;
                    //if password has at least one special caracther give 1 point
                    if(password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/) )	score++;
                    //if password bigger than 12 give another 1 point
                    if(password.length > 12) score++;

                    var passwordMeterDom;
                    var siblings = $(passwordField).siblings();
                    $.each(siblings, function(idx, sibling) {
                        if($(sibling).hasClass("password-meter-wrap")) {
                            passwordMeterDom = $(sibling);
                            return false;
                        }
                    });
                    if (!passwordMeterDom) {
                        passwordMeterDom = $("<span class='password-meter-wrap'></span>");
                        $(passwordField).after(passwordMeterDom);
                    }
                    var descDom = passwordMeterDom.find(".password-description");
                    if(descDom.length == 0) {
                        passwordMeterDom.append("<div class='password-description'></div>");
                    }
                    descDom.text($.i18n.prop(passwordStrengthMeterText[score]));
                    if(password.length == 0) {
                        descDom.text("");
                    }
                    var barDom = passwordMeterDom.find(".password-strength-bar");
                    if(barDom.length == 0) {
                        passwordMeterDom.append("<div class='password-strength-bar'></div>");
                    }
                    barDom.removeClass();
                    barDom.addClass("password-strength-bar " + passwordStrengthMeterClass[score]);
                    if(password.length == 0) {
                        barDom.removeClass();
                    }
                });
            });
        },
        abn_input_formatting: function () {
            var _form = this;
            var abnField = _form.find(".abn-validation");
            abnField.on({
                keypress: function (element) {
                    var key = element.which;
                    if (!(key >= 48 && key <= 57)) {
                        element.preventDefault();
                        return false;
                    }
                },
                keyup: function (element) {
                    var key = element.which;
                    var abnValue = abnField.val();
                    var abnFormattedValue = '';
                    if (!(key >= 37 && key <= 40) && (key != 8)) {
                        abnValue = abnValue.replace(/\s+/g, "");
                        if (abnValue.length > 2) {
                            for (var index = 0; index < abnValue.length; index++) {
                                if (index == 2) {
                                    abnFormattedValue += " ";
                                } else if (index == 5) {
                                    abnFormattedValue += " ";
                                } else if (index == 8) {
                                    abnFormattedValue += " ";
                                }
                                abnFormattedValue += abnValue[index];
                            }
                            abnField.val(abnFormattedValue);
                        }
                    }
                }
            });
        }
    };

    var instanceFuncs = {
        append: function(dom) {
            var instance = this;
            $.each(careFunctions, function() {
                this.call(dom, instance);
            })
        },
        lock: function(lockId) {
            if(!this.lock) {
                this.lock = {};
            }
            this.lock[lockId] = true;
            if(this.submitButton) {
                this.submitButton.attr("disabled", "disabled");
            }
            this.elm.trigger("lock")
        },
        unlock: function(lockId) {
            if(this.lock && this.lock[lockId]) {
                delete this.lock[lockId];
            }
            if($.isEmptyObject(this.lock)) {
                if(this.submitButton) {
                    this.submitButton.removeAttr("disabled");
                }
                this.elm.trigger("unlock")
            }
        },
        prop: function(name, value) {
            return bm.prop(this, name, value)
        },
        force_submit: function(settings) {
            var _form = this, lockId = bm.getUUID();
            this.elm.addClass("submitting");
            instanceFuncs.lock.call(this, lockId);
            if (this.disable_on_submit && this.submitButton) {
                if(this.text_change_on_submit) {
                    _form.submitButton.each(function() {
                        var btn = this.jqObject;
                        if(!btn.is(".fixed-status")){
                            var text = btn.text();
                            this.orgText = text;
                            if (_form.disable_button_text) {
                                btn.text(_form.disable_button_text);
                            } else {
                                if (text == $.i18n.prop("create")) {
                                    text = $.i18n.prop("creating.1")
                                } else if (text == $.i18n.prop("update")) {
                                    text = $.i18n.prop("updating")
                                } else {
                                    text = $.i18n.prop("submitting")
                                }
                                btn.text(text + " ...");
                            }
                        }
                    })
                }
                this.submitButton.attr("disabled", "disabled")
            }
            var _def_settings = $.extend({}, this.ajax === true ? {} : this.ajax);
            var _response;
            settings = settings || {};
            if(_def_settings.success && settings.success) {
                settings.success = settings.success.blend(_def_settings.success)
            }
            if(_def_settings.error && settings.error) {
                settings.error = settings.error.blend(_def_settings.error)
            }
            if(_def_settings.response || settings.response) {
                _response = function() {
                    if(settings.response) {
                        settings.response.apply(this, arguments);
                    }
                    if(_def_settings.response) {
                        _def_settings.response.apply(this, arguments);
                    }
                }
            }
            if(_def_settings.complete && settings.complete) {
                settings.complete = settings.complete.blend(_def_settings.complete)
            }
            var modified_settings = $.extend({}, _def_settings, settings);
            if(!this.elm.is("form")) {
                modified_settings.data = $.extend(this.elm.serializeObject(), modified_settings.data);
                if(!modified_settings.url && modified_settings.controller) {
                    modified_settings.url = app.baseUrl + modified_settings.controller + "/" + modified_settings.action
                }
            }
            this.elm.ajaxSubmit($.extend(modified_settings, {
                response: function (type, response, status, xhr) {
                    _form.elm.removeClass("submitting");
                    instanceFuncs.unlock.call(_form, lockId);
                    if(type == "success") {
                        _form.elm.trigger("ajax-submit-success", [response, status, xhr])
                    } else {
                        _form.elm.trigger("ajax-submit-error", [xhr, status, response])
                    }
                    if (_form.disable_on_submit) {
                        if (_form.text_change_on_submit) {
                            _form.submitButton.each(function() {
                                $(this).text(this.orgText);
                            })
                        }
                        _form.submitButton.removeAttr("disabled", "disabled")
                    }
                    if (_response) {
                        _response.apply(_form.elm, arguments);
                    }
                }
            }));
        },
        submit: function(settings) {
            if (!$.isEmptyObject(this.lock)) {
                return false;
            }
            try {
                if (!this.elm.valid()) {
                    if(settings && settings.invalid) {
                        settings.invalid.call(this.elm)
                    }
                    return false;
                }
                if(this.elm.attr("disabled")) {
                    return false;
                }
                var beforeSubmitRet = true;
                if (typeof this.preSubmit === 'function') {
                    settings = settings || (this.ajax ? {} : null);
                    var _success;
                    if(settings) {
                        _success = settings.success;
                        settings.success = undefined;
                    }
                    beforeSubmitRet = this.preSubmit.call(this.elm, settings);
                    if(settings && settings.success && _success) {
                        settings.success = settings.success.blend(_success);
                    } else if(settings && _success) {
                        settings.success = _success
                    }
                }
                if (beforeSubmitRet !== false && this.ajax) {
                    instanceFuncs.force_submit.call(this, settings);
                    return false;
                }
                if(beforeSubmitRet !== false  && this.disable_on_submit && !this.ajax) {
                    this.onSubmitLockId = bm.getUUID();
                    instanceFuncs.lock.call(this, this.onSubmitLockId);
                }
                return beforeSubmitRet;
            } catch (ex) {
                log(ex.stack);
                return false;
            }
        },
        set_submit: function(button) {
            this.submitButton = button
        }
    };

    function init(instance) {
        var _self = this;
        var obj = this.data(DATA_KEY);
        if(!obj.submitButton) {
            obj.submitButton = this.find("[type='submit'], .submit-button");
            if(obj.submitButton.length > 1) {
                this.attr("class").split(" ").everyCustomFunc(function() {
                    var button = obj.submitButton.filter("." + this + "-submit");
                    if(button.length) {
                        obj.submitButton = button;
                        return false;
                    }
                })
            }
        }
        obj.disable_on_invalid = this.attr("disable-on-invalid") ? this.attr("disable-on-invalid") == "true" :
            (instance.hasOwnProperty("disable_on_invalid") ? obj.disable_on_invalid : obj.disable_on_invalid);
        $.each(careFunctions, function() {
            this.call(_self, instance);
        })
    }

    $.fn.form = function(funcs) {
        var forms = this;
        if(typeof funcs == "string") {
            var rtrn;
            var _arguments = Array.prototype.slice.call(arguments, 1);
            forms.each(function() {
                var obj = $(this).data(DATA_KEY);
                if(!obj) {
                    return true
                }
                if(typeof instanceFuncs[funcs] == "function") {
                    rtrn = instanceFuncs[funcs].apply(obj, _arguments);
                } else {
                    rtrn = obj[funcs]
                }
                if(typeof rtrn != "undefined") {
                    return false
                }
            });
            if(typeof rtrn != "undefined") {
                return rtrn
            }
            return this;
        }
        forms.each(function() {
            var form = $(this);
            if(!form.data(DATA_KEY)) {
                var inst = $.extend({}, DEFAULT_OPTIONS, funcs, {elm: form});
                form.data(DATA_KEY, inst);
                init.call(form, inst);
            }
        });
        return this;
    }
})();

; class Pushbar {
    constructor(config = { overlay: true, blur: false }) {
        this.activeId;
        this.activeElement;
        this.overlayElement;
        if (config.overlay) {
            this.overlayElement = document.createElement('div');
            this.overlayElement.classList.add('pushbar_overlay');
            document.querySelector('body').appendChild(this.overlayElement);
        }
        if (config.blur) {
            const mainContent = document.querySelector('.pushbar_main_content');
            if (mainContent) {
                mainContent.classList.add('pushbar_blur');
            }
        }
        this.bindEvents();
    }

    emitOpening() {
        const event = new CustomEvent('pushbar_opening', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    emitClosing() {
        const event = new CustomEvent('pushbar_closing', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    handleOpenEvent(e) {
        e.preventDefault();
        const pushbarId = e.currentTarget.getAttribute('data-pushbar-target');
        this.open(pushbarId);
    }

    handleCloseEvent(e) {
        e.preventDefault();
        this.close();
    }

    handleKeyEvent(e) {
        if (e.keyCode === 27) this.close();
    }

    bindEvents() {
        const triggers = document.querySelectorAll('[data-pushbar-target]');
        const closers = document.querySelectorAll('[data-pushbar-close]');
        triggers.forEach(trigger => trigger.addEventListener('click', e => this.handleOpenEvent(e), false));
        closers.forEach(closer => closer.addEventListener('click', e => this.handleCloseEvent(e), false));
        if (this.overlayElement) {
            this.overlayElement.addEventListener('click', e => this.handleCloseEvent(e), false);
        }
        document.addEventListener('keyup', e => this.handleKeyEvent(e));
    }

    open(pushbarId) {
        if (this.activeId === String(pushbarId) || !pushbarId) return;
        if (this.activeId && this.activeId !== String(pushbarId)) this.close();
        this.activeId = pushbarId
        this.activeElement = document.querySelector(`[data-pushbar-id="${this.activeId}"]`)
        if (!this.activeElement) return;
        this.emitOpening();
        this.activeElement.classList.add('opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.add('pushbar_locked');
        pageRootElement.setAttribute('pushbar', pushbarId)
    }

    close() {
        if (!this.activeId) return;
        this.emitClosing();
        this.activeElement.classList.remove('opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.remove('pushbar_locked');
        pageRootElement.removeAttribute('pushbar')
        this.activeId = null;
        this.activeElement = null;
    }
}
; /* storeSwitcherSelect.js
 * Sub site widget (type key: storeSwitcher) — the storefront half of widget/storeSwitcher.gsp.
 *
 * Picking a country REDIRECTS to that country's store (/site/<cc>/) and records the choice in the
 * multilingualCountry cookie. It translates nothing: language is languageSelect.js's job, on the same
 * url, via the googtrans cookie.
 *
 * Why this is its own file: the two behaviours used to share ONE widget and ONE <select>, chosen by
 * config (site.js: isMultiLanguageEnable ? loadMultiLanguages() : loadMultilingualCountries()). A
 * merchant therefore could never place a language switcher and a store switcher on the same page, and
 * the same DOM node meant different things on different sites. Separate widgets, separate files.
 *
 * Drives the markup ui:multiStoreCountrys emits — a text input (#country_selector) plus a hidden code
 * field (#country_selector_code) — through countrySelect.js, which is what that taglib was written
 * for and what gives the picker its country flags.
 */
(function (window, document, $) {
    "use strict";

    var COUNTRY_COOKIE = 'multilingualCountry';
    var WIDGET_SELECTOR = '.widget-storeSwitcher';

    function readCookie(name) {
        var parts = String(document.cookie || '').split(';');
        for (var i = 0; i < parts.length; i++) {
            var c = parts[i].replace(/^\s+/, '');
            if (c.indexOf(name + '=') === 0) { return c.substring(name.length + 1); }
        }
        return '';
    }

    function writeCountryCookie(value, days) {
        var exp = new Date(Date.now() + days * 86400000).toUTCString();
        document.cookie = COUNTRY_COOKIE + '=' + value + ';expires=' + exp + ';path=/';
    }

    /**
     * Send the visitor to a country's store. Never re-assigns the url we are already on:
     * getStoreDetails resolves an unknown or blank country to the DEFAULT store, so an unguarded
     * assignment reloaded the current page instead of navigating anywhere.
     */
    function goToCountryStore(countryCode) {
        if (!countryCode) return;
        bm.ajax({
            dataType: 'json',
            method: 'POST',
            url: app.baseUrl + 'siteCommon/getStoreDetails',
            data: {location: window.location.href, countryCode: countryCode},
            success: function (resp) {
                if (!resp.url) return;
                writeCountryCookie(countryCode, 1000);
                var here = location.href.replace(/[?#].*$/, '').replace(/\/+$/, '');
                if (resp.url.replace(/\/+$/, '') === here) return;
                location.href = resp.url;
            }
        });
    }

    var INPUT_SELECTOR = '#country_selector';
    var CODE_SELECTOR = '#country_selector_code';
    var LOADING_KEY = 'store-switcher-loading';
    var CHUNK_KEY = 'store-switcher-chunk-requested';

    function isEnabled() {
        return !!(app.isMultiModelEnable && app.isStoreLocationEnable);
    }

    function pendingInputs() {
        return $(WIDGET_SELECTOR).find(INPUT_SELECTOR).filter(function () {
            return !$(this).data(LOADING_KEY);
        });
    }

    function buildPicker($input, codes, selected, enabled) {
        $input.countrySelect(codes.length ? {onlyCountries: codes} : {});
        if (selected && (!codes.length || codes.indexOf(selected) !== -1)) {
            $input.countrySelect('selectCountry', selected);
        }
        var $widget = $input.closest(WIDGET_SELECTOR);
        $widget.removeAttr('hidden');
        $input.off('change.storeSwitcher');
        if (enabled) {
            $input.on('change.storeSwitcher', function () {
                goToCountryStore($widget.find(CODE_SELECTOR).val());
            });
        }
    }

    $.wcStoreSwitcher = {
        /**
         * options.onCountryList(codes): called with the lower-cased store country codes once the list
         * is in. The site and editor bundles pass different handlers — that is the one part of this
         * flow which legitimately differs between them (the editor must not auto-redirect itself).
         */
        load: function (options) {
            var opts = $.extend({onCountryList: null}, options);
            var enabled = isEnabled();
            if (!enabled && !app.is_front_end_editor) {
                $(WIDGET_SELECTOR).attr('hidden', true);
                return;
            }
            var $inputs = pendingInputs();
            if (!$inputs.length) return;
            if (!$.fn.countrySelect) {
                if (window.wcLoadJsChunk && !$inputs.first().data(CHUNK_KEY)) {
                    $inputs.data(CHUNK_KEY, true);
                    window.wcLoadJsChunk('locale', function () {
                        $.wcStoreSwitcher.load(options);
                    });
                }
                return;
            }
            $inputs.data(LOADING_KEY, true);

            var cookieCountry = readCookie(COUNTRY_COOKIE);
            bm.ajax({
                url: app.baseUrl + 'siteCommon/multiStoreCountryList',
                dataType: 'json',
                data: {location: window.location.href},
                error: function () {
                    $inputs.removeData(LOADING_KEY);
                },
                success: function (resp) {
                    var codes = [];
                    var seen = {};
                    (resp.countryList || []).forEach(function (country) {
                        if (!country || !country.code) return;
                        var code = String(country.code).toLowerCase();
                        // getStoreCountryList() returns one row PER STORE, so two stores in the same
                        // country would otherwise appear twice in the picker.
                        if (seen[code]) return;
                        seen[code] = true;
                        codes.push(code);
                    });
                    if (!codes.length && !app.is_front_end_editor) {
                        $inputs.removeData(LOADING_KEY);
                        return;
                    }
                    // Cookie wins over the store the url resolves to: it is the country the visitor
                    // last chose, and it is what onCountryList's handler compares against.
                    var selected = String(cookieCountry || resp.countryCode || '').toLowerCase();
                    $inputs.each(function () {
                        buildPicker($(this), codes, selected, enabled);
                    });
                    if (enabled && opts.onCountryList) { opts.onCountryList(codes); }
                }
            });
        }
    };

    if (app.is_front_end_editor && typeof MutationObserver === 'function') {
        $(function () {
            var scheduled = null;
            var observer = new MutationObserver(function (mutations) {
                var hit = false;
                for (var i = 0; i < mutations.length && !hit; i++) {
                    var added = mutations[i].addedNodes;
                    for (var j = 0; j < added.length; j++) {
                        var node = added[j];
                        if (node.nodeType !== 1) continue;
                        if ($(node).is(WIDGET_SELECTOR) || $(node).find(WIDGET_SELECTOR).length) {
                            hit = true;
                            break;
                        }
                    }
                }
                if (!hit || scheduled) return;
                scheduled = setTimeout(function () {
                    scheduled = null;
                    $.wcStoreSwitcher.load();
                }, 50);
            });
            observer.observe(document.body, {childList: true, subtree: true});
        });
    }
})(window, document, jQuery);

; 
// Sized album/gallery cloud images (thumb-/gallery- prefixed) 404 for images uploaded before
// thumbnail generation existed. This is a capture-phase listener because "error" doesn't bubble
// on <img>, so delegation via .on("error", "img", ...) would never fire. Falls back to the
// unprefixed original once, guarded by a data flag so a failing original doesn't retry forever.
document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || img.dataset.thumbFallbackApplied) {
        return;
    }
    var src = img.getAttribute('src') || '';
    var match = src.match(/\/(?:thumb|gallery)-([^\/?#]+)$/);
    if (!match) {
        return;
    }
    img.dataset.thumbFallbackApplied = '1';
    img.src = src.slice(0, match.index + 1) + match[1];
}, true);

$(function() {
    restoreProductListingScroll();
    initPreviousPageButton();
    initScrollingClass();
    // Round 4: the video half of site.js lives in the 'video' feature chunk. The server
    // emits it eagerly when the page markup reveals a video, but a video inside snippet
    // content is invisible to that check - probe the real DOM and lazy-load on demand.
    // wcLoadJsChunk no-ops (immediate callback) when the chunk was already emitted.
    if (window.wcLoadJsChunk && $('video, .wc-video-container, [data-video-autoplay], iframe[src*="youtube"], iframe[src*="vimeo"], .snippet-video-thumbnail').length) {
        window.wcLoadJsChunk('video');
    }
});


// True when running INSIDE the FEE editor (page editor OR layout sub-editor, grid OR flat/AI
// layout) and NOT in Preview. body.`fee` (set by sitepage.gsp for editMode && isFrontEndEditor)
// is the UNIVERSAL editor marker; `fee-editor-active`/`fee-grid-editing` only cover the grid path
// and miss the flat/AI layout editor — which is why an autoplay video kept playing in the editor
// after reload. Mirrors the guard used by the flying-cart / widget-select handlers below. Autoplay
// must be suppressed while editing (any context) but allowed on the published page and in Preview
// (fee-preview-mode), which renders the page as it will appear live.
function _isFeeEditing() {
    var b = $('body');
    return !b.hasClass('fee-preview-mode') &&
        (b.hasClass('fee') || b.hasClass('fee-editor-active') || $('.fee-grid-editing').length > 0);
}


function initScrollingClass() {
    var webcommanderPage = $('#webcommander-page');

    if (webcommanderPage.length) {
        // Listen to window scroll since #webcommander-page is the body element
        $(window).on('scroll', function() {
            var scrollTop = $(window).scrollTop();

            // Add class when scrolled more than 70px from top
            if (scrollTop > 0) {
                webcommanderPage.addClass('body-scrolling');
            } else {
                // Remove class when scrolled back to within 70px from top
                webcommanderPage.removeClass('body-scrolling');
            }
        });
    }
}

function initPreviousPageButton() {
    $(".previous-page").on("click", function (e) {
        var lastBreadcrumb = $(".widget-breadcrumb .custom-breadcrumb-trace.breadcrumb-item.last-nav-to-go-back a");
        if (lastBreadcrumb.length) {
            e.preventDefault();
            window.location.href = lastBreadcrumb.attr("href");
        } else {
            window.history.back();
        }
    });
}

$.extend(app, {
    global_event: $({}),
    widget: {}
});

var site = {
    width : $(window).width(),
    height : $(window).height(),
    registered_hooks: {},
    hook: {
        register: function(name, func) {
            var callbacks = site.registered_hooks[name];
            if(!callbacks) {
                callbacks = site.registered_hooks[name] = []
            }
            callbacks.push(func)
        },
        fire: function(name, response, params) {
            var callbacks = site.registered_hooks[name];
            if(callbacks) {
                callbacks.everyCustomFunc(function() {
                    response = this.apply(null, [response].concat(params))
                })
            }
        }
    },
    fncts: {}
};
var responsiveMenuManager = {
    closeFunction: null,
    currentOwner: null,
    open: function(opener, closer, owner) {
        // Always close any open menu before opening a new one
        if(this.closeFunction) {
            this.closeFunction()
            this.closeFunction = null
            this.currentOwner = null
        }
        opener();
        this.closeFunction = closer;
        this.currentOwner = owner;
    },
    close: function(owner) {
        // Only close if owner matches the current owner, or if no owner is specified (close all)
        if(this.closeFunction) {
            if(!owner || owner === this.currentOwner) {
                this.closeFunction()
                this.closeFunction = null
                this.currentOwner = null
            }
        }
    }
};
var renderSitePopup, renderGlobalSitePopup, renderAddToCartPopup, loadAdvancedFlyingCart, renderFlyingCart, adjustCartWidgetQuantity, renderInfoChooserPopup, addProductInCart;

function collectCartData(container, data, forPriceOnly) {
    var included;
    var combination;
    if(container.find(".included-products-container[combination-flexible]").length) {
        included = {};
        container.find(".included-quantity-selector").each(function() {
            var spin = $(this);
            var id = spin.attr("pId");
            included[id] = spin.val()
        });
        included = included ? JSON.stringify(included) : null
    } else if(container.find(".included-quantity-selector-hidden").length) {
        included = {};
        container.find(".included-quantity-selector-hidden").each(function() {
            var spin = $(this);
            var id = spin.attr("pId");
            included[id] = spin.val()
        });
        included = included ? JSON.stringify(included) : null
    }
    data.included = included;
    if(container.find(".param-dump").length) {
        $.extend(data, container.find(".param-dump").serializeObject())
    }
    site.hook.fire("prepareAddCartData", data, [container, data.productId, data.quantity, forPriceOnly])
}

function thirdPartyAnalyticsAddToCartEvent(resp) {
    let product = resp.productObject;
    let cartProductDataMap = resp.cartProductDataMap;
    let thirdPartyAnalyticsConfigContainer = $('#third-party-analytics-config-container');
    if (thirdPartyAnalyticsConfigContainer.length) {
        let currency = thirdPartyAnalyticsConfigContainer.find('#currency-for-third-party-analytics');

        let googleAnalyticsAddToCartEnabled = thirdPartyAnalyticsConfigContainer.find('#google-analytics-add-to-cart-event');
        if (googleAnalyticsAddToCartEnabled.length && googleAnalyticsAddToCartEnabled.val() === 'true') {
            console.log('google analytics event: add_to_cart');
            gtag("event", "add_to_cart", {
                currency: currency.val(),
                value: cartProductDataMap.cartPageDisplayTotal,
                items: [
                    {
                        item_id: product.sku,
                        item_name: product.name,
                        price: cartProductDataMap.cartPageDisplayUnitPrice,
                        quantity: cartProductDataMap.quantity
                    }
                ]
            });
        }
        let fbPixelAddToCartEnabled = thirdPartyAnalyticsConfigContainer.find('#facebook-pixel-add-to-cart-event');
        if (fbPixelAddToCartEnabled.length > 0 && fbPixelAddToCartEnabled.val() === 'true') {
            fbq('track', 'AddToCart');
        }
    }
}

addProductInCart = function (externalProperties, callback, callbackAfterSuccess, _this) {
    _this = _this ? _this : $(this);
    var carts = _this.config("cart");
    var container = _this.closest(".page-content, .popup, .product-block, .add-cart-info-block");
    var quantity = carts["quantity"];
    var productId = _this.attr("product-id");
    var storeId = _this.attr("storeId");
    var data = {productId: productId, quantity: quantity};
    data.externalProperties = externalProperties;
    storeId ? data.storeId = storeId : "";
    if(_this.is(".buy-now-button")) {
        data.buyNow = true;
    }
    if(_this.is(".add-to-cart-button")) {
        data.addToCart = true;
    }
    site.hook.fire("addProductInCartData", _this, data)
    collectCartData(container, data, false);
    if(data["isValidationFailed"]) {
        _this.loader(false);
        return false;
    }
    var formData = data["formData"] || new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key) && data[key]) {
            const value = data[key];
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    if(key == 'productId') {
                        if(!formData['productId'] && !formData.get('productId')) {
                            formData.append(key, value[i]);
                        }
                    } else {
                        formData.append(key, value[i]);
                    }
                }
            } else {
                if(key == 'productId') {
                    if(!formData['productId'] && !formData.get('productId')) {
                        formData.append(key, value);
                    }
                } else {
                    formData.append(key, value);
                }
            }
        }
    }

    bm.ajax({
        url: app.baseUrl + "cart/add",
        data: formData,
        mimeType:"multipart/form-data",
        contentType: false,
        processData: false,
        type: 'post',
        success: function(resp) {
            _this.loader(false)
            app.customFormData = null;
            callbackAfterSuccess && callbackAfterSuccess();
            var content = $(resp.html);
            if(resp.status == 'added') {
                site.hook.fire("cartAdded", {})

                if(resp.externalStep && resp.externalStep.content){
                    site.hook.fire("externalStep", {},[resp.externalStep])
                    return
                }
                var isBuyNowSoldOut = (resp.buyNow && resp.productObject.isSoldOut);
                var isBuyNowOutOfStockAndIsInventoryEnabled = (resp.buyNow && (resp.productObject.availableStock <= 0) && (resp.productObject.isInventoryEnabled));
                var isBuyNowAndIsAddToCartPopup = !(resp.isFlyingCartEnabled) || isBuyNowSoldOut || isBuyNowOutOfStockAndIsInventoryEnabled;
                var isProductSoldOut =  resp.productObject.isSoldOut;
                var isOutOfStockAndIsInventoryEnabled= ((resp.productObject.availableStock <= 0) && (resp.productObject.isInventoryEnabled));
                var isAddToCartPopup = !(resp.isFlyingCartEnabled) || isProductSoldOut || isOutOfStockAndIsInventoryEnabled;

                site.hook.fire("itemAddedIntoCart", data, [container, data.productId, data.quantity])
                if(resp.buyNow) {
                    window.location.href = app.baseUrl + "shop/checkout";
                } else if (isBuyNowAndIsAddToCartPopup){
                    renderAddToCartPopup(content);
                } else if(isAddToCartPopup) {
                    renderAddToCartPopup(content);
                } else {
                    var messageBlocks = content.find(".message-block.no-quantity-error");
                    if(messageBlocks.length) {
                        renderAddToCartPopup(content)
                    } else {
                        var timeout = 0
                        if(container && container.find(".frequently-bought-together-products").length){
                            timeout = 2000
                        }
                        setTimeout(function(){
                            //TODO show cart add ons offer
                            loadAdvancedFlyingCart();
                        }, timeout);
                    }
                }
                thirdPartyAnalyticsAddToCartEvent(resp);
            } else if(resp.status == 'redirect-to') {
                window.location.href = app.baseUrl + "product/" + resp.url
            } else if(resp.status == 'incomplete-info') {
                renderInfoChooserPopup(productId, content);
            }else if(resp.status == 'restrict') {
                if (resp.externalData && resp.externalData.addToCartRestrictionTypeYesNo) {
                    bm.confirm(resp.alrtMessage, function(){
                            if (resp.isFlyingCartEnabled) {
                                externalProperties = externalProperties ? $.extend(externalProperties, {isAllowedToConvertAllToPreOrder: resp.externalData.isAskToPreOrder}): {isAllowedToConvertAllToPreOrder: resp.externalData.isAskToPreOrder}
                                externalProperties = JSON.stringify(externalProperties)
                                addProductInCart(externalProperties, callback, callbackAfterSuccess, _this)
                            } else {
                                window.location.href = app.baseUrl + resp.redirectLink
                            }
                        },
                        function () {
                            externalProperties = externalProperties ? $.extend(externalProperties, {preOrderConversionRequired: false}) : {preOrderConversionRequired: false}
                            externalProperties = JSON.stringify(externalProperties)
                            addProductInCart(externalProperties, callback, callbackAfterSuccess, _this)
                        });
                } else {
                    bm.confirm(resp.alrtMessage, function () {
                        if (resp.isFlyingCartEnabled) {
                            loadAdvancedFlyingCart()
                        } else {
                            window.location.href = app.baseUrl + resp.redirectLink
                        }

                    }, undefined, undefined, {yesButtonTitle: "OK"});
                }
            }
            callback && callback()
        },
        error: function (resp) {
            _this.loader(false)
        }
    });

}

var addBulkProductInCart = function (externalProperties, callback) {
    var _this = $(this);
    var container = _this.closest(".page-content");
    var blukQtyInputs = container.find(".product-quantity-selector-bulk");
    var isPossibleAddToCart = container.find("input.product-quantity-selector-bulk.validation-error").length;
    blukQtyInputs.each(function () {
        if(this.jqObject.val() != "0"){
            isPossibleAddToCart = true;
            return false
        }
    });
    if(isPossibleAddToCart){
        var productDataList = [];
        $(".product-quantity-selector-bulk").each(function () {
            var productRow = $(this);
            var storeId = _this.attr("storeId");
            var data = {
                productId: productRow.attr("product-id"),
                quantity: productRow.val(),
                'config.variation': productRow.attr("product-variation")
            };
            storeId ? data.storeId = storeId : "";
            // collectCartData(container, data, false);
            productDataList.push(data);
        });
        bm.ajax({
            url: app.baseUrl + "variation/addBulkProductToCart",
            data: {productDataList: JSON.stringify(productDataList)},
            type: 'post',
            success: function(resp) {
                var content = $(resp.html);
                if(resp.status == 'added') {
                    renderAddToCartPopup(content);
                } else if(resp.status == 'redirect-to') {
                    window.location.href = app.baseUrl + "product/" + resp.url
                }else if(resp.status == 'restrict') {
                    bm.confirm(resp.alrtMessage, function() {
                        window.location.href =  app.baseUrl + resp.redirectLink
                    },undefined, undefined, { yesButtonTitle: "OK"});
                }
                callback && callback()
            }
        });
    }
}

var addBulkProductInCartFromExternal = function (productDataList, externalProperties, callback, errorCallback) {
    var _this = $(this);
    var container = $(".page-content");

    // var productDataList = [{
    //     productId: 71,
    //     quantity: 2,
    //     'config.variation': 2,
    //     'custom.TeamReference' : "abc",
    //     'custom.CustomXL' : "xyz.xls",
    //     'extAdditionalJson' : "xyz.xls",
    // }];

    bm.ajax({
        url: app.baseUrl + "variation/addBulkProductToCartFromExternal",
        data: {productDataList: JSON.stringify(productDataList)},
        type: 'post',
        success: function(resp) {
            var content = $(resp.html);
            if(resp.status == 'added') {
                if(resp.isFlyingCartEnabled == "true"){
                    loadAdvancedFlyingCart();
                } else {
                    renderAddToCartPopup(content);
                }
            } else if(resp.status == 'redirect-to') {
                window.location.href = app.baseUrl + "product/" + resp.url
            }else if(resp.status == 'restrict') {
                bm.confirm(resp.alrtMessage, function() {
                    window.location.href =  app.baseUrl + resp.redirectLink
                },undefined, undefined, { yesButtonTitle: "OK"});
            }
            callback && callback(resp)
        },
        error: function(xhr, status, error) {
            errorCallback && errorCallback(error, xhr, status)
        }
    });
}

var addBulkProductInCartFromCustomSource = function (productDataList, externalProperties, callback, errorCallback) {

    var _this = $(this);
    var container = $(".page-content");
    bm.ajax({
        url: app.baseUrl + "cart/addBulkCustomProductToCartFromExternal",
        data: {productDataList: JSON.stringify(productDataList), externalProperties: JSON.stringify(externalProperties || {})},
        type: 'post',
        success: function(resp) {
            var content = $(resp.html);
            if(resp.status == 'added') {
                if(resp.isFlyingCartEnabled == "true"){
                    loadAdvancedFlyingCart();
                } else {
                    renderAddToCartPopup(content);
                }
            } else if(resp.status == 'redirect-to') {
                window.location.href = app.baseUrl + "product/" + resp.url
            } else if(resp.status == 'restrict') {
                bm.confirm(resp.alrtMessage, function() {
                    window.location.href =  app.baseUrl + resp.redirectLink
                },undefined, undefined, { yesButtonTitle: "OK"});
            }
            callback && callback(resp)
        },
        error: function(xhr, status, error) {
            errorCallback && errorCallback(error, xhr, status)
        }
    });
}

bm.addBulkProductInCartFromCustomSource = addBulkProductInCartFromCustomSource;

bm.addBulkProductInCartFromExternal = addBulkProductInCartFromExternal;

bm.addProductInCart = addProductInCart;

function renderMessage(panel, message, type, time, insertMethod) {
    panel = panel ? panel : $('[section=body]')
    panel.find('.message-block').remove();
    var msgSpan = $('<div class="message-block ' + type + '">' + message + '</div>');
    insertMethod = insertMethod ? insertMethod : "prepend";
    panel[insertMethod](msgSpan);
    msgSpan.scrollHere();
    setTimeout(function(){
        msgSpan.remove();
    }, time || 5000);
}

///////////////// CAPTCHA ////////////

app.captchaUtil = (function() {
    var recaptchaWidgets = [];

    var TURNSTILE_API_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    var turnstileApiRequested = false;

    // Loads Turnstile's api.js when a widget container is on the page without it. The server enqueues that
    // tag for the site layout, but a surface that never prints the queue (or a render pass whose output is
    // discarded) would otherwise leave the container an empty box with nothing to render it.
    function loadTurnstileApi() {
        if (turnstileApiRequested) {
            return;
        }
        turnstileApiRequested = true;
        if (document.querySelector('script[src^="' + TURNSTILE_API_SRC + '"]')) {
            return;   // already in the DOM, just not executed yet - its own auto-render will pick things up
        }
        var script = document.createElement("script");
        // render=explicit turns OFF Turnstile's implicit render pass, so initTurnstile is the ONE renderer.
        // Left implicit, both run and whichever loses logs "a widget already exists in this container".
        // Same approach the reCAPTCHA v2 path takes with its own ?render=explicit.
        script.src = TURNSTILE_API_SRC + "?render=explicit";
        script.async = true;
        script.defer = true;
        script.onload = function () {
            app.captchaUtil.initTurnstile();
        };
        document.head.appendChild(script);
    }
    return {
        reloadCaptcha: function(captchaType) {
            if(captchaType == 'simple_captcha') {
                var src = $(".simple-captcha img")[0].src;
                var path = bm.path(src);
                path.query._ = new Date().getTime();
                src = path.full();
                $(".simple-captcha img").attr("src", src);
                $(".simple_captcha_input_field > input[name=captcha]").val("");
            } else if(captchaType == 're_captcha') {
                recaptchaWidgets.forEach(function (value) {
                    if( value != undefined )
                        grecaptcha.reset(value);
                });
            } else if(captchaType == 'turnstile') {
                // A Turnstile token is single-use: without this reset the next submit on the same form is
                // rejected as timeout-or-duplicate, and the visitor gets an "invalid captcha" they cannot clear.
                if(typeof turnstile !== "undefined") {
                    $(".cf-turnstile").each(function () {
                        turnstile.reset(this);
                    });
                }
            }
        },
        bindReCaptcha: function (container, ifNotReady, recaptchaFormSubmit) {
            bm.onReady(window, "grecaptcha", {
                not: ifNotReady,
                ready: function () {
                    grecaptcha.ready(function () {
                        if(container.length){
                            var captcha = grecaptcha.render(container.attr('id'), container.config("config"));
                            recaptchaWidgets.push(captcha)
                            recaptchaFormSubmit.attr("disabled", false)
                        }
                    });
                }
            });
        },

        //TODO recaptcha not good for those form which is required less time to stay on the form.
        bindV3: function (container) {
            var recaptchaDoms = container.hasClass("recaptcha-v3-container")
                ? container
                : container.closest(".recaptcha-v3-container")
            try {
                bm.onReady(window, "grecaptcha", {
                    not: function () {
                        bm.addScript("https://www.google.com/recaptcha/api.js?&render=" + recaptchaDoms.attr('config-sitekey'), false)
                    },
                    ready: function () {
                        grecaptcha.ready(function () {
                            function responseGenerate() {
                                var siteKey = recaptchaDoms.attr('config-sitekey')
                                grecaptcha.execute(siteKey, {action: 'submit'}).then(function (token) {
                                    recaptchaDoms.find("#" + recaptchaDoms.attr('token-field-id')).attr("value", token)
                                });
                            }
                            recaptchaDoms.parent().find("button[type='submit']").on("click", function () {
                                responseGenerate();
                            })
                            responseGenerate();
                        });
                    }
                });
            } catch (e) {
                console.log(e.message)
            }
        },

        // Mints a FRESH reCAPTCHA v3 token right before an order is submitted and
        // writes it into the hidden g-recaptcha-response field(s), then runs the
        // callback. v3 tokens expire after ~2 minutes and are single-use, so the
        // token generated when the page/step first rendered is almost always stale
        // by the time the shopper finishes entering card details -> "Invalid captcha".
        // Resolves the callback immediately (submits as before) when v3 captcha is
        // not present or grecaptcha is unavailable, so non-captcha flows are unaffected.
        refreshV3Token: function (callback) {
            var settled = false;
            // Run the callback exactly once, no matter which path resolves first,
            // so checkout is never blocked or double-submitted.
            var done = function () {
                if (settled) { return; }
                settled = true;
                if (callback) { callback(); }
            };
            var recaptchaDoms = $(".recaptcha-v3-container");
            var siteKey = recaptchaDoms.length ? recaptchaDoms.attr('config-sitekey') : null;
            if (!siteKey || typeof grecaptcha === "undefined") {
                done();
                return;
            }
            // Safety net: if grecaptcha.ready never fires its callback (grecaptcha
            // present but internally wedged), submit anyway after 4s so the pay
            // button can never permanently stall. The `settled` guard ensures a
            // real token still wins if it arrives first.
            setTimeout(done, 4000);
            try {
                grecaptcha.ready(function () {
                    // grecaptcha.execute throws SYNCHRONOUSLY on an invalid/misconfigured
                    // site key. That throw happens inside this ready callback (outside the
                    // outer try), so it must be caught here or it silently blocks checkout.
                    try {
                        grecaptcha.execute(siteKey, {action: 'submit'}).then(function (token) {
                            recaptchaDoms.each(function () {
                                var _dom = this.jqObject;
                                _dom.find("#" + _dom.attr('token-field-id')).attr("value", token);
                            });
                            done();
                        }).catch(function () {
                            // Fall back to submitting with whatever token exists; the
                            // server still validates and will surface any real failure.
                            done();
                        });
                    } catch (e) {
                        console.log(e.message);
                        done();
                    }
                });
            } catch (e) {
                console.log(e.message);
                done();
            }
        },
        /**
         * api.js auto-renders only the .cf-turnstile containers that exist when it executes. A form injected
         * by AJAX afterwards - or any container that appears late - is left as an empty box, so render those
         * explicitly. Idempotent: a container Turnstile already rendered holds an iframe and is skipped.
         */
        initTurnstile: function () {
            var pending = $(".cf-turnstile").filter(function () {
                // Turnstile renders into a SHADOW ROOT, so querying for an iframe never sees its widget and
                // every pass would try to render again ("already rendered ... rejected"). It does add a child
                // element to the container, and we mark what we render ourselves.
                return !this.childElementCount && !this.getAttribute("data-wc-turnstile-bound");
            });
            if (!pending.length) {
                return;
            }
            if (typeof turnstile === "undefined") {
                loadTurnstileApi();
                return;
            }
            pending.each(function () {
                try {
                    this.setAttribute("data-wc-turnstile-bound", "1");
                    turnstile.render(this, {
                        sitekey: $(this).data("sitekey"),
                        theme: $(this).data("theme") || "light",
                        // data-size from <ui:captcha size=".."/>: "compact" where 300px can't fit
                        size: $(this).data("size") || "normal"
                    });
                } catch (e) {
                    console.log("turnstile render failed: " + e.message);
                }
            });
        }
    }
})();

;$(function () {
    app.captchaUtil.initTurnstile();
    // Scoped to our own AJAX layer (jQuery's own hook) - never a global XHR/fetch patch.
    $(document).ajaxComplete(function () {
        app.captchaUtil.initTurnstile();
    });
});

//////////  image preview  /////////////////

function bindImagePreviewEvents(){

    // In the FEE editor a click on a content image belongs to the editor (select the widget, open the
    // table's Cell Content editor), not to this viewer-side zoom popup - which also masks the canvas and
    // swallows the click. Checked per click, like the cart's _feeEditorSelect: Preview still zooms.
    $(".zoom-able-image-to-preview").click(function(){
        if (_isFeeEditing()) { return; }
        imageZoomPreview(this.jqObject);
    });

    var disableImagePopUp = $("#content-settings-disable-image-popup-in-text-editor");

    if (!disableImagePopUp.length || disableImagePopUp.val() === 'false') {
        $("figure img").click(function () {
            if (_isFeeEditing()) { return; }
            var _this = this.jqObject;
            if(!_this.is(".swiper-lazy")){
                var parent = _this.parent();
                if (parent.is("a")) {
                    if (parent.attr("target") == 'true') {
                        imageZoomPreview(_this);
                    }
                } else {
                    imageZoomPreview(_this);
                }
            }
        });
    }

    imageZoomPreview = function(imageObj) {
        var popup = $('<div class="image-popup-container-for-zoom-preview"></div>');
        var popupDom = '<span class="close-button-for-zoom-preview"></span>' +
            '<span class="image-wrapper-for-zoom-preview">' +
            '<span class="image-loader-for-zoom-preview"></span>' +
            '<img class="popup-image-for-zoom-preview">' +
            '</span>';

        popup.addClass("loading")
        popup.popup({
            content: popup,
            is_always_up: true,
            show_close: true,
            close_on_blur: true,
            is_center: true,
            masking: true,
            draggable: false,
        });
        var dom = $(popupDom);
        popup.append(dom)
        popup.find(".popup-image-for-zoom-preview").on("load", function () {
            popup.removeClass("loading").obj(POPUP).position();
        });

        var isActive = true;
        var reload = function () {
            var src = imageObj.attr("src");
            popup.addClass("loading").find(".popup-image-for-zoom-preview").attr("src", src);
        };
        reload();
        bm.disableBackgroundScroll();
        popup.find(".close-button-for-zoom-preview").click(function () {
            popup.obj(POPUP).close();
            isActive = false;
        });
    };
}
$(function() {
    bindImagePreviewEvents()
});

////////////////////image preview end//////////////
function bindCommonWidgetEvents(){



    // Choose widget mode based on admin config:
    //   enable_multi_language=true → language locale list
    //   enable_multi_model=true   → country list (existing behaviour)
    //   neither                   → widget hidden
    // Independent, not either/or: a page may carry the language switcher, the country/store
    // switcher, both, or neither. Each loader gates itself on its own config, so what used to be an
    // if/else — which made the two widgets mutually exclusive — is now two plain calls.
    loadMultiLanguages();
    loadStoreSelector();

    // Offer the visitor their own language (popup only, opt-in per site). Runs after the switcher is
    // built so the popup and the dropdown can never disagree about what is on offer.
    maybeSuggestLanguage();


    $(".valid-verify-form").form({
        text_change_on_submit: false
    });

    $(".quick-signup-form").form();

    if($(".date-of-birth-row").length) {
        $(".date-of-birth-row").updateUi()
    }

    function bindLanguageSelectorEvent(storeCountryList, detectedCountry) {
        var cookieCountry = getCookie("multilingualCountry")
        var popupTitle = "";
        var changeButtonLabel = "";
        bm.ajax({
            url: app.baseUrl + "page/getMultiLanguageSettings",
            type: 'GET',
            success: function (resp) {
                if (resp.config) {
                    popupTitle = resp.config.popup_message;
                    changeButtonLabel = resp.config.change_button_label;
                    bm.ajax({
                        dataType: 'json',
                        method: "POST",
                        url: app.baseUrl + "siteCommon/getCountryCodeByUrl",
                        data: {location: window.location.href},
                        success: function (response) {
                            var urlCountry = String(response.countryCode || "").toUpperCase();
                            var chosenCountry = String(cookieCountry || "").toUpperCase();

                            if (chosenCountry) {
                                // The visitor already picked a sub site. Honour it and do nothing else — no
                                // prompt, no redirect. The old code redirected here whenever the cookie
                                // disagreed with the url, which meant a shared /site/<cc>/ link or a bookmark
                                // bounced the visitor straight back out, and the page they asked for flashed
                                // and vanished. A remembered choice is a decision, not a mismatch to correct.
                                return;
                            }
                            // FIRST VISIT — nothing chosen. ASK; never guess. Silent geo redirect is the
                            // OTHER branch of this decision and it is owned entirely by
                            // resolveRegionalSite / maybeRedirectToRegionalSite: when the admin has turned
                            // "Redirect visitors to their regional site" on, that runs and this page is
                            // already navigating away, so the popup must not also appear. The two are
                            // alternatives — ask, or send — never both.
                            //
                            // isCountrySelected is a per-SESSION flag set by getStoreDetails, so once the
                            // visitor has answered we stop asking on every subsequent page.
                            // Offer the DETECTED country, not the one the current url resolves to.
                            // Preselecting the latter meant the dropdown already showed the store being
                            // viewed, so "switch?" had nothing to switch to.
                            var offerCountry = String(detectedCountry || "").toUpperCase();
                            if (!offerCountry || offerCountry === urlCountry) {
                                // Nothing detected, or they are already on their own country's store —
                                // asking would be noise.
                                return;
                            }
                            // countrySelect can only preselect a country it was given; a detected country
                            // with no sub site is not in the list.
                            var offerable = storeCountryList
                                    && storeCountryList.indexOf(offerCountry.toLowerCase()) !== -1;
                            if (offerable && response.isCountrySelected !== true && !app.is_front_end_editor) {
                                countrySelectionPopup(popupTitle, offerCountry, storeCountryList, changeButtonLabel);
                            }
                        }
                    })
                }
                // NOTE: a missing multi_language_settings config used to hide the whole widget here. Those
                // settings only govern the auto-redirect / "you look like you're from X" popup — they say
                // nothing about whether the store selector should exist. On a site that never opened the
                // legacy Multi Language Settings screen the config row is absent, which silently removed a
                // selector the merchant had deliberately placed. The selector now stands on its own.
            }
        });
        var languageContinue=$(".language-go-to");
        var languageCancel=$(".language-cancel");
        languageCancel.on("click", function(e) {
            $(".language-popup").attr("hidden",true);
        });
        languageContinue.on("click", function(e) {
            $(".language-popup").attr("hidden",true);
            bm.ajax({
                dataType: 'json',
                method: "POST",
                url: app.baseUrl + "siteCommon/getStoreDetails",
                data: { location: window.location.href, countryCode:selectedCountryCode},
                success: function (resp){
                    if(resp.url){
                        location.href=resp.url
                    }
                }
            })
        });
    }
    function countrySelectionPopup(headerLabel, selectedCountry, storeCountryList, changeButtonLabel) {
        var popup = $('<div class="site-popup popup multi-language active" style="background: #FFFFFF" tabindex="0"></div>');
        var selectDom = '<div class="select-wrapper"> <div class="form-item">\n' +
            '<input id="popup_country_selector" type="text" readonly="readonly">\n' +
            '<label for="popup_country_selector" style="display:none;">Select a country here...</label>\n' +
            '</div>\n' +
            '<div class="form-item" style="display:none;">\n' +
            '<input type="text" id="popup_country_selector_code" name="popup_country_selector_code" data-countrycodeinput="1" readonly="readonly"  />\n' +
            '<label for="popup_country_selector_code"></label>\n' +
            '</div>' +
            ' <button name="language-select-continue" id="language-select-continue" class="language-select-continue">Change</button> </div>';
        var headerDom = '<span class="header-label"><div class="title"> We\'ve detected you might from different country </div>' +
            '<div class="label"> Do you want to change to : </div> </span>';
        var footerDom =  '<div class="language-popup-close">\n' +
            '    <button name="language-select-cancel" id="language-select-cancel" class="language-select-cancel">Close and do not switch country</button>' +
            ' </div>' +
            '</div>';
        popup.popup({
            content: popup,
            is_always_up: true,
            show_close: true,
            close_on_blur: true,
            is_center: true,
            masking: true,
            draggable: false,
            animation_clazz: '',
            closing_animation_clazz: '',
            is_fixed: true
        });
        var header = $(headerDom);
        var select = $(selectDom);
        var footer = $(footerDom);
        popup.append(header)
        popup.append(select)
        popup.append(footer)
        if (headerLabel){
            popup.find(".header-label").html(headerLabel)
        }
        if (changeButtonLabel){
            popup.find(".language-select-continue").html(changeButtonLabel)
        }
        var applyCountrySelect = function () {
            $("#popup_country_selector").countrySelect({ onlyCountries: storeCountryList});
            if(selectedCountry.toLowerCase() != 'undefined' && selectedCountry.toLowerCase != null){
                $("#popup_country_selector").countrySelect("selectCountry",selectedCountry.toLowerCase())
            }
        };
        // HWC-4151: locale chunk is page-conditional — lazy-load it on demand
        if ($.fn.countrySelect) {
            applyCountrySelect();
        } else if (window.wcLoadJsChunk) {
            wcLoadJsChunk('locale', applyCountrySelect);
        }
        popup.find(".language-select-continue").on("click", function () {
            var selectedCountryCode = popup.find("#popup_country_selector_code").val();
            bm.ajax({
                dataType: 'json',
                method: "POST",
                url: app.baseUrl + "siteCommon/getStoreDetails",
                data: { location: window.location.href, countryCode:selectedCountryCode},
                success: function (resp){
                    if(resp.url){
                        setCookie("multilingualCountry",selectedCountryCode,1000)
                        location.href = resp.url
                    }
                }
            })
        });
        popup.find(".language-select-cancel").on("click", function () {
            var selectedCountryCode = popup.find("#popup_country_selector_code").val();
            bm.ajax({
                dataType: 'json',
                method: "POST",
                url: app.baseUrl + "siteCommon/getStoreDetails",
                data: { location: window.location.href, countryCode:selectedCountryCode},
                success: function (resp){
                    popup.obj(POPUP).close();
                    if(resp.url){
                        setCookie("multilingualCountry",selectedCountryCode,1000)
                        location.href = resp.url
                    }
                }
            })
        });
        popup.updateUi()
    };
    // Sub site widget (type key: storeSwitcher). Independent of the language switcher now: both may sit on the
    // same page, so this is no longer the "else" of a language check. The loader lives in
    // storeSwitcherSelect.js (loaded by both the site and editor bundles); bindLanguageSelectorEvent
    // stays local because the site and editor versions genuinely differ — the editor must not
    // auto-redirect the page it is editing.
    // Dev-only overrides (?wcLang, ?wcGeoCountry) sit on the PAGE url, but these decisions are made by
    // AJAX calls that have urls of their own — so unless they are forwarded the server never sees them
    // and silently answers as if there were no override, which looks exactly like the feature being
    // broken. Non-production only on the server side; forwarding them costs nothing in production
    // because the params are simply absent.
    function devOverrideParams() {
        var out = {};
        var query = window.location.search || "";
        ["wcLang", "wcGeoCountry"].forEach(function (key) {
            var found = new RegExp("[?&]" + key + "=([^&#]*)").exec(query);
            if (found) { out[key] = decodeURIComponent(found[1]); }
        });
        return out;
    }

    function loadStoreSelector() {
        if (!$.wcStoreSwitcher) {
            if (window.console && console.warn) {
                console.warn("storeSwitcher: $.wcStoreSwitcher is undefined - storeSwitcherSelect.js " +
                    "is missing or a stale cached copy. Sub site switcher not loaded.");
            }
            return;
        }
        // Ask the server what to do BEFORE wiring anything up. "Redirect visitors to their regional
        // site" and the country-selection popup are alternatives, and sequencing them here is what
        // keeps them exclusive: if we are navigating away, the popup never gets a chance to appear and
        // we do not build a picker for a page that is leaving. Doing it with a flag instead would race,
        // because both paths hang off their own async calls.
        bm.ajax({
            url: app.baseUrl + "siteCommon/resolveRegionalSite",
            dataType: "json",
            data: $.extend({location: window.location.href}, devOverrideParams()),
            // cache:false — these answers depend on per-visitor state (browser language, geo, cookie,
            // and the admin's toggles), and the endpoint sends no cache headers, so the browser is free
            // to replay an earlier body forever. A {suggest:null} cached from before the feature was
            // switched on is indistinguishable from the feature not working, which is exactly how this
            // presented: curl saw the fresh answer while the page kept getting the stale one.
            cache: false,
            success: function (resp) {
                if (resp && resp.redirect && resp.url && !app.is_front_end_editor) {
                    // Record the destination ONLY when the server named a country, i.e. when we are
                    // being sent to a real sub site — that is what makes it resolve to "already
                    // chosen" next time instead of detecting again on every page.
                    //
                    // The unlisted-country fallback deliberately sends no countryCode: that redirect
                    // goes to an ordinary page, not a sub site, and writing it here would both record
                    // a store that does not exist and (being read as an explicit choice) disable the
                    // fallback for good after one visit. Guarded because an unguarded write stored the
                    // string "undefined" as the visitor's chosen country.
                    if (resp.countryCode) {
                        setCookie("multilingualCountry", resp.countryCode, 1000);
                    }
                    location.href = resp.url;
                    return;
                }
                // prompt === false means "Redirect visitors to their regional site" is ON. Build the
                // switcher, but withhold bindLanguageSelectorEvent so the country popup cannot appear.
                // Detection may have failed (proxy, local host, no CDN geo header) and produced no
                // redirect — that must NOT fall back to asking, because the toggle promises no prompt.
                var detected = (resp && resp.detectedCountry) ? resp.detectedCountry : null;
                var onCountryList = (resp && resp.prompt === false)
                        ? null
                        : function (codes) { bindLanguageSelectorEvent(codes, detected); };
                $.wcStoreSwitcher.load({onCountryList: onCountryList});
            },
            error: function () {
                // Detection is an enhancement; never let it cost the visitor the switcher itself.
                $.wcStoreSwitcher.load({onCountryList: bindLanguageSelectorEvent});
            }
        });
    }

    // Language SUGGESTION popup — asks, never switches on its own.
    //
    // Separate from countrySelectionPopup() on purpose. That one changes the STORE: it redirects to
    // /site/<code>/ and rewrites the multilingualCountry cookie, which moves the shopper onto another
    // store's prices and currency. This one only sets the Google Translate target for the SAME url.
    // Sharing one popup between the two would mean a visitor who asked for a language silently got a
    // different store's pricing.
    //
    // Gates, in order: switcher on, not the editor, and no language decision on record. That last one
    // is what stops the nagging — wc_site_lang is written both when the visitor switches AND when they
    // keep the current language, so either answer is final. Everything else (feature toggle, signal
    // resolution, whether there is anything worth asking) is the server's call in suggestLanguage.
    function maybeSuggestLanguage() {
        if (!app.isMultiLanguageEnable) return;
        if (app.is_front_end_editor) return;
        try {
            if (localStorage.getItem('wc_site_lang')) return;
        } catch (e) {
            return;                     // no storage → no way to remember an answer → do not ask
        }
        bm.ajax({
            url: app.baseUrl + "siteCommon/suggestLanguage",
            dataType: "json",
            method: "GET",
            data: devOverrideParams(),
            // cache:false — these answers depend on per-visitor state (browser language, geo, cookie,
            // and the admin's toggles), and the endpoint sends no cache headers, so the browser is free
            // to replay an earlier body forever. A {suggest:null} cached from before the feature was
            // switched on is indistinguishable from the feature not working, which is exactly how this
            // presented: curl saw the fresh answer while the page kept getting the stale one.
            cache: false,
            success: function (resp) {
                if (!resp || !resp.suggest) return;
                languageSuggestionPopup(resp);
            }
        });
    }

    function languageSuggestionPopup(suggestion) {
        // Labels arrive fully resolved from the server. Deliberately not $.i18n.prop here: its bundle
        // loads asynchronously and returns the KEY when the map is not ready yet, which would render a
        // literal "language.suggestion.title" to a shopper.
        var popup = $('<div class="site-popup popup multi-language language-suggestion active" style="background:#FFFFFF" tabindex="0"></div>');
        popup.popup({
            content: popup,
            is_always_up: true,
            show_close: true,
            close_on_blur: true,
            is_center: true,
            masking: true,
            draggable: false,
            animation_clazz: '',
            closing_animation_clazz: '',
            is_fixed: true
        });
        // .text() on every server value: the language label comes from a config-driven map, and the
        // popup is built by string-free DOM construction so nothing can be injected as markup.
        var header = $('<span class="header-label"></span>');
        header.append($('<div class="title"></div>').text(suggestion.title || ''));
        header.append($('<div class="label"></div>').text(suggestion.body || ''));

        var actions = $('<div class="select-wrapper"></div>');
        var switchBtn = $('<button type="button" class="language-suggestion-switch"></button>')
            .text(suggestion.switchLabel || suggestion.label || '');
        var keepBtn = $('<button type="button" class="language-suggestion-keep"></button>')
            .text(suggestion.keepLabel || '');
        actions.append(switchBtn);

        var footer = $('<div class="language-popup-close"></div>').append(keepBtn);

        popup.append(header).append(actions).append(footer);

        switchBtn.on("click", function () {
            // Commits through the same path the switcher dropdown uses, then reloads translated.
            $.wcSetSiteLanguage(suggestion.suggest);
        });
        keepBtn.on("click", function () {
            // Record the CURRENT language as the decision so this never asks again, and do NOT reload:
            // nothing about the page changes when the visitor keeps what they already have.
            $.wcSetSiteLanguage(suggestion.current || 'en', false);
            popup.obj(POPUP).close();
        });
        popup.updateUi();
    }

    // Multi-language widget — populates dropdown, syncs with hidden Google
    // TranslateElement via googtrans cookie + localStorage.wc_site_lang.
    // Cookie is read by layout head script BEFORE element.js loads so first
    // paint after reload is already translated.
    function loadMultiLanguages() {
        if (!app.isMultiLanguageEnable) {
            if (!app.is_front_end_editor) {
                $(".widget-languageSelector").attr("hidden", true);
            }
            return;
        }
        var $widget = $(".widget-languageSelector");
        if (!$widget.length) return;
        var $select = $widget.find("#language_selector");
        if (!$select.length) return;

        bm.ajax({
            url: app.baseUrl + "siteCommon/multiLanguageList",
            dataType: "json",
            method: "GET",
            success: function (resp) {
                var saved = localStorage.getItem('wc_site_lang') || 'en';
                $select.empty();
                $select.append('<option value="en"' + (saved === 'en' ? ' selected' : '') + '>English</option>');
                (resp.locales || []).forEach(function (loc) {
                    if (!loc || !loc.code || !loc.name) return;
                    if (loc.code === 'all' || loc.code === 'en') return;
                    var sel = (loc.code === saved) ? ' selected' : '';
                    $select.append('<option value="' + loc.code + '"' + sel + '>' + loc.name + '</option>');
                });
                $widget.removeAttr("hidden");
                // Activate custom dropdown picker (countrySelect-style UX).
                // languageSelect.js handles change, cookie, reload.
                if ($.fn.languageSelect) {
                    $select.languageSelect();
                }
            }
        });
    }
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    renderSitePopup = function(config, popup) {
        var content = config.el || $();
        config = $.extend({
            is_fixed: true,
            is_always_up: true,
        }, config);
        if(config.animation_clazz == undefined) {
            config.animation_clazz = app.config.site_popup_animation_clazz
        }
        config.auto_active_on_focus = false
        content.find(".close-popup, .continue-shopping-btn, .close-btn").click(function () {
            popup.close();
            content.find(".popup-mask").remove();
        });

        var addToCartButtonElement = content.find(".add-to-cart-button");
        var incompleteCartScrollTarget = content.find('.app-tab-incomplete-data-cart-popup');
        if(incompleteCartScrollTarget.length){
            if(window.PerfectScrollbar) {
                new PerfectScrollbar(incompleteCartScrollTarget.nat);
            } else if(window.wcLoadJsChunk) {
                wcLoadJsChunk('scrollbar', function () {
                    new PerfectScrollbar(incompleteCartScrollTarget.nat);
                });
            }
        }

        site.hook.fire("incompleteCartPopupTemplateList", content)

        addToCartButtonElement.click(function () {
            var _self = this.jqObject;
            var form = content.find('form');
            site.hook.fire("prepareAddCartDataValidation", content)
            site.hook.fire("prepareAddCartData", config, [content]);
            if(config.formData) {
                app.customFormData = config.formData;
            }
            if (form.length) {
                form.valid() && popup.close();
            } else {
                popup.close();
            }
        });

        if(!popup|| popup.is_closed) {
            popup = new POPUP(config)
        } else {
            popup.setContent(content.children())
        }
        return popup
    };

    renderGlobalSitePopup = function(content, config)  {
        config = $.extend({
            auto_close: 40000,
            el: content
        }, config);
        site.global_single_popup = renderSitePopup(config, site.global_single_popup)
        return site.global_single_popup
    };

    renderInfoChooserPopup = function(productId, content, customClass, callBackFunction) {
        app.global_event.trigger("initialize-info-chose-popup", [productId, content]);
        renderGlobalSitePopup(content, {clazz: "add-cart-information-popup", disable_background_scroll: true});
        var combinationContainer = content.find(".included-products-container");
        if(combinationContainer.length) {
            initializeCombination(productId, combinationContainer)
        }
        var storeSelection = content.find(".store-selection")
        if(storeSelection.length) {
            content.find(".add-to-cart-button, .buy-now-button").attr("storeId", storeSelection.find(':selected').val())
            storeSelection.on("change", function () {
                content.find(".add-to-cart-button, .buy-now-button").attr("storeId", $(this).find(':selected').val())
            })
        }

        content.find(".add-to-cart-button, .buy-now-button").click(function() {
            if($(this).is(".disabled")) {
                return;
            }
            addProductInCart.call(this);
        })
        content.find("."+customClass).click(function() {
            if($(this).is(".disabled")) {
                return;
            }
            if(callBackFunction){
                callBackFunction.call(this)
            }
        })
    };

    loadAdvancedFlyingCart = function() {
        // HWC-704: in the FEE editor the cart is a widget being EDITED — don't open the flying cart so
        // the click selects the widget instead. The reliable universal editor marker is body.`fee`
        // (sitepage.gsp adds it for editMode && isFrontEndEditor — page editor AND layout sub-editor,
        // grid OR flat/AI layout). `fee-editor-active`/`fee-grid-editing` only cover the grid path and
        // miss a flat layout's header/footer. Preview adds `fee-preview-mode` (cart works); the live
        // storefront has none of these (cart works). This is site.js's loadAdvancedFlyingCart.
        var _feeBody = $('body');
        if (!_feeBody.hasClass('fee-preview-mode') &&
            (_feeBody.hasClass('fee') || _feeBody.hasClass('fee-editor-active') || $('.fee-grid-editing').length > 0)) {
            return;
        }
        var alreadyRenderedFlyingCart = $('#webcommander-page .flying-cart-content.page-content');
        if (alreadyRenderedFlyingCart.length) {
            //alreadyRenderedFlyingCart.hide()
            renderFlyingCart(alreadyRenderedFlyingCart, {disableThirdPartyAnalytics: true});
            return;
        }

        var popup = $('<div class="flying-cart-content page-content" style="background: #FFFFFF" tabindex="0"></div>');
        popup.addClass("loading")
        popup.popup({
            content: popup,
            is_always_up: true,
            show_close: true,
            hide_on_blur: true,
            is_center: false,
            masking: true,
            draggable: false,
            height: window.innerHeight - 1,
            width: 530,
            left: window.innerWidth - 530,
            top: 1,
            animation_clazz: 'flying-cart-appear-animation',
            closing_animation_clazz: 'flying-cart-closing-animation',
            is_fixed: true
        });
        popup.hide()
        popup.loader('flying-cart-loader');
        renderFlyingCart(popup);
        bm.disableBackgroundScroll();
    }

    /*Commented out dut to template issue*/

    adjustCartWidgetQuantity = function (popup, distinctCartItem, totalCartItem, totalAmount) {
        var cartWidgetText = popup.closest("#webcommander-page").find(".cart-widget-text");
        $('.cart-widget-text').text(totalCartItem + ' Item(s)');
        if(cartWidgetText.is(".distinct-item-count")) {
            cartWidgetText.text(distinctCartItem);
        }
        if(cartWidgetText.is(".item-count")) {
            cartWidgetText.text(totalCartItem);
        }
        if(cartWidgetText.is(".total-amount")) {
            cartWidgetText.text(totalCartItem+" item (s) $" + totalAmount);
        }

    }

    var updateFlyingCartQuantity = function (popup, quantity, itemId, flyingCartFooterCheckoutButton) {
        bm.ajax({
            url: app.baseUrl + "cart/updateQuantity",
            data: {quantity: quantity, cartItemId: itemId},
            success: function(resp) {
                renderFlyingCart(popup)
            },
            error: function(a, b, resp) {
                flyingCartFooterCheckoutButton.removeClass("disabled")
                popup.loader(false);
                // Rate-limit block (§7.2 cart_updates ceiling): the update never ran server-side, so re-render
                // the cart to revert the stepper to the true (unchanged) quantity. The global handler shows the
                // ceiling toast, so skip the in-cell message to avoid double UI.
                if(resp && resp.errorCode === "abuse_ceiling_exceeded"){
                    renderFlyingCart(popup);
                    return;
                }
                if(resp.validQty){
                    popup.find(".cart-item-row.flying-cart-item[item-id='"+itemId+"']").find(".flying-cart-product-quantity-selector").val(resp.validQty)
                }
                renderMessage(popup.find(".cart-item-row.flying-cart-item[item-id='"+itemId+"']").find(".flying-cart-item-name-quantity-wrapper"), resp.message, resp.status + "-message in-cell-message-block", app.config.shopping_cart_page_message_display_time);
                setTimeout(function() {
                    var quantityInput = popup.find(".cart-item-row.flying-cart-item[item-id='"+itemId+"']").find(".flying-cart-product-quantity-selector");
                    quantityInput.removeData('updating-' + itemId);
                }, 2000);
            }
        });
    };

    var updateFlyingCartQuantityAfterRemoveItem = function (popup, removedItemId, flyingCartFooterCheckoutButton) {
        var clearEmptyCart = true
        if($("#webcommander-page").hasClass("do-not-remove-cart-preview")){
            clearEmptyCart = false
        }
        bm.ajax({
            url: app.baseUrl + "cart/removeFromFlyingCart",
            data: {itemId: removedItemId, clearEmptyCart: clearEmptyCart},
            success: function(resp) {
                renderFlyingCart(popup)
                if(resp.totalCartItem == 0) {
                    renderFlyingCart(popup, {disableThirdPartyAnalytics: true});
                    site.hook.fire("removeCart", popup.closest("#webcommander-page"));
                    return;
                }
                /*$('.cart-widget-text').text(resp.totalCartItem + ' Item(s)');
                if(resp.totalCartItem == 0) {
                    renderFlyingCart(popup, {disableThirdPartyAnalytics: true});
                    site.hook.fire("removeCart", popup.closest("#webcommander-page"));
                    return;
                }
                $.each(resp.cartData, function(key, value) {
                    key = key.minusCase();
                    popup.find("." + key).text(value)
                });
                popup.find(".cart-item").each(function() {
                    var $this = this.jqObject, itemId = +$this.attr("item-id");
                    if (itemId === +removedItemId) {
                        $this.remove();
                        return;
                    }
                    $.each(resp.cartItemsData[+itemId], function(key, value) {
                        $this.find("." + key.minusCase()).text(value)
                    });
                    $this.find('.flying-cart-product-quantity-selector').val(resp.cartItemsData[itemId].cartItemQuantity);
                });
                popup.loader(false)
                flyingCartFooterCheckoutButton.removeClass("disabled")*/
            },
            error: function (){
                popup.loader(false)
                flyingCartFooterCheckoutButton.removeClass("disabled")
            }
        });
    }

    var updateFlyingCartQuantityAfterRemoveBulkItem = function (popup, removedItemIds, flyingCartFooterCheckoutButton, removeThis) {
        var clearEmptyCart = true
        if($("#webcommander-page").hasClass("do-not-remove-cart-preview")){
            clearEmptyCart = false
        }
        bm.ajax({
            url: app.baseUrl + "cart/removeFromFlyingCartBulkItem",
            data: {itemIds: removedItemIds, clearEmptyCart: clearEmptyCart},
            success: function(resp) {
                $('.cart-widget-text').text(resp.totalCartItem + ' Item(s)');
                if(resp.totalCartItem == 0) {
                    renderFlyingCart(popup, {disableThirdPartyAnalytics: true});
                    site.hook.fire("removeCart", popup.closest("#webcommander-page"));
                    return;
                }
                $.each(resp.cartData, function(key, value) {
                    key = key.minusCase();
                    popup.find("." + key).text(value)
                });
                removeThis.jqObject.closest(".cart-item-row.flying-cart-item").remove()
                popup.loader(false)
                flyingCartFooterCheckoutButton.removeClass("disabled")
            },
            error: function (){
                popup.loader(false)
                flyingCartFooterCheckoutButton.removeClass("disabled")
            }
        });
    }

    renderFlyingCart = function (popup, data = {}) {
        // popup.removeClass("active");
        bm.ajax({
            url: app.baseUrl + "cart/advancedFlyingCart",
            data: data,
            dataType: 'html',
            success: function(resp) {
                popup.html(resp);
                popup.find(".flying-cart-close-button").click(function () {
                    popup.removeClass("active");
                    bm.enableBackgroundScroll();
                    setTimeout(function() {
                        if($(".popup-mask").length){ $(".popup-mask").hide()
                        }
                    },250)

                });

                //It will close the popup
                /*$(window).click(function(){
                    if(popup.obj(POPUP)) {
                        popup.obj(POPUP).close();
                    }
                });*/

                // popup.on("click", function(e){
                //     e.stopPropagation();
                // });

                if($(".popup-mask").length){
                    $(".popup-mask").show()
                }
                var distinctCartItem = popup.find("input[name='distinctItemCount']").val();
                var totalCartItem = popup.find("input[name='totalItemCount']").val();
                var totalAmount = popup.find("input[name='totalAmount']").val();

                adjustCartWidgetQuantity(popup, distinctCartItem, totalCartItem, totalAmount);
                bindProductQuantitySpinner();

                popup.find(".flying-cart-quantity.cartitem-table .stepper").on("min", function() {
                    var box = this.jqObject.find(".stepper-input");
                    box.trigger("ichange");
                });

                popup.find(".flying-cart-quantity.cartitem-table .stepper").on("max", function() {
                    var box = this.jqObject.find(".stepper-input");
                    box.trigger("ichange");
                });

                var quantitySelector = popup.find(".flying-cart-quantity .stepper input.flying-cart-product-quantity-selector");
                quantitySelector.on("before-step-change", function()  {
                    $(this).focus();
                });

                var type = popup.find(".variation-model");
                if(type.length) {
                    var select = popup.find("div.product-variation-select:not(.combined)");
                    if(select.length) {
                        select.chosen({
                            disable_search_threshold: 10,
                            disable_search: true
                        });
                    }
                }

                var flyingCartFooterCheckoutButton = popup.find(".flying-cart-footer-button.checkout-btn")
                quantitySelector.removeData('ichange');
                quantitySelector.off();
                quantitySelector.ichange(10, function () {
                    var ichangeThis = this
                    function ichangeQuantitySelector (){
                        var quantityInput = ichangeThis.jqObject
                        var itemId = quantityInput.attr("item-id");
                        if (quantityInput.data('updating-' + itemId) === true) {
                            return;
                        }
                        popup.loader()
                        flyingCartFooterCheckoutButton.addClass("disabled")
                        var quantity = +quantityInput.val();
                        var minQuantity = +(quantityInput.attr("spin-min") || 1);

                        // Handle empty or zero value
                        if (quantity == 0 || !ichangeThis.value || quantityInput.val().trim() === '') {
                            quantityInput.val(minQuantity);
                            popup.loader(false);
                            flyingCartFooterCheckoutButton.removeClass("disabled");
                            return;
                        }

                        // Validate minimum quantity
                        if (quantity < minQuantity) {
                            quantityInput.val(minQuantity);
                            quantity = minQuantity;
                        }
                        quantityInput.data('updating-' + itemId, true);

                        updateFlyingCartQuantity(popup, quantity, itemId, flyingCartFooterCheckoutButton);
                    }
                    setTimeout(ichangeQuantitySelector, 800)
                }).numeric()

                popup.find(".scrollable-view").each(function() {
                    var _this = $(this);
                    var head = _this.find(">.header");
                    _this.find(".content").scrollbar({
                        show_vertical: false,
                        show_horizontal: true,
                        use_bar: false,
                        visible_on: "always",
                        horizontal: {
                            step: "auto",
                            snap_to_child_width: true, // land on a card edge, not mid-card
                            handle: {
                                left: head.find(".scroll-left"),
                                right: head.find(".scroll-right")
                            }
                        }
                    })
                });

                popup.find(".flying-cart-special-add-to-cart").on("click", function() {
                    var thisCartButton = $(this)
                    if(thisCartButton.is(".disabled")) {
                        return;
                    }
                    thisCartButton.loader()
                    var excAddToCartThis = this
                    function excAddToCart(){
                        addProductInCart.call(excAddToCartThis)
                    }
                    setTimeout(excAddToCart, 700);
                });

                popup.find(".flying-cart-remove-wrapper .flying-cart-item-remove").on("click", function() {
                    popup.loader()
                    flyingCartFooterCheckoutButton.addClass("disabled")
                    var removeThis = this
                    function flyingCartItemRemove(){
                        flyingCartFooterCheckoutButton.addClass("disabled")
                        var itemId = removeThis.jqObject.attr("item-id");
                        updateFlyingCartQuantityAfterRemoveItem(popup, itemId, flyingCartFooterCheckoutButton);
                    }
                    setTimeout(flyingCartItemRemove, 800)
                });

                popup.find(".flying-cart-remove-wrapper .bulk-flying-cart-item-remove").on("click", function() {
                    popup.loader()
                    flyingCartFooterCheckoutButton.addClass("disabled")
                    var removeThis = this
                    function flyingCartItemRemove(){
                        flyingCartFooterCheckoutButton.addClass("disabled")
                        var itemIds = removeThis.jqObject.attr("item-ids");
                        updateFlyingCartQuantityAfterRemoveBulkItem(popup, itemIds, flyingCartFooterCheckoutButton, removeThis);
                    }
                    setTimeout(flyingCartItemRemove, 800)
                });

                popup.find(".save-cart-popup").on("click", function() {
                    var thiz = this.jqObject;
                    var data = thiz.data();
                    bm.ajax({
                        url: app.baseUrl + "saveCart/beforeSave",
                        dataType: 'html',
                        data: data,
                        success: function(resp) {
                            var content = $(resp);
                            content.find(".save-cart-init-form").form({
                                ajax: true,
                                preSubmit: function(ajaxSettings) {
                                    $.extend(ajaxSettings, {
                                        success: function(resp){
                                            bm.notify(resp.message, "success");
                                            popup.close()
                                        },
                                        error: function(a, b, resp) {
                                            renderMessage(content.find(".body .message-container"), resp.message, "error");
                                            app.captchaUtil.reloadCaptcha(resp.captchaType);
                                        }
                                    })
                                }
                            });
                            var popup = renderGlobalSitePopup(content, {clazz: "save-cart-init-form"});
                        }
                    });
                });
                popup.find(".flying-cart-page-heading-action-btn-wrapper .flying-cart-clear-cart-btn").on("click", function() {
                    bm.confirm($.i18n.prop("confirm.empty.cart"), function() {
                        bm.ajax({
                            url: app.baseUrl + "cart/emptyFlyingCart",
                            success: function(resp) {
                                renderFlyingCart(popup);
                                adjustCartWidgetQuantity(popup, resp.distinctCartItem, resp.totalCartItem, resp.totalAmount);
                                site.hook.fire("removeCart", popup.closest("#webcommander-page"));
                            }
                        });
                    }, function() {});
                });
                popup.show()
                bm.disableBackgroundScroll();
                popup.addClass("active");
                site.hook.fire("bind-flying-cart-events", popup);
                popup.loader(false);
            }
        });
    };

    renderAddToCartPopup = function(content) {
        var popup = renderGlobalSitePopup(content, {clazz: "add-to-cart-popup", animation_clazz: app.config.add_to_cart_popup_animation_clazz, auto_close: false});
        content = popup.el
        bindProductQuantitySpinner(content);
        var messageBlocks = content.find(".message-block:not(.no-quantity-error)");
        if(messageBlocks.length) {
            setTimeout(function() {
                messageBlocks.remove()
            }, 5000)
        }

        if(content.closest("#webcommander-page").find(".widget-cart .advanced-flying-cart").length > 0) {
            content.find(".popup-bottom .button-item .cart-page-button").on("click", function(e) {
                e.preventDefault();
                popup.close();
                loadAdvancedFlyingCart(this);
            });
        }

        content.find(".product-quantity-selector").ichange(600, function() {
            if(!this.value) { return }
            var itemId = content.find("[name=itemId]").val();
            var data ={quantity: this.value, cartItemId: itemId};
            site.hook.fire("prepareAddCartData", data, [content])
            if(data["isValidationFailed"]) {
                return false;
            }
            bm.ajax({
                url: app.baseUrl + "cart/updateQuantity",
                data: data,
                success: function(resp) {
                    if(resp.message) renderMessage(content.find(".body"), resp.message, resp.status)
                    $.each(resp.cartData, function(key, value) {
                        content.find("." + key.minusCase()).text(value)
                    });
                    $.each(resp.cartItemsData[+itemId], function(key, value) {
                        content.find("." + key.minusCase()).text(value)
                    });
                    app.global_event.trigger("update-cart");
                },
                error: function(status, xht, resp) {
                    // Rate-limit block (§7.2 cart_updates ceiling): the global handler shows the ceiling toast, so
                    // skip the in-cell message to avoid double UI.
                    if(resp && resp.errorCode === "abuse_ceiling_exceeded"){
                        return;
                    }
                    renderMessage(content.find(".body"), resp.message, resp.status)
                }
            });
        }).numeric();
        app.global_event.trigger("update-cart");
    };

    bindPreviousNextClickEvent = function () {
        var prevBtn = $(".prev-btn");
        var nextBtn = $(".next-btn");
        var productParent = prevBtn.attr('product-parent');
        var hasPrevious = prevBtn.attr('prev');
        var hasNext = nextBtn.attr('next');
        var categoryId = prevBtn.attr("category-id");
        if((!productParent && !categoryId) || (hasPrevious != "true" && hasNext != "true")) {
            prevBtn.hide();
            nextBtn.hide();
        }
        if(hasPrevious != "true") {
            prevBtn.addClass("disabled");
        } else {
            prevBtn.click(function () {
                var productId = prevBtn.attr('product-id');
                var productSorting = prevBtn.attr("product-sorting");
                previousOrNextProduct(productId, "prev", categoryId, productSorting);
            });
        }
        if(hasNext != "true") {
            nextBtn.addClass("disabled");
        } else {
            nextBtn.click(function () {
                var productId = nextBtn.attr('product-id');
                var productSorting = nextBtn.attr("product-sorting");
                previousOrNextProduct(productId, "next", categoryId, productSorting);
            });
        }
        function previousOrNextProduct(productId, direction, categoryId, productSorting) {
            bm.ajax({
                url: app.baseUrl + "page/product",
                data: {productId: productId, direction: direction, categoryId: categoryId, productSorting: productSorting},
                success: function (resp) {
                    if(resp.url) {
                        window.location.href = app.baseUrl + 'product/' + resp.url + "?categoryId=" + resp.categoryId + "&productSorting=" + resp.productSorting
                    }
                }
            });
        }
    }

    bindAddToCartClickEvent = function(container) {
        var cartButton = $(".add-to-cart-button, .buy-now-button, .send-as-gift-button");
        if(container != null) {
            cartButton = container.find(".add-to-cart-button, .buy-now-button, .send-as-gift-button");
        }
        cartButton.click(function () {
            var thisCartButton = $(this)
            if(thisCartButton.is(".disabled")) {
                return;
            }
            thisCartButton.loader()
            var excAddToCartThis = this
            function excAddToCart(){
                addProductInCart.call(excAddToCartThis)
            }
            setTimeout(excAddToCart, 700);

        });

        var pageContent = $(".page-content");
        var isBulkVariationWidgetExist = pageContent.find(".product-widget.widget-bulkVariation .bulk-variation-widget-container").length;
        if(isBulkVariationWidgetExist){
            pageContent.find(".product-widget.widget-addCart").hide();
            // pageContent.find(".product-widget.widget-price").hide();
            pageContent.find(".add-to-cart-button-bulk").click(function() {
                var isValid =  pageContent.find(".product-widget.widget-bulkVariation").valid();
                if($(this).is(".disabled") || !isValid) {
                    return;
                }
                addBulkProductInCart.call(this)
            });
            pageContent.find(".product-widget.widget-bulkVariation").valid()
        }
    };

    bindAddToCartClickEvent();

    bindPreviousNextClickEvent();

    // bindLanguageSelectorEvent();

    // HWC-4750: bindProductQuantitySpinner and its initial call MOVED to the bottom of this file.
    // It used to live here — ~1000 lines inside the $(function(){}) that opens at line 727 — so any
    // unrelated throw earlier in that handler silently left the product page with a bare quantity
    // input instead of a stepper. The definition now runs at script load, which also means the
    // renderAddToCartPopup / flying-cart callers above can no longer race it.

    bm.initCountryChangeHandler($(".country-selector-row select"));

    $(".widget-currency select").on("change", function(){
        var _self = $(this);
        bm.ajax({
            url: app.baseUrl + "app/changeCurrency",
            data: {currencyId: _self.val()},
            dataType: "json",
            success: function(resp){
                location.reload()
            }
        })
    });

    $(".widget-country select").on("change", function(){
        var _self = $(this);
        bm.ajax({
            url: app.baseUrl + "app/changeCountry",
            data: {countryId: _self.val()},
            dataType: "json",
            success: function(resp){
                location.reload()
            }
        })
    });

    // Landing detection for the Country widget (CountryDetectionService): a country already
    // in the session is left alone; a detected country is auto-selected server-side (falling
    // back to the store default when the detected one isn't offered) and the page reloads
    // only when that changed what's already rendered; an undetected visitor gets the
    // country-selection popup rendered hidden by country.gsp.
    function bindCountryWidgetDetection() {
        var countryWidget = $(".widget-country").first();
        if (!countryWidget.length || app.is_front_end_editor) {
            return;
        }
        bm.ajax({
            url: app.baseUrl + "app/detectCountry",
            dataType: "json",
            success: function (resp) {
                if (!resp || resp.status !== "undetected") {
                    if (resp && resp.status === "detected" && resp.changed) {
                        location.reload();
                    }
                    return;
                }
                var contentTemplate = countryWidget.find(".country-selection-popup-template").first();
                if (!contentTemplate.length) {
                    return;
                }
                // Shell first, content after: popup() init calls setContent → .html(content),
                // which would wipe markup already inside the shell (see country.gsp comment).
                var popupElement = $('<div class="country-selection-popup site-popup popup" tabindex="0"></div>');
                popupElement.popup({
                    is_always_up: true,
                    show_close: true,
                    close_on_blur: false,
                    is_center: true,
                    masking: true,
                    draggable: false,
                    animation_clazz: '',
                    closing_animation_clazz: '',
                    is_fixed: true
                });
                popupElement.append(contentTemplate.children());
                contentTemplate.remove();
                contentTemplate = null;
                // Re-center now that the content defines the real size. Direct instance call:
                // the popup("position") string API would pass an empty-array arg, which the
                // method treats as a region and animates to.
                var popupInstance = popupElement.data("popup-inst");
                if (popupInstance) {
                    popupInstance.position();
                }
                popupElement.find(".country-select-continue").on("click", function () {
                    var countryId = popupElement.find("select").val();
                    if (!countryId) {
                        return;
                    }
                    bm.ajax({
                        url: app.baseUrl + "app/changeCountry",
                        data: {countryId: countryId},
                        dataType: "json",
                        success: function () {
                            location.reload()
                        }
                    })
                });
            }
        })
    }

    bindCountryWidgetDetection();

    $(".widget-newsletter > .newsletter.inplace, .newsletter.subscribe").form("prop", "ajax", {
        url: app.baseUrl + "shop/newsletterSubscription",
        success: function(resp, b, c, form) {
            form.find("input[type=text], input[type=email]").val("");
            setMessage(resp.message, true, form);
        }, error: function(a, b, resp, form) {
            setMessage(resp.message, false, form);
        }
    });

    // Newsletter uses the browser's native HTML5 validation (default tooltip) — blocks submit on invalid.
    function newsletterNativeValidate() {
        var firstInvalid = null;
        this.find("input, select, textarea").filter(":visible").each(function() {
            if (this.willValidate && !this.checkValidity()) { firstInvalid = this; return false; }
        });
        if (firstInvalid) {
            if (firstInvalid.reportValidity) { firstInvalid.reportValidity(); }
            return false;
        }
        return true;
    }
    $(".widget-newsletter > .newsletter.inplace, .newsletter.subscribe").form("prop", "preSubmit", newsletterNativeValidate);

    $(".newsletter.unsubscribe").form("prop", "ajax", {
        url: app.baseUrl + "shop/newsletterUnsubscription",
        success: function(resp, b, c, form) {
            var sid = form.find("input[name=sid]").val();
            var page = form.parent();
            var messsage = $(resp.html);
            messsage.find(".link.resubscribe").on("click", function() {
                bm.ajax({
                    url: app.baseUrl + "shop/newsletterResubscription",
                    data: {sid: sid, immediate: true},
                    success: function(resp) {
                        setMessage(resp.message, true, messsage);
                    },
                    error: function(a, b, resp) {
                        setMessage(resp.message, false, messsage);
                    }
                })
            });
            form.replaceWith(messsage);
        }, error: function(a, b, resp, form) {
            setMessage(resp.message, false, form);
        }
    });

    ///////////Order Comment/////////////////

    $(".gust-oder-comment-page .oder-comment-form").form({
        ajax: {
            success: function(resp, b, c, form) {
                var commentArea = $(".gust-oder-comment-page .comment-area");
                var message = $("<div class='comment-row customer'><span class='name'>" +
                    $.i18n.prop(resp.customerName ? resp.customerName : 'customer') + " </span>" +
                    "<span class='date-time-row'><span class='date-time'>" + resp.date + "</span>" +
                    "<span class='show-comment'>" + resp.message + "</span></span></div>");
                commentArea.append(message);
                form.find("textarea").val("");
                commentArea.animate({scrollTop : commentArea[0].scrollHeight}, "slow");
            },
            error: function(xhr, status, resp, form) {
                var commentArea = $(".gust-oder-comment-page .comment-area");
                setMessage(resp.message, false, commentArea);
            }
        }
    });

    function setMessage(message, success, container) {
        var messageBlock = container.find(".message-block");
        if(!messageBlock.length) {
            messageBlock = $("<div class='message-block'></div>");
            container.prepend(messageBlock)
        }
        if(success) {
            messageBlock.removeClass("error-message").addClass("info-message").html(message)
        } else {
            messageBlock.removeClass("info-message").addClass("error-message").html(message)
        }
        // messageBlock.scrollHere();
        setTimeout(function() {
            messageBlock.remove()
        }, app.config.newsletter_subscription_message_display_time)
    }

    $(".widget-newsletter > .submit-button.page-button").on("click", function() {
        location.href = app.baseUrl + "subscription"
    });

    $(".widget-newsletter > .submit-button.floating-subscription-button").on("click", function() {
        var content = $(".newsletter.floating-subscription-hidden-panel").html()
        var newsSubsPopup = renderGlobalSitePopup($(content), {clazz: "newsletter-floating-subscription-popup", animation_clazz:  app.config.site_popup_animation_clazz, auto_close: false});
        var newsletterPopup =  newsSubsPopup.el
        newsletterPopup.form({
            text_change_on_submit: false,
            preSubmit: newsletterNativeValidate
        });
        newsletterPopup.form("prop", "ajax", {
            url: app.baseUrl + "shop/newsletterSubscription",
            success: function(resp, b, c, form) {
                form.find("input[type=text], input[type=email]").val("");
                setMessage(resp.message, true, form.find(".body"));
                setTimeout(function () {
                    newsletterPopup.find(".close-popup.close-icon").trigger("click")
                }, 1000);
            }, error: function(a, b, resp, form) {
                setMessage(resp.message, false, form.find(".body"));
            }
        });
    });


    initializeProductWidget();
    initCartWidget();
    if(!$(".widget.widget-filter").length){
        initializePagination();
    }


    var serverMessages = $(".server-message");
    if(serverMessages.length) {
        serverMessages.scrollHere();
        setTimeout(function() {
            serverMessages.remove()
        }, app.config.server_message_display_time)
    }

    //commons ui change
    $(".bmui-tab").tabify();
    $(".product-block .product-quantity-selector.text-type").on("change spinchange", function () {
        var priceBlock = $(this).parents(".price-n-cart");
        var cartButton = priceBlock.find(".add-to-cart-button, .buy-now-button");
        cartButton.config("cart", {quantity: this.value})
    });

    // HWC-4151: forms chunk is page-conditional — lazy-load before initializing date fields
    var initSiteDatePickers = function () {
    $(".date-picker").each(function () {
        var field = $(this);
        var startDate = field.attr('date-range-start') ? field.attr('date-range-start') : false;
        var endDate = field.attr('date-range-end') ? field.attr('date-range-end') : false;
        var direction = ( startDate || endDate ) ? [startDate, endDate] : (field.attr("no-previous") ? true : (field.attr("no-next") ? false : undefined));
        field.date({
            direction: direction,
            show_select_today: false,
            lang_clear_date: $.i18n.prop("clear")
        })
    });

    // was $(this).find(...) in document-ready scope; the wrapper changes `this`, so select directly
    $(".date-time-picker").each(function () {
        var field = $(this);
        var startDate = field.attr('date-range-start') ? field.attr('date-range-start') : false;
        var endDate = field.attr('date-range-end') ? field.attr('date-range-end') : false;
        var direction = ( startDate || endDate ) ? [startDate, endDate] : (field.attr("no-previous") ? true : (field.attr("no-next") ? false : undefined));
        var timeFormat = field.attr('time-format') == '12' ? "hh:mm:tt" : "HH:mm";
        field.date({
            direction: direction,
            show_select_today: false,
            lang_clear_date: $.i18n.prop("clear"),
            time: timeFormat
        })
    });
    };
    if ($.fn.date) {
        initSiteDatePickers();
    } else if ($(".date-picker, .date-time-picker").length && window.wcLoadJsChunk) {
        wcLoadJsChunk('forms', initSiteDatePickers);
    }

    var recaptchaFormSubmit;

    if ($('.recaptcha-container').length) {
        recaptchaFormSubmit = $('.recaptcha-container').closest("form").find(".submit-button")
        recaptchaFormSubmit.attr("disabled", true)
    }

    $('.recaptcha-container').each(function () {
        app.captchaUtil.bindReCaptcha(this.jqObject, null, recaptchaFormSubmit)
    })

    $('.recaptcha-v3-container').each(function () {
        app.captchaUtil.bindV3(this.jqObject)
    })
}

$(function() {
    bindCommonWidgetEvents()
});


///////////////// Product listing scroll preservation (HWC-2465) //////////////
// Changing a product widget's sorting, pagination page, or items-per-page triggers a
// FULL page reload (window.location.href, in the handlers below) with new query params.
// A fresh navigation always lands at the top of the document, so the user is thrown away
// from the product section and has to scroll back down to see the results they just asked
// for. Before navigating we remember where the viewport sat relative to the listing that
// triggered the change; after the reload we scroll back to that spot so the section stays
// put and only its contents update.
var PRODUCT_LISTING_SCROLL_KEY = "wc-product-listing-scroll";

// Remember the current scroll position just before a sort/pagination reload. `$anchor` is
// the .product-view that owns the control, so we can re-find it after the reload. We store
// the raw viewport offset AND the listing's viewport-relative top (the gap from the viewport
// top down to the section). Restoring against the listing element keeps us correct even if
// content above it reflows on the new load (e.g. images finishing loading); the raw offset
// is the fallback when no listing element is available.
function rememberProductListingScroll($anchor) {
    try {
        var y = $(window).scrollTop();
        var data = { path: window.location.pathname, y: y };
        if ($anchor && $anchor.length && $anchor.attr("id")) {
            data.anchorId = $anchor.attr("id");
            data.anchorDelta = $anchor.offset().top - y; // px from viewport top down to listing top
        }
        sessionStorage.setItem(PRODUCT_LISTING_SCROLL_KEY, JSON.stringify(data));
    } catch (e) { /* sessionStorage unavailable — degrade to the old jump-to-top */ }
}

// Restore the position saved by rememberProductListingScroll after the reload. Only acts on
// the same page it was saved on, and clears the marker afterwards so unrelated navigations
// (manual refresh, following a link) are never affected. Re-applies once on window `load` so
// late layout shifts (images/fonts) can't leave us a few pixels off the section.
function restoreProductListingScroll() {
    var data;
    try {
        var raw = sessionStorage.getItem(PRODUCT_LISTING_SCROLL_KEY);
        if (!raw) { return; }
        data = JSON.parse(raw);
    } catch (e) { return; }
    if (!data || data.path !== window.location.pathname) {
        try { sessionStorage.removeItem(PRODUCT_LISTING_SCROLL_KEY); } catch (e) {}
        return;
    }
    function apply() {
        var target = data.y;
        if (data.anchorId) {
            var $el = $("#" + data.anchorId);
            if ($el.length) {
                target = $el.offset().top - data.anchorDelta;
            }
        }
        $(window).scrollTop(target < 0 ? 0 : target);
    }
    apply();
    $(window).one("load", function() {
        apply();
        try { sessionStorage.removeItem(PRODUCT_LISTING_SCROLL_KEY); } catch (e) {}
    });
}


/////////////////Pagination //////////////

function initializePagination() {
    var paginator = $("paginator");
    if(paginator.length == 0) {
        return
    }
    paginator.each(function() {
        $(this).paginator({
            showPages: window.innerWidth > 800 ? app.config.number_block_in_paginator_count : app.config.number_block_in_paginator_count_800
        })
    });
    $(".pagination").each(function() {
        var _this = $(this);
        var paginatorObj = _this.obj();
        paginatorObj.onPageClick = function() {
            rememberProductListingScroll(_this.closest(".product-view"));
            window.location.href = getUrl(_this)
        }
    });
    var parPageCount = $(".per-page-count");
    parPageCount.change(function() {
        var paginator = $(this).siblings(".pagination");
        paginator.obj().setItemsPerPage(+this.value);
        rememberProductListingScroll($(this).closest(".product-view"));
        window.location.href = getUrl(paginator);
    });
    function getUrl(pagination) {
        var paginatorObj =  pagination.data("wcuiPagination");
        var urlprefix = pagination.data("urlprefix") + "-";
        var cleanHref = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
        var url = bm.path(cleanHref);
        url.query[urlprefix + "offset"] = ((paginatorObj.currentPage - 1) * paginatorObj.itemsPerPage);
        url.query[urlprefix + "max"] = (paginatorObj.all ? "-1" : paginatorObj.itemsPerPage);
        return url.full();
    }
}

///////////////// ProductWidget ////////////


function initializeProductWidget() {
    var sortOrder = $(".product-sorting");
    sortOrder.change(function() {
        var $this= $(this), urlPrefix = $this.attr("urlprefix");
        var cleanHref = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
        var url = bm.path(cleanHref);
        url.query[urlPrefix + "-sort"] = $this.val();
        rememberProductListingScroll($this.closest(".product-view"));
        window.location.href = url.full();
    });
    sortOrder.each(function() {
        var $this = $(this);
        if (!$this.val()) {
            var firstOption = $this.find('option[value!=""]').first();
            if (firstOption.length) { $this.val(firstOption.val()); }
        }
    });

    $(".scrollable-view").each(function() {
        var _this = $(this);
        var head = _this.find(">.header");
        _this.find(".content").scrollbar({
            show_vertical: false,
            show_horizontal: true,
            use_bar: false,
            visible_on: "always",
            horizontal: {
                step: "auto",
                snap_to_child_width: true, // land on a card edge, not mid-card
                handle: {
                    left: head.find(".scroll-left"),
                    right: head.find(".scroll-right")
                }
            }
        })
    });
    bindProductQuantitySpinner()
}

bm.initializeProductWidgetEvents = initializeProductWidget

///////////////// Cart Widget ////////////////

function initCartWidget() {
    // HWC-704: in the FEE editor a cart click must SELECT the widget for editing, not open the cart.
    // The flying/quick-cart handlers bind to .cart-wrapper, which sits over the .fee-overlay selection
    // target (a sibling — the click can't bubble there), so forward the click to the widget's overlay,
    // whose delegated handler opens the right panel. Returns true (→ caller bails) only when editing
    // and NOT in Preview; on the live site it returns false. body.`fee` is the universal editor marker
    // (every FEE iframe — page editor + layout sub-editor, grid OR flat/AI layout); `fee-editor-active`/
    // `fee-grid-editing` only cover the grid path and miss a flat layout's header/footer cart.
    function _feeEditorSelect(clickedEl) {
        var b = $('body');
        if (b.hasClass('fee-preview-mode')) { return false; }
        if (!(b.hasClass('fee') || b.hasClass('fee-editor-active') || $('.fee-grid-editing').length)) { return false; }
        $(clickedEl).closest('.widget').children('.fee-overlay').first().trigger('click');
        return true;
    }
    function initQuickCart (cart) {
        cart.find(".cart-wrapper.quick-cart").unbind().click(function() {
            if (_feeEditorSelect(this)) { return; }
            var _this = $(this);
            var quickCartContent = _this.siblings(".quick-cart-content");
            if(quickCartContent.hasClass("show")) {
                return;
            }
            if(quickCartContent.is(":hidden")) {
                quickCartContent.stop(true).slideDown();
                quickCartContent.focus().one("blur", function() {
                    setTimeout(function() {
                        quickCartContent.stop(true).slideUp();
                    }, 200)
                })
            } else {
                quickCartContent.stop(true).slideUp();
            }
        });
        cart.find(".cart-menu-button").on("click", function() {
            if (_feeEditorSelect(this)) { return; }
            var $this = $(this), content = $this.siblings(".content"), quickCart = content.find('.quick-cart-content');
            if(content.hasClass("show")) {
                responsiveMenuManager.close('cart')
            } else {
                responsiveMenuManager.open(function() {
                    $this.addClass("close");
                    content.addClass("show");
                    quickCart.css({display: ""}).addClass("show")
                }, function() {
                    $this.removeClass("close");
                    content.removeClass("show");
                    quickCart.css({display: "none"}).removeClass("show")
                }, 'cart')
            }
        });
    }

    function initAdvancedFlyingCart (cart) {
        cart.find(".cart-wrapper.advanced-flying-cart").unbind().click(function() {
            if (_feeEditorSelect(this)) { return; }
            loadAdvancedFlyingCart()
        });
    }

    $(".widget-cart").each(function(){
        var _this = $(this);
        initQuickCart(_this);
        initAdvancedFlyingCart(_this);
        var id = _this.attr("widget-id");
        var domId = _this.attr("id");
        app.global_event.bind("update-cart billing-address-change", function(){
            bm.ajax({
                data: {id: id},
                dataType: 'html',
                url : app.baseUrl + "cart/widget",
                success: function (resp){
                    _this.replaceWith(resp);
                    _this = $("#" + domId);
                    initQuickCart(_this);
                    initAdvancedFlyingCart(_this);
                }
            })
        })
    })
}
/* +++++++++++++++++++++++ City Selector +++++++++++++++++++++++++++++ */

$(function() {
    bm.initCityValidator($('[name="postCode"]'))
});

/*** Combination ************************/

function updateProductPrice(block, data) {
    var container = block.closest(".page-content, .popup, .product-block, .add-cart-info-block");
    if(container.is(".page-content")) {
        container = container.find(".product-widget.widget-price, .product-widget.widget-variation, .product-widget.widget-addCart")
    }
    collectCartData(container, data, true);
    if(data["isValidationFailed"]) {
        return false;
    }
    bm.ajax({
        controller: "productPage",
        action: "priceAndUnavailableMsg",
        data: data,
        success: function(resp) {
            container.find(".current-price .price-amount").text(resp.price.toFixed(2));
            if(resp.expect) {
                container.find(".previous-price .price-amount").text(resp.expect.toFixed(2));
            } else if(resp.sale) {
                container.find(".previous-price .price-amount").text(resp.sale.toFixed(2));
            }
            var total = container.find(".current-price .total-amount");
            if(total.length) {
                var quantity = data.quantity || container.find(".add-to-cart-button, .buy-now-button").config("cart", "quantity");
                total.text((resp.price * quantity).toFixed(2))
            }
            container.closest('.page-content').find('.widget-variation .product-status').remove();
            container.closest('.page-content').find('.widget-stockMark').replaceWith(resp.stockWidget).show()
        },
        error: function(a, b, resp) {
            container.closest('.page-content').find('.widget-stockMark').hide();
            displayUnavailableStatus(container.closest('.page-content').find('.widget-variation'), resp.message)
        }
    })
}

function displayUnavailableStatus(container, message) {
    container.find(".product-status").remove();
    container.prepend('<span class="product-status message-block error"></span>');
    container.find(".product-status").text(message);
}

function initializeCombination(productId, container) {
    if(container.is(".initialized")) {
        return
    }
    container.change(function(evt) {
        var data = {productId: productId};
        var originalEvent = evt.originalEvent || evt;
        var input = $(originalEvent.target || originalEvent.srcElement);
        var page = container.parents(".page-content, .add-cart-information-popup");
        var buttons = page.find(".widget-addCart .button, .add-to-cart-button .buy-now-button");
        var infoRow = input.parents(".info-row");
        if(+input.val() < 1) {
            buttons.addClass("disabled");
            renderMessage(infoRow, $.i18n.prop("minimum.required.quantity", [1]), "error", "5000", "after");
            return;
        } else {
            buttons.removeClass("disabled");
            infoRow.siblings(".message-block.error").remove();
        }
        updateProductPrice(container, data)
    });

    container.find(".included-quantity-selector").each(function() {
        var spin = $(this);
        var data = spin.config("spin");
        data.et_data = {
            up: {clazz: "et_pdp_increase_quantity", attr: {'et-category': 'button'}},
            down: {clazz: "et_pdp_decrease_quantity", attr: {'et-category': 'button'}}
        };
        spin.stepper(data)
    });
    container.addClass("initialized")
    site.hook.fire("adjustAdditionalProductData", container, [productId]);
}

$.extend($.form_care_functions, {
    simple_captcha_reload: function() {
        var _reloadIcon = this.find(".simple-captcha-reload.icon");
        _reloadIcon.click( function() {
            app.captchaUtil.reloadCaptcha('simple_captcha')
        });
    }
});

//////////////////Product Short info View////////////////////

function initializeProductInfoView(productId, content, type, callback) {
    bindProductQuantitySpinner(content);
    content.find(".product-quantity-selector.text-type").on("change spinchange", function () {
        var cartButton = content.find(".widget-addCart .add-to-cart-button, .buy-now-button");
        cartButton.config("cart", {quantity: this.value});
    });
    var combinationObj = $(".included-products-container");
    if (combinationObj.length) {
        initializeCombination(productId, combinationObj);
    }
    bindAddToCartClickEvent(content);
    if(type == "details") {
        bm.onReady(app, "productWidgets", {
            ready: function() {
                app.productWidgets.init(content, productId)
            },
            not: bm.addScript.bind(undefined, app.systemResourceUrl + "js/site/product.js", true)
        });
    }
    app.global_event.trigger("after-product-info-view-initialize", [productId, content, type, callback]);
    if(callback) {
        callback()
    }
}

///////////Navigation Widget////////
function bindNavigationWidget(){

    var pageBody = $("#webcommander-page");
    function drawerOpen(content) {
        content.addClass("responsive-navigation");
        if(pageBody.hasClass("with-drawer")) {
            pageBody.find("left-container").html(content)
        } else {
            pageBody.children().wrapAll('<div class="page-container"></div>');
            content = $('<div class="left-container"></div>').html(content);
            pageBody.prepend(content);
            setTimeout(function() {
                pageBody.find(".left-container, .page-container").addClass("open");
            }, 100);
            pageBody.addClass("with-drawer")
            if (typeof reinitTabAccordion !== 'undefined') {
                reinitTabAccordion(content);
            }
        }
    }

    function leftSideBar(content) {
        if(!pageBody.hasClass("with-drawer")) {

            //pageBody.children().wrapAll('<div class="page-container"></div>');

            var navItemsWithWrap = content.find(".nav-wrapper");
            navItemsWithWrap.addClass("responsive-navigation");
            navItemsWithWrap.addClass("wc-modern-navigation");

            var logo;
            var widgetLogo = $(".widget.widget-storeLogo[widget-type='storeLogo']");
            if(widgetLogo.length) {
                logo = widgetLogo.nat.jqObject.find("img").clone();
            } else {
                logo = "";
            }

            content = $('<aside id="left-modern-nav-drawer-wc"  data-pushbar-id="left" data-pushbar-direction="left" class="left-modern-nav-drawer-container"></div>').html(navItemsWithWrap);
            pageBody.prepend(content);

            navItemsWithWrap.prepend("<div class=\"wc-mdoern-nav-title\"><span class='wc-modern-nav-logo'></span><span data-pushbar-close class=\"close wc-modern-nav-close-button push_right\"></span></div>")
            content.find(".wc-modern-nav-logo").prepend(logo)
            // HWC-5637: .clone() keeps the img's data-logo-* variant attributes, so re-pick the variant for the
            // drawer's own background (the clone may carry the header's sticky/dark src).
            if (logo && window.wcStoreLogoVariants) {
                window.wcStoreLogoVariants.refresh();
            }

            pageBody.addClass("with-drawer")
            const pushbar = new Pushbar({
                overlay: true,
            });
            setTimeout(function(){
                pushbar.open("left")
            }, 100);

            if (typeof reinitTabAccordion !== 'undefined') {
                reinitTabAccordion(content);
            }
        }
    }

    function drawerClose(callback) {
        pageBody.find(".left-container, .page-container").removeClass("open");
        setTimeout(function() {
            pageBody.find(".left-container").remove();
            pageBody.find(".page-container").children().unwrap();
            pageBody.removeClass("with-drawer");
            if(callback) {
                callback();
            }
        }, 200)
    }

    $(".widget-navigation").each(function() {
        var widget = $(this), navigation = widget.find(".nav-wrapper");
        // HWC-4152: level 3+ subtrees are mounted lazily from an inert <template> on first
        // interaction (nav-lazy-children.js), so they don't exist in the DOM yet at this
        // boot-time bind. Delegate on the navigation container instead of a direct .find()
        // bind so clicks on those elements still work once they're mounted.
        navigation.off("click", ".child-opener").on("click", ".child-opener", function() {
            var $this = $(this), child = $this.siblings(".navigation-item-child-container");
            $this.toggleClass("close");
            child.toggleClass("open")
        });

        navigation.off("click", ".has-child a").on("click", ".has-child a", function() {
            var $this = $(this), child = $this.siblings(".navigation-item-child-container");
            $this.toggleClass("close");
            child.toggleClass("open")
        });

        widget.find(".menu-title").unbind().on("click", function() {
            var menuBtn = $(this).find(".menu-button"), transitionType = menuBtn.attr("transition-type");
            if(transitionType == "leftSideBar") {
                leftSideBar(widget.clone(true, true).removeAttr("id"))
            } else if(transitionType == "drawer") {
                if(pageBody.hasClass("with-drawer")) {
                    drawerClose();
                } else {
                    drawerOpen(widget.clone(true, true).removeAttr("id"))
                }
            } else {
                if(navigation.hasClass("show")) {
                    responsiveMenuManager.close('navigation');
                } else {
                    responsiveMenuManager.open(function() {
                        menuBtn.addClass("close");
                        navigation.addClass("show responsive-navigation")
                    }, function(){
                        menuBtn.removeClass("close");
                        navigation.removeClass("show responsive-navigation");
                    }, 'navigation')
                }
            }
        });
    })
}

$(function() {
    bindNavigationWidget()
});

///////////Search Widget////////

function widgetSearch(){

    if($(".widget-search .expandble-search-full-wrap").length) {
        var searchWidget = $(".widget-search .expandble-search-full-wrap").closest(".widget-search");
        if(searchWidget.find(".expandble-search-full-wrap").is(".quick-preview-dropdown")) {
            searchWidget.addClass("quick-preview-dropdown");
        } else if(searchWidget.find(".expandble-search-full-wrap").is(".slide-in-search-panel")) {
            searchWidget.addClass("slide-in-search-panel");
        } else {
            searchWidget.addClass("expanded");
        }
    }

    if($(".widget-search .quick-preview-responsive-version").length) {
        var className;
        try {
            className = $(".widget-search .quick-preview-responsive-version").attr("class").split(" ").last();
        } catch (e) {
            console.log(e.message)
        }
        var searchWidget = $(".widget-search .quick-preview-responsive-version").closest(".widget-search");
        searchWidget.addClass("responsive-quick-view-search-widget");
        if(className) {
            searchWidget.addClass(className);
        }
    }

    $(".elastic-search-result-page-submit-button").unbind().on("click", function () {
        var form = this.jqObject.closest("form.search-result-page-search-input-box");
        var searchText = form.find("input.search-result-page-input-text").val();
        if(form.find("input[name='searchWidgetId']").length) {
            window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + form.find("input[name='searchWidgetId']").val() + "&query=" + searchText;
        } else {
            window.location.href = app.baseUrl + "lookup/searchResultPage?query=" + searchText;
        }
    });

    $("form.search-result-page-search-input-box").submit(function (e) {
        e.preventDefault();
        var form = this.jqObject;
        var searchText = form.find("input.search-result-page-input-text").val();
        if(form.find("input[name='searchWidgetId']").length) {
            window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + form.find("input[name='searchWidgetId']").val() + "&query=" + searchText;
        } else {
            window.location.href = app.baseUrl + "lookup/searchResultPage?query=" + searchText;
        }
    });

    $(".widget-search .see-all-result").unbind().on("click", function () {
        var searchWidget = this.jqObject.closest(".widget-search");
        var searchText = searchWidget.find("input[name='query']").val();
        var widgetId = searchWidget.attr("widget-id");
        window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
    });

    // Search on Enter key press in search-text input
    $(".widget-search input.search-text").unbind('keypress').on("keypress", function (e) {
        if (e.which === 13) { // Enter key
            var searchWidget = $(this).closest(".widget-search");
            var searchText = $(this).val();
            var widgetId = searchWidget.attr("widget-id");
            window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
        }
    });

    // Search on click of search-icon
    $(".widget-search .search-icon").unbind().on("click", function () {
        var searchWidget = $(this).closest(".widget-search");
        var searchText = searchWidget.find("input.search-text").val();
        var widgetId = searchWidget.attr("widget-id");
        window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
    });

    $(".widget-search .search-menu-button").unbind().on("click", function () {
        var searchWidget = this.jqObject.closest(".widget-search");
        var widgetSearchEvents = function(searchWidget, ignoreClose = false) {
            if( $(".widget-search .search-menu-button").closest(".widget-search.fee-not-editable").length == 0){
                var $this = searchWidget.find(".search-menu-button"), searchForm = searchWidget.find(".search-form");
                if (searchForm.hasClass("show") && !ignoreClose) {
                    responsiveMenuManager.close('search');
                    $("#webcommander-page").removeClass("elastic-search-popup-open");
                } else if(!ignoreClose) {
                    var searchParams = window.location.search.slice(1).split('&').reduce(function _reduce(a, b) {b = b.split('=');a[b[0]] = decodeURIComponent(b[1]);
                        return a;
                    }, {});
                    responsiveMenuManager.open(function () {
                        $this.addClass("close");
                        if(!searchForm.hasClass("empty-suggestions")) {
                            searchForm.addClass("show");
                            if(searchForm.is(".expanded-search-form")) {
                                $("#webcommander-page").addClass("expanded-elastic-search-popup-open");
                            }
                            var searchText = searchParams.name ? searchParams.name.replaceAll("+", " ") : ""
                            searchForm.find("#elastic-search-text").val(searchText);
                            if(searchForm.is(".slide-in-search-form")) {
                                searchForm.animate({right: '0px'});
                            } else {
                                searchForm.fadeIn();
                            }
                            searchForm.find(".search-content").show();
                            $("#webcommander-page").addClass("elastic-search-popup-open");
                        }
                    }, function () {
                        searchForm.removeClass("show");
                        $("#webcommander-page").removeClass("expanded-elastic-search-popup-open");
                        $(".widget-search .search-menu-button").removeClass("close");
                        if(searchForm.is(".slide-in-search-form")) {
                            searchForm.animate({right: '-150%'});
                        } else {
                            searchForm.fadeOut();
                        }
                        $("#webcommander-page").removeClass("elastic-search-popup-open");
                    }, 'search')
                }
            }

            searchWidget.find('.search-category-block-view').unbind().on('click', function() {
                var url = this.jqObject.attr("category-url");
                window.location.href = app.baseUrl + "category/" + url;
            });

            var initialSearchSubmission = function() {
                var searchText = searchWidget.find("input[name='query']").val();
                var loaderPanel = searchWidget.find("form.expandble-search-full-wrap");
                loaderPanel.find(".expanded-search-container-wrapper").loader("elastic-search-loader");
                bm.ajax({
                    url: app.baseUrl + "lookup/initialSearch",
                    dataType: 'html',
                    data: loaderPanel.serializeObject(),
                    success: function(resp) {
                        searchWidget.find(".expanded-search-container-wrapper").html(resp);
                        loaderPanel.find(".expanded-search-container-wrapper").loader(false);
                        searchWidget.find(".see-all-result").unbind().on("click", function () {
                            var widgetId = searchWidget.attr("widget-id");
                            window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
                        });

                        widgetSearchEvents(searchWidget, true);
                    },
                    error: function() {
                        // Clear loader on failure/timeout so the panel doesn't spin forever.
                        loaderPanel.find(".expanded-search-container-wrapper").loader(false);
                    }
                });
            }

            var searchSubmissionForInitialState = function() {
                var loaderPanel = searchWidget.find("form.expandble-search-full-wrap");
                var widgetId = searchWidget.attr("widget-id");
                loaderPanel.find(".expanded-search-container-wrapper").loader("elastic-search-loader");
                bm.ajax({
                    url: app.baseUrl + "lookup/initialSearchState",
                    dataType: 'html',
                    data: {widgetId: widgetId},
                    success: function(resp) {
                        searchWidget.find(".expanded-search-container-wrapper").html(resp);
                        loaderPanel.find(".expanded-search-container-wrapper").loader(false);
                        searchWidget.find(".see-all-result").unbind().on("click", function () {
                            var widgetId = searchWidget.attr("widget-id");
                            var searchText = searchWidget.find("input[name='query']").val();
                            window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
                        });
                        widgetSearchEvents(searchWidget, true);
                    },
                    error: function() {
                        // Clear the loader so the panel doesn't spin forever when the
                        // request fails or times out (e.g. Elasticsearch unavailable).
                        loaderPanel.find(".expanded-search-container-wrapper").loader(false);
                    }
                });
            }

            var bindSearchCloseEvents = function(widget) {
                widget.find(".expandble-search-full-wrap .close-icon").unbind().on("click", function () {
                    // searchWidget.find("input[name='query']").val("");
                    searchWidget.find(".search-content").hide();
                    responsiveMenuManager.close('search');
                    $("#webcommander-page").removeClass("elastic-search-popup-open");
                });

                widget.find(".expandble-search-full-wrap .expanded-close-icon").unbind().on("click", function () {
                    searchWidget.find("input[name='query']").val("");
                    searchWidget.find(".expanded-close-icon").hide();
                    searchSubmissionForInitialState(searchWidget);
                });

                widget.find(".expandble-search-full-wrap .right-side-close").unbind().on("click", function (e) {
                    searchWidget.find(".expandble-search-full-wrap #elastic-search-text").val('');
                    searchWidget.find(".right-side-search").show();
                    searchWidget.find(".right-side-close").hide();
                    searchSubmissionForInitialState();
                });

                $("#webcommander-page").on("click", function(e){
                    if(!($(e.target).closest('.search-menu-button').length) && !($(e.target).closest('.expandble-search-full-wrap').length) && !($(e.target).closest('.search-form.expanded-search-form').length)) {
                        // searchWidget.find("input[name='query']").val("");
                        searchWidget.find(".search-content").hide();
                        responsiveMenuManager.close('search');
                        $("#webcommander-page").removeClass("elastic-search-popup-open");
                    }
                });
            }

            var searchTimer;
            $('.widget-search #elastic-search-text').unbind().on('input', function() {
                clearTimeout(searchTimer);
                var searchText = $(this).val().trim();
                var searchWidget = this.jqObject.closest(".widget-search");
                if(searchText.length) {
                    searchWidget.find(".right-side-search").hide();
                    searchWidget.find(".right-side-close").show();
                    searchWidget.find(".expanded-close-icon").show();
                } else {
                    searchWidget.find(".right-side-search").show();
                    searchWidget.find(".right-side-close").hide();
                    searchWidget.find(".expanded-close-icon").hide();
                }
                if(searchText.length > 1) {
                    searchTimer = setTimeout(function() {
                        initialSearchSubmission();
                    }, 300); // Wait 300ms after user stops typing
                } else if(searchText.length === 0) {
                    searchTimer = setTimeout(function() {
                        searchSubmissionForInitialState();
                    }, 300); // Wait 300ms after user stops typing
                }
            });

            $(".widget-search .expanded-view .popular-search-suggestion, .widget-search .slide-in-view .popular-search-suggestion").unbind().on("click", function () {
                var searchText = this.jqObject.text();
                searchWidget.find("#elastic-search-text").val(searchText);
                searchWidget.find(".expanded-close-icon").show();
                searchWidget.find(".right-side-search").hide();
                searchWidget.find(".right-side-close").show();
                initialSearchSubmission();
            });


            bindSearchCloseEvents($(".widget-search"));
        }
        widgetSearchEvents(searchWidget);
    });

    var isQuickView = $(".widget-search .quick-preview-search-input-text");
    if(isQuickView.length) {
        var isResponsive = $(".widget-search.responsive-quick-view-search-widget");
        if(!isResponsive.length) {
            $(".widget-search .quick-preview-search-input-text").unbind().on("focus", function () {
                var parentDom = this.jqObject.closest(".expandble-search-full-wrap");
                if(!parentDom.length) {
                    var searchWidget = this.jqObject.closest(".widget-search");
                    var widgetSearchEvents = function(searchWidget, ignoreClose = false) {
                        if( $(".widget-search .search-menu-button").closest(".widget-search.fee-not-editable").length == 0){
                            var $this = searchWidget.find(".search-menu-button"), searchForm = searchWidget.find(".search-form");
                            if(!ignoreClose) {
                                var searchParams = window.location.search.slice(1).split('&').reduce(function _reduce(a, b) {b = b.split('=');a[b[0]] = decodeURIComponent(b[1]);
                                    return a;
                                }, {});
                                responsiveMenuManager.open(function () {
                                    $this.addClass("close");
                                    searchForm.addClass("show");
                                    if(!searchForm.hasClass("empty-suggestions")) {
                                        var searchText = searchParams.name ? searchParams.name.replaceAll("+", " ") : ""
                                        searchForm.find("#elastic-search-text").val(searchText);
                                        if(searchForm.is(".slide-in-search-form")) {
                                            searchForm.animate({right: '0px'});
                                        } else {
                                            if(searchForm.is(":hidden")) {
                                                searchForm.fadeIn();
                                            }
                                        }
                                        searchForm.find(".search-content").show();
                                        $("#webcommander-page").addClass("elastic-search-popup-open");
                                    }
                                }, function () {
                                    $(".widget-search .search-menu-button").removeClass("close");
                                    searchForm.removeClass("show");
                                    if(searchForm.is(".slide-in-search-form")) {
                                        searchForm.animate({right: '-150%'});
                                    } else {
                                        if(searchForm.find(".quick-preview-search-input-box").is(":visible")) {
                                            searchForm.fadeOut();
                                        }
                                    }
                                    $("#webcommander-page").removeClass("elastic-search-popup-open");
                                }, 'search')
                            }
                        }

                        var bindSearchCloseEvents = function(widget) {
                            widget.find(".quick-preview-search-input-box .close-btn").unbind().on("click", function () {
                                // searchWidget.find("input[name='query']").val("");
                                searchWidget.find(".search-content").hide();
                                responsiveMenuManager.close('search');
                                $("#webcommander-page").removeClass("elastic-search-popup-open");
                            });

                            $("#webcommander-page").on("click", function(e){
                                if(!($(e.target).closest('.search-menu-button').length) && !($(e.target).closest('.expandble-search-full-wrap').length) && !($(e.target).closest('.search-form.expanded-search-form').length) && !($(e.target).closest('.quick-preview-search-input-box').length)) {
                                    // searchWidget.find("input[name='query']").val("");
                                    searchWidget.find(".search-content").hide();
                                    responsiveMenuManager.close('search');
                                    $("#webcommander-page").removeClass("elastic-search-popup-open");
                                }
                            });
                        }

                        bindSearchCloseEvents($(".widget-search"));
                    }
                    widgetSearchEvents(searchWidget);
                }
            });
        } else {
            $(".widget-search .quick-preview-search-input-text").unbind().on("click", function () {
                var searchWidget = this.jqObject.closest(".widget-search");
                var searchForm = searchWidget.find(".search-form");
                if (searchForm.hasClass("show")) {
                    if(searchWidget.find(".expandble-search-full-wrap .quick-preview-search-input-text").is(":visible")) {
                        searchForm.removeClass("show");
                        searchWidget.find("form.quick-preview-search-input-box").removeClass("close");
                        searchForm.fadeOut();
                        $("#webcommander-page").removeClass("elastic-search-popup-open");
                    }
                } else {
                    searchForm.addClass("show");
                    searchWidget.find("form.quick-preview-search-input-box").addClass("close");
                    searchForm.fadeIn();
                    $("#webcommander-page").addClass("elastic-search-popup-open");
                }
            });

            $(".widget-search .expandble-search-full-wrap .quick-preview-search-input-text").unbind().on("click", function (e) {
                e.preventDefault();
            });
        }
    }

    $("#webcommander-page").unbind().on("click", function(e){
        if(!($(e.target).closest('.quick-preview-search-input-text').length) && !($(e.target).closest('.quick-view-close-btn').length) && !($(e.target).closest('.expandble-search-full-wrap').length) && !($(e.target).closest('.search-form.expanded-search-form').length) && !($(e.target).closest('.search-menu-button').length)) {
            var searchWidget = this.jqObject.find(".widget-search");
            var searchForm = searchWidget.find(".search-form");
            searchForm.removeClass("show");
            searchWidget.find("form.quick-preview-search-input-box").removeClass("close");
            searchForm.fadeOut();
            $("#webcommander-page").removeClass("elastic-search-popup-open");
        }
    });

    var initialSearchSubmission = function(searchWidget) {
        var searchText = "";
        var isResponsiveView = searchWidget.is(".responsive-quick-view-search-widget");
        if(isResponsiveView && searchWidget.find(".quick-preview-search-form .quick-preview-search-input-text").is(":visible")) {
            searchText = searchWidget.find(".quick-preview-search-form .quick-preview-search-input-text").val();
        } else {
            searchText = searchWidget.find(".quick-preview-search-input-text").val();
        }

        var loaderPanel = searchWidget.find("form.expandble-search-full-wrap");
        var params = $.extend(loaderPanel.serializeObject(), {query: searchText});
        loaderPanel.find(".quick-preview-distinct-search-container").loader("elastic-search-loader");
        bm.ajax({
            url: app.baseUrl + "lookup/initialSearch",
            dataType: 'html',
            data: params,
            success: function(resp) {
                searchWidget.find(".quick-preview-distinct-search-container").html(resp);
                if(searchWidget.find(".quick-view-close-btn").length) {
                    searchWidget.find(".quick-view-close-btn").show();
                }
                var input = searchWidget.find("#elastic-search-text");
                if(input.length) {
                    input.focus();
                    input.nat.setSelectionRange(input.val().length, input.val().length);
                } else {
                    if(isResponsiveView) {
                        input = searchWidget.find(".quick-preview-search-form .quick-preview-search-input-text");
                    } else {
                        input = searchWidget.find(".quick-preview-search-input-text");
                    }
                    if(input.length) {
                        input.focus();
                        input.nat.setSelectionRange(input.val().length, input.val().length);
                    }
                }
                loaderPanel.loader(false);
                searchWidget.find(".see-all-result").unbind().on("click", function () {
                    var widgetId = searchWidget.attr("widget-id");
                    window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
                });

                searchWidget.find('.widget-search .search-category-block-view').unbind().on('click', function() {
                    var url = this.jqObject.attr("category-url");
                    window.location.href = app.baseUrl + "category/" + url;
                });

                searchWidget.find(".expandble-search-full-wrap .expanded-close-icon").unbind().on("click", function () {
                    searchWidget.find("input[name='query']").val("");
                    searchWidget.find(".expanded-close-icon").hide();
                    searchSubmissionForInitialState(searchWidget);
                });

                searchWidget.find(".expandble-search-full-wrap .close-icon").unbind().on("click", function () {
                    // searchWidget.find("input[name='query']").val("");
                    searchWidget.find(".search-content").hide();
                    responsiveMenuManager.close('search');
                    $("#webcommander-page").removeClass("elastic-search-popup-open");
                });

                searchWidget.find(".quick-view-close-btn").unbind().on("click", function () {
                    var searchWidget = this.jqObject.closest(".widget-search");
                    $(".quick-preview-search-input-text").val("");
                    searchSubmissionForInitialState(searchWidget);
                    this.jqObject.hide();
                });

                searchWidget.find('.search-text.quick-preview-search-input-text').on('input', function() {
                    var searchWidget = this.jqObject.closest(".widget-search");
                    clearTimeout(searchTimer);
                    var searchText = $(this).val().trim();
                    if(searchText.length > 1) {
                        searchTimer = setTimeout(function() {
                            initialSearchSubmission(searchWidget);
                        }, 300); // Wait 300ms after user stops typing
                    } else if(searchText.length === 0) {
                        searchWidget.find(".quick-view-close-btn").hide();
                        searchTimer = setTimeout(function() {
                            searchSubmissionForInitialState(searchWidget);
                        }, 300); // Wait 300ms after user stops typing
                    }
                });
            }
        });
    }

    var searchSubmissionForInitialState = function(searchWidget) {
        var loaderPanel = searchWidget.find("form.expandble-search-full-wrap");
        var widgetId = searchWidget.attr("widget-id");
        loaderPanel.find(".quick-preview-distinct-search-container").loader("elastic-search-loader");
        bm.ajax({
            url: app.baseUrl + "lookup/initialSearchState",
            dataType: 'html',
            data: {widgetId: widgetId},
            success: function(resp) {
                searchWidget.find(".quick-preview-distinct-search-container").html(resp);
                var input = searchWidget.find("#elastic-search-text");
                if(input.length) {
                    input.focus();
                    input.nat.setSelectionRange(input.val().length, input.val().length);
                }

                if(!input.length) {
                    if(searchWidget.is(".responsive-quick-view-search-widget")) {
                        input = searchWidget.find(".quick-preview-search-form .quick-preview-search-input-text");
                    } else {
                        input = searchWidget.find(".quick-preview-search-input-text");
                    }

                    if(input.length) {
                        input.val("");
                        if(input.length) {
                            input.focus();
                            input.nat.setSelectionRange(input.val().length, input.val().length);
                        }

                        searchWidget.find(".quick-preview-search-wrap .popular-search-suggestion").unbind().on("click", function () {
                            var searchText = this.jqObject.text();
                            var searchWidget = this.jqObject.closest(".widget-search");
                            searchWidget.find(".search-text.quick-preview-search-input-text").val(searchText);
                            initialSearchSubmission(searchWidget);
                        });
                    }
                }

                searchWidget.find('.widget-search .search-category-block-view').unbind().on('click', function() {
                    var url = this.jqObject.attr("category-url");
                    window.location.href = app.baseUrl + "category/" + url;
                });

                searchWidget.find('.search-text.quick-preview-search-input-text').on('input', function() {
                    var searchWidget = this.jqObject.closest(".widget-search");
                    clearTimeout(searchTimer);
                    var searchText = $(this).val().trim();
                    if(searchText.length > 1) {
                        searchTimer = setTimeout(function() {
                            initialSearchSubmission(searchWidget);
                        }, 300); // Wait 300ms after user stops typing
                    } else if(searchText.length === 0) {
                        searchWidget.find(".quick-view-close-btn").hide();
                        searchTimer = setTimeout(function() {
                            searchSubmissionForInitialState(searchWidget);
                        }, 300); // Wait 300ms after user stops typing
                    }
                });

                searchWidget.find(".see-all-result").unbind().on("click", function () {
                    var widgetId = searchWidget.attr("widget-id");
                    var searchText = searchWidget.find('.search-text.quick-preview-search-input-text').val();
                    window.location.href = app.baseUrl + "lookup/searchResultPage?widgetId=" + widgetId + "&query=" + searchText;
                });
                loaderPanel.loader(false);
            }
        });
    }

    var searchTimer;
    $('.widget-search .search-text.quick-preview-search-input-text').on('input', function() {
        var searchWidget = this.jqObject.closest(".widget-search");
        clearTimeout(searchTimer);
        var searchText = $(this).val().trim();
        if(searchText.length > 1) {
            searchTimer = setTimeout(function() {
                initialSearchSubmission(searchWidget);
            }, 300); // Wait 300ms after user stops typing
        } else if(searchText.length === 0) {
            searchWidget.find(".quick-view-close-btn").hide();
            searchTimer = setTimeout(function() {
                searchSubmissionForInitialState(searchWidget);
            }, 300); // Wait 300ms after user stops typing
        }
    });

    $(".widget-search .quick-preview-search-wrap .popular-search-suggestion").unbind().on("click", function () {
        var searchText = this.jqObject.text();
        var searchWidget = this.jqObject.closest(".widget-search");
        searchWidget.find(".search-text.quick-preview-search-input-text").val(searchText);
        initialSearchSubmission(searchWidget);
    });

    $(".quick-view-close-btn").unbind().on("click", function () {
        var searchWidget = this.jqObject.closest(".widget-search");
        $(".quick-preview-search-input-text").val("");
        searchSubmissionForInitialState(searchWidget);
        this.jqObject.hide();
    });

    var searchSuggestionOnselect = function (element, suggestion) {
        if (!$(element.value).is(".elastic-search-link")){
            this.closest("form").jqObject.submit()
        }
    };

    $('.search-category-block-view').unbind().on('click', function() {
        var url = this.jqObject.attr("category-url");
        window.location.href = app.baseUrl + "category/" + url;
    });
}

$(function () {
    widgetSearch()
    bindLazySearchSuggestions()
});

// HWC-4152: the live site ships the search widget WITHOUT embedded suggestion data
// (data-lazy-suggestions="true"); the first interaction fetches the initial-state
// fragment from the existing lookup/initialSearchState endpoint and mounts it.
function bindLazySearchSuggestions() {
    $(".widget-search").each(function () {
        var widgetEl = this;
        var wrap = $(widgetEl).find("form.expandble-search-full-wrap[data-lazy-suggestions='true']");
        if (!wrap.length) {
            return;
        }
        var loadInitialState = function () {
            if (wrap.attr("data-lazy-suggestions") !== "true") {
                return;
            }
            wrap.attr("data-lazy-suggestions", "loading");
            var searchWidget = $(widgetEl);
            var container = searchWidget.find(".expanded-search-container-wrapper");
            if (!container.length) {
                container = searchWidget.find(".quick-preview-distinct-search-container");
            }
            if (!container.length) {
                wrap.attr("data-lazy-suggestions", "true");
                return;
            }
            if (container.loader) {
                container.loader("elastic-search-loader");
            }
            bm.ajax({
                url: app.baseUrl + "lookup/initialSearchState",
                dataType: 'html',
                data: {widgetId: searchWidget.attr("widget-id")},
                success: function (resp) {
                    container.html(resp);
                    // enhance mounted tabs/selects (chunk stubs replay if their chunk is lazy)
                    if (container.updateUi) {
                        try { container.updateUi(); } catch (e) { console.error(e); }
                    }
                    if (container.loader) {
                        container.loader(false);
                    }
                    wrap.attr("data-lazy-suggestions", "loaded");
                    // rebind the freshly mounted suggestion content
                    widgetSearch();
                    if (window.site && site.hook) {
                        site.hook.fire("search-suggestions-mounted", container);
                    }
                },
                error: function () {
                    if (container.loader) {
                        container.loader(false);
                    }
                    // allow a retry on the next interaction (once-listeners are spent)
                    wrap.attr("data-lazy-suggestions", "true");
                    bindListeners();
                }
            });
        };
        var bindListeners = function () {
            ["focusin", "pointerdown"].forEach(function (evt) {
                widgetEl.addEventListener(evt, loadInitialState, {once: true, capture: true, passive: true});
            });
        };
        bindListeners();
    });
}


$(window).resize(function() {
    if($(window).width() != site.width && $(window).height() != site.height){
        responsiveMenuManager.close()
        site.width = $(window).width()
        site.height = $(window).height()
    }
});

function shareOnSocialMedea(type, sharing_url, sharing_name, sharing_img) {
    switch(type) {
        case 'twitter':
            window.open('https://twitter.com/intent/tweet?text=' + sharing_name + ' ' + encodeURIComponent(sharing_url), 'sharertwt', 'toolbar=0,status=0,width=640,height=445');
            break;
        case 'facebook':
            window.open('http://www.facebook.com/sharer.php?u=' + sharing_url, 'sharer', 'toolbar=0,status=0,width=660,height=445');
            break;
        case 'messenger':
            var url = "https://www.facebook.com/dialog/send?app_id=" + ((window.app && app.fb_app_id) || 0) +
                "&link=" + encodeURIComponent(sharing_url) + "&redirect_uri=" + encodeURIComponent(sharing_url);
            window.open(url, "_blank", "width=480, height=360")
            break;
        case 'linkedin':
            window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + sharing_url + "title=" + sharing_name, 'sharer', 'toolbar=0,status=0,width=660,height=445');
            break;
        case 'google-plus':
            window.open('https://plus.google.com/share?url=' + sharing_url, 'sharer', 'toolbar=0,status=0,width=660,height=445');
            break;
        case 'pinterest':
            var img_url = sharing_img;
            window.open('http://www.pinterest.com/pin/create/button/?media=' + img_url + '&url=' + sharing_url, 'sharerpinterest', 'toolbar=0,status=0,width=660,height=445');
            break;
    }
}

function tellAFriendAboutProduct(productId) {
    bm.ajax({
        url: app.baseUrl + "shop/tellFriend",
        dataType: 'html',
        type: 'post',
        data: {productId: productId},
        success: function(resp) {
            var content = $(resp);
            content.find(".tell-friend-popup").form({
                ajax: true,
                preSubmit: function(ajaxSettings) {
                    $.extend(ajaxSettings, {
                        success: function(resp){
                            var successPopupContent = $(resp.html);
                            renderGlobalSitePopup(successPopupContent, {clazz: "tell-friend-success"})
                        },
                        error: function(a, b, resp) {
                            renderMessage(content.find(".body .message-container"), resp.message, "error")
                        }
                    })
                }
            });
            renderGlobalSitePopup(content, {clazz: "tell_friend_popup"});
        }
    })
}


var addBulkProductFromProductListInCart = function (externalProperties, callback) {
    var _this = $(this);
    var blukQtyInputs = $(".product-quantity-selector-bulk-from-product-list:visible");
    var isPossibleAddToCart = $("input.product-quantity-selector-bulk-from-product-list:visible.validation-error").length;
    blukQtyInputs.each(function () {
        if(this.jqObject.val() != "0"){
            isPossibleAddToCart = true;
            return false
        }
    });
    if(isPossibleAddToCart){
        var productDataList = [];
        $(".product-quantity-selector-bulk-from-product-list:visible").each(function () {
            var productRow = $(this);
            var storeId = _this.attr("storeId");
            var data = {
                productId: productRow.attr("product-id"),
                quantity: productRow.val(),
                'config.variation': productRow.attr("product-variation")
            };
            storeId ? data.storeId = storeId : "";
            // collectCartData(container, data, false);
            productDataList.push(data);
        });
        bm.ajax({
            url: app.baseUrl + "cart/addBulkProductToCart",
            data: {productDataList: JSON.stringify(productDataList)},
            type: 'post',
            success: function(resp) {
                var content = $(resp.html);
                if(resp.status == 'added') {
                    renderAddToCartPopup(content);
                } else if(resp.status == 'redirect-to') {
                    window.location.href = app.baseUrl + "product/" + resp.url
                }else if(resp.status == 'restrict') {
                    bm.confirm(resp.alrtMessage, function() {
                        window.location.href =  app.baseUrl + resp.redirectLink
                    },undefined, undefined, { yesButtonTitle: "OK"});
                }
                callback && callback()
            }
        });
    }
}

var ProductViewSwitcher = (function() {
    function ProductViewSwitcher(listingBlock) {
        var _self = this, switchers = listingBlock.find(".view-switchers > div");
        this.listingBlock = listingBlock
        this.id = listingBlock.attr("id")
        this.displayType = listingBlock.attr("display-type")
        this.showOnHover = listingBlock.attr("show-on-hover")
        switchers.on("click", function() {
            var $this = $(this);
            if($this.is(".active")) {
                return
            }
            _self.switchDisplayType($this.attr("value"))
        });
        // Category pages AND product widgets open in the admin's DEFAULT display type on every load (ignore any
        // persisted per-visitor choice) — reload keeps showing the default. Manual switching still works during
        // the visit. Other standalone listings keep remembering the last view.
        var isCategoryPage = this.listingBlock.closest(".category-details").length > 0;
        var isProductWidget = this.listingBlock.attr("isWidget") == "true";
        var selectedDisplayType = (isCategoryPage || isProductWidget) ? null : localStorage.getItem(this.id)
        if(selectedDisplayType && selectedDisplayType != this.displayType && switchers.length) {
            _self.switchDisplayType(selectedDisplayType)
        }
    }

    var _p = ProductViewSwitcher.prototype;

    _p._switchToList= function() {
        // if(this.showOnHover == "true") {
        //     this.listingBlock.find(".product-block").each(function() {
        //         var $this = $(this), addBtn = $this.find(".btn-add")
        //         $this.find(".price-waper").after(addBtn)
        //     })
        // }
        var parent = this.listingBlock;
        var isWidget = parent.attr('isWidget');
        if(isWidget == "true"){
            var tablularView = parent.find(".tabular-product-view");
            if(!tablularView.hasClass('hide-tabular-product-view')){
                tablularView.addClass('hide-tabular-product-view')
            }
            var tablularButton = parent.find(".add-to-cart-multi-select-fixed-button");
            if(!tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.addClass('hide-add-to-cart-multi-select-fixed-button')
            }
            parent.find(".normal-product-view").removeClass("hide-product-block-normal");
        }else{
            var tablularView = $(".tabular-product-view");
            if(!tablularView.hasClass('hide-tabular-product-view')){
                tablularView.addClass('hide-tabular-product-view')
            }
            var tablularButton = $(".add-to-cart-multi-select-fixed-button");
            if(!tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.addClass('hide-add-to-cart-multi-select-fixed-button')
            }
            $(".normal-product-view").removeClass("hide-product-block-normal");
        }

    };

    _p._switchToImage = function() {
        // btn-add relocation removed — server renders buttons in .btn-add-placeholder for all views; old .append() reparented .btn-add out of .wc-product-actions-group (broke DOM, no reverse on switch).
        var parent = this.listingBlock;
        var isWidget = parent.attr('isWidget');
        if(isWidget == "true"){
            var tablularView = parent.find(".tabular-product-view");
            if(!tablularView.hasClass('hide-tabular-product-view')){
                tablularView.addClass('hide-tabular-product-view')
            }
            var tablularButton = parent.find(".add-to-cart-multi-select-fixed-button");
            if(!tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.addClass('hide-add-to-cart-multi-select-fixed-button')
            }
            parent.find(".normal-product-view").removeClass("hide-product-block-normal");
        }else{
            var tablularView = $(".tabular-product-view");
            if(!tablularView.hasClass('hide-tabular-product-view')){
                tablularView.addClass('hide-tabular-product-view')
            }
            var tablularButton = $(".add-to-cart-multi-select-fixed-button");
            if(!tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.addClass('hide-add-to-cart-multi-select-fixed-button')
            }
            $(".normal-product-view").removeClass("hide-product-block-normal");
        }
    };

    _p._switchToTabular = function() {
        var parent = this.listingBlock;
        var isWidget = parent.attr('isWidget');
        if(isWidget == "true"){
            parent.find(".normal-product-view").addClass("hide-product-block-normal");
            var tablularView = parent.find(".tabular-product-view");
            if(tablularView.hasClass('hide-tabular-product-view')){
                tablularView.removeClass('hide-tabular-product-view')
            }
            var tablularButton = parent.find(".add-to-cart-multi-select-fixed-button");
            if(tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.removeClass('hide-add-to-cart-multi-select-fixed-button')
            }
        }else{
            parent.find(".normal-product-view").addClass("hide-product-block-normal");
            var tablularView = parent.find(".tabular-product-view");
            if(tablularView.hasClass('hide-tabular-product-view')){
                tablularView.removeClass('hide-tabular-product-view')
            }
            var tablularButton = parent.find(".add-to-cart-multi-select-fixed-button");
            if(tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.removeClass('hide-add-to-cart-multi-select-fixed-button')
            }
        }
    };

    _p._switchToScrollable = function() {
        // Scrollable shows the normal product blocks (horizontal scroll), not the tabular table — mirror image/list.
        var parent = this.listingBlock;
        var isWidget = parent.attr('isWidget');
        if(isWidget == "true"){
            var tablularView = parent.find(".tabular-product-view");
            if(!tablularView.hasClass('hide-tabular-product-view')){
                tablularView.addClass('hide-tabular-product-view')
            }
            var tablularButton = parent.find(".add-to-cart-multi-select-fixed-button");
            if(!tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.addClass('hide-add-to-cart-multi-select-fixed-button')
            }
            parent.find(".normal-product-view").removeClass("hide-product-block-normal");
        }else{
            var tablularView = $(".tabular-product-view");
            if(!tablularView.hasClass('hide-tabular-product-view')){
                tablularView.addClass('hide-tabular-product-view')
            }
            var tablularButton = $(".add-to-cart-multi-select-fixed-button");
            if(!tablularButton.hasClass('hide-add-to-cart-multi-select-fixed-button')){
                tablularButton.addClass('hide-add-to-cart-multi-select-fixed-button')
            }
            $(".normal-product-view").removeClass("hide-product-block-normal");
        }
    };

    _p.switchDisplayType = function(displayType) {
        var oldType = this.displayType;
        this.listingBlock.removeClass(oldType + "-view").addClass(displayType+"-view")
        // Keep the responsive marker class (e.g. "image-view-rsp") in sync so per-breakpoint column
        // rules keep matching the active view after a switch.
        if (this.listingBlock.hasClass(oldType + "-view-rsp")) {
            this.listingBlock.removeClass(oldType + "-view-rsp").addClass(displayType + "-view-rsp")
        }
        // The widget wrapper carries `fee-widget-product-<type>-view`, which gates almost every per-view
        // rule in ecommerce.css (display:grid, image sizing, the [no-of-column] grid rules). The switcher
        // only rewrote the inner `.product-view` class, so a list->image switch left the wrapper on
        // `fee-widget-product-list-view` and image-view styling never applied. Sync the wrapper too.
        var _wrapperSuffix = { image: "image", list: "list", tabular: "tabular", scrollable: "scroll" };
        var _wrapper = this.listingBlock.closest(".widget-product");
        if (_wrapper.length) {
            _wrapper.removeClass("fee-widget-product-image-view fee-widget-product-list-view fee-widget-product-scroll-view fee-widget-product-tabular-view")
                .addClass("fee-widget-product-" + (_wrapperSuffix[displayType] || displayType) + "-view");
        }
        // Per-view column count: the category page configures grid vs list columns separately (data-cols-image /
        // data-cols-list). Apply the target view's value so switching views uses its own no-of-column, not the
        // default view's. Listings without these attrs (product widgets) are unchanged.
        var _viewCols = this.listingBlock.attr("data-cols-" + displayType) || this.listingBlock.closest(".product-container").attr("data-cols-" + displayType);
        if (_viewCols) { this.listingBlock.attr("no-of-column", _viewCols); }
        // Per-view row/column gap: mirror the per-view column handling above. The desktop gap flows through the
        // CSS custom properties --product-row-gap / --product-col-gap (consumed by .content.product-content), so
        // apply the target view's gap from data-rowgap-<view> / data-colgap-<view> on switch. No-op if attrs absent.
        var _rg = this.listingBlock.attr("data-rowgap-" + displayType) || this.listingBlock.closest(".product-container").attr("data-rowgap-" + displayType);
        var _cg = this.listingBlock.attr("data-colgap-" + displayType) || this.listingBlock.closest(".product-container").attr("data-colgap-" + displayType);
        var _pvEl = this.listingBlock[0];
        if (_pvEl && _rg) { try { _pvEl.style.setProperty("--product-row-gap", _rg + "px"); } catch (e) {} }
        if (_pvEl && _cg) { try { _pvEl.style.setProperty("--product-col-gap", _cg + "px"); } catch (e) {} }
        localStorage.setItem(this.id, displayType)
        this["_switchTo" + displayType.capitalize()]()
        this.listingBlock.find(".view-switchers > div.active").removeClass("active")
        this.listingBlock.find(".view-switchers > div[value=" + displayType + "]").addClass("active")
        this.displayType = displayType;
    };
    return ProductViewSwitcher
}());

var CategoryTabSwitcher = (function () {
    function CategoryTabSwitcher(listingBlock) {
        var $tabBar = listingBlock.find('.wc-category-tabs');
        if (!$tabBar.length) return;
        // Active-tab products are paginated SERVER-side (WidgetService.renderProductWidget reads
        // prwd-<id>-tab), so a tab switch needs a server render — there is no client-side filtering
        // or "Showing X of Y" relabeling here. HWC-3209: that render is fetched over AJAX and
        // swapped into this listing; NAVIGATING to it threw the visitor back to the top of the
        // document. The tab id is still written to the address bar (replaceState — no navigation,
        // no scroll) because the paginator and the sort select build their URLs from
        // window.location: without it, paging inside a tab would fall back to the first tab.
        function urlPrefixFor() {
            var pfx = $tabBar.closest('.product-view').find('paginator').first().attr('data-urlprefix');
            if (pfx) return pfx;
            var $sort = listingBlock.find('.product-sorting').first();
            if ($sort.length && $sort.attr('urlprefix')) return $sort.attr('urlprefix');
            var id = listingBlock.attr('id') || '';
            var m = id.match(/(\d+)$/);
            return m ? ('prwd-' + m[1]) : null;
        }
        function tabUrlFor(prefix, tabId) {
            var cleanHref = window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
            var url = bm.path(cleanHref);
            url.query[prefix + '-tab'] = tabId;
            // Switching tab returns the listing to its default state, not the state left over
            // from the previous tab: page 1, default sort, default view.
            delete url.query[prefix + '-offset'];   // back to page 1
            delete url.query[prefix + '-sort'];      // sort resets to the widget default (first option)
            return url.full();
        }
        // Fallback for every failure path: the pre-HWC-3209 reload, with the scroll position kept.
        function reloadWithTab(tabUrl) {
            rememberProductListingScroll(listingBlock);
            window.location.href = tabUrl;
        }
        // Re-bind what lived inside the replaced markup, through the same entry points the page
        // uses on load. Quick view re-attaches itself (MutationObserver in quick-view.js).
        function bindSwappedListing($listing) {
            initializeProductWidget();
            initializePagination();
            bindAddToCartClickEvent($listing);
            if (window.attachWishListGlobalEvents) { window.attachWishListGlobalEvents($listing); }
            if (window.bindAddToCompareClickEvent) { window.bindAddToCompareClickEvent($listing); }
            new ProductViewSwitcher($listing);
            new CategoryTabSwitcher($listing);
        }
        $tabBar.off('click.wcCatTab').on('click.wcCatTab', '.wc-category-tab-btn', function () {
            var $btn = $(this);
            if ($btn.hasClass('active')) return;
            var prefix = urlPrefixFor();
            if (!prefix) return;
            var listingId = listingBlock.attr('id');
            // View is persisted per-listing in localStorage by ProductViewSwitcher; clear it so the
            // tab's render falls back to the widget's default display-type (e.g. grid) rather than
            // restoring the previously-selected view.
            try {
                if (listingId) localStorage.removeItem(listingId);
            } catch (e) {}
            var tabUrl = tabUrlFor(prefix, $btn.attr('data-tab-id'));
            // Two cases keep the old reload. (1) A filter widget owns the AJAX re-render of the
            // listings on its page (site-filter.js — the same reason bindCommonWidgetEvents skips
            // initializePagination when one is present), and two owners would fight over one
            // listing. (2) The FEE canvas loads this file too (sitepage.gsp), and swapping markup
            // under the editor's overlays is not this fix's job — Preview is excluded by
            // _isFeeEditing, so it behaves like the live site.
            if (!listingId || $('.widget.widget-filter').length || _isFeeEditing()) {
                reloadWithTab(tabUrl);
                return;
            }
            $tabBar.find('.wc-category-tab-btn').removeClass('active');
            $btn.addClass('active');
            listingBlock.loader();
            bm.ajax({
                url: tabUrl,
                type: 'GET',
                dataType: 'html',
                success: function (data) {
                    // Same fragment-from-the-page-response idiom as load-more-pagination.js.
                    var $fresh = $(data).find("[id='" + listingId + "']").first();
                    if (!$fresh.length) {
                        reloadWithTab(tabUrl);
                        return;
                    }
                    listingBlock.replaceWith($fresh);
                    if (window.history && window.history.replaceState) {
                        window.history.replaceState(null, '', tabUrl);
                    }
                    bindSwappedListing($fresh);
                },
                error: function () {
                    reloadWithTab(tabUrl);
                }
            });
        });
    }
    return CategoryTabSwitcher;
}());

$(function() {
    $('.product-view').each(function() {
        new ProductViewSwitcher($(this))
        new CategoryTabSwitcher($(this))
    })
});

window.fbAsyncInit = function() {
    FB.init({
        appId      : app.fb_app_id,
        cookie     : true,
        xfbml      : true,
        version    : app.fb_api_version
    });
};

function googleAyncInit() {
    if(app.google_client_id) {
        bm.onReady(window, "gapi", function() {
            gapi.load('auth2', function () {
                window.googleAuth2 = gapi.auth2.init({
                    client_id: app.google_client_id,
                    cookiepolicy: 'single_host_origin',
                });
            });
        })
    }
}


function fbLogin(callback){
    FB.login(function(response) {
        if (response.authResponse) {
            console.log('Welcome!  Fetching your information.... ');
            var access_token = response.authResponse.accessToken;
            callback(access_token)
        } else {
            console.log('User cancelled login or did not fully authorize.');
        }
    },{
        scope: 'email,user_location',
        return_scopes: true
    });
}

function googleLogin(callback) {
    googleAuth2.signIn().then(function(googleUser) {
        callback(googleUser.getAuthResponse().id_token)
    });
}

function loginBySocialToken(data) {
    bm.ajax({
        url: app.baseUrl + "customer/doSocialLogin",
        data: data,
        success: function(resp){
            location.href = resp.redirectUrl
        },
        error: function(status, xhr, resp) {
            renderMessage(null, resp.message, "error")
        }
    })
}

function loginSocial(){
    $('.login-with-fb-btn').on("click", function() {
        var $this = $(this), form = $this.parents("form")
        fbLogin(function(access_token) {
            loginBySocialToken({
                token: access_token,
                media: "fb",
                referer: form.find('[name=referer]').val()
            })
        })
    });

    var resendForm = $(".registration-verification-message");
    var resendButton = resendForm.find(".resend-verification-button");
    resendButton.on("click", function (){
        var customerId = resendForm.serializeObject().id;
        bm.ajax({
            type: 'post',
            url: app.baseUrl + 'customer/resendVerification',
            data: { id: customerId },
            success: function (resp) {
                bm.notify(resp.message || $.i18n.prop("resend.email.success"), "success");
            },
            error: function (resp) {
                bm.notify($.i18n.prop("resend.email.fail"), "alert");
            }
        });
    })
    $('.login-with-google-btn').on("click", function() {
        var $this = $(this), form = $this.parents("form")
        googleLogin(function(access_token) {
            loginBySocialToken({
                token: access_token,
                media: "google",
                referer: form.find('[name=referer]').val()
            })
        })
    })


    $('.add-to-cart-multi-select-fixed-button').on("click", function() {
        var selectButton = $(this);
        addBulkProductFromProductListInCart(selectButton)
    });


    bm.onReady(window, "google", {
        ready: function() {
            bm.initAutoAddressSuggest()
        },
        not: function() {}
    });

    var imgWithFocalPoint = $(".wc-image-focuspoint");
    if(imgWithFocalPoint.length){
        // HWC-4151: commerce chunk is page-conditional — lazy-load it on demand
        if ($.fn.focusPoint) {
            imgWithFocalPoint.focusPoint();
        } else if (window.wcLoadJsChunk) {
            wcLoadJsChunk('commerce', function () { imgWithFocalPoint.focusPoint(); });
        }
    }
}

$(function() {
    loginSocial()
});

app.commonFunctionalities = (function() {
    return {
        initializeProductWidget
    }
})();

function  pageCondeVerification(){
    var verificationCode = [];
    var passCodeForm = $(".pass-code-verify-form")
    var mainInputToVerify = passCodeForm.find('#otp-passcode-main')
    var singleCodeInputs = passCodeForm.find(".verification-code .passcode-single-input")
    singleCodeInputs.keyup(function (e) {
        singleCodeInputs.each(function (i) {
            verificationCode[i] = singleCodeInputs[i].value;
            mainInputToVerify.val(verificationCode.join(''));
        });
        if (event.key == 'Backspace') {
            $(this).prev().focus();
        }else if (!$(this).val().trim() == "") {
            $(this).next().focus();
        }
    });
}

$(function() {
    pageCondeVerification()
})

site.hook.register("bind-site-events", function() {
    intiSiteEvents();
});

function intiSiteEvents(){
    initPreviousPageButton()
    bm.initCityValidator($('[name="postCode"]'))
    bindNavigationWidget()
    widgetSearch()
    bindImagePreviewEvents()
    bindCommonWidgetEvents()
    $('.product-view').each(function() {
        new ProductViewSwitcher($(this))
        new CategoryTabSwitcher($(this))
    })
    loginSocial()
    pageCondeVerification()
}


// $(window).on('load', function() {
//     if ($('#preloader-x').length) {
//         $('#preloader-x').delay(350).fadeOut('slow');
//         // $('body').delay(450).css({'overflow':'visible'});
//     }
// });
//
// $(window).on('beforeunload', function() {
//     if ($('#preloader-x').length) {
//         $('#preloader-x').css('display', 'flex');
//         // $('body').css({'overflow':'hidden'});
//     }
// });

$(function() {
    $("body").delegate(".view-virtual-cart-items", "click", function (){
        var cartItems = this.jqObject.attr("cart-items")
        bm.renderSitePopup(app.baseUrl + "shop/viewVirtualCartItems", "Order Details", "", {cartItems: cartItems}, {
            clazz: "pay-remaining-amount-popup view-virtual-cart-items-popup",
            events: {
                content_loaded: function (popup) {
                    var popupBody = popup.el
                    popupBody.find("button.cancel-button").on("click", function (){
                        popup.close()
                    })
                    popupBody.find("button.submit-button").on("click", function (){
                        var paymentData = popupBody.find(".pay-remain-wrapper-from").serializeObject()
                        location.href = app.baseUrl + "shop/duePayment?paymentMethod="+paymentData.paymentMethod
                    })
                }
            },
            beforeSubmit: function () {},
            success: function (_resp) {
            },
            error: function (xhr, status, resp) {
                _self._showStatus(panel, "error", resp.message)
            }
        })
    })

    $("body").delegate(".view-virtual-order-items", "click", function (){
        var orderItems = this.jqObject.attr("cart-items")
        bm.renderSitePopup(app.baseUrl + "shop/viewVirtualOrderItems", "Order Details", "", {orderItems: orderItems}, {
            clazz: "pay-remaining-amount-popup",
            events: {
                content_loaded: function (popup) {
                    var popupBody = popup.el
                    popupBody.find("button.cancel-button").on("click", function (){
                        popup.close()
                    })
                    popupBody.find("button.submit-button").on("click", function (){
                        var paymentData = popupBody.find(".pay-remain-wrapper-from").serializeObject()
                        location.href = app.baseUrl + "shop/duePayment?paymentMethod="+paymentData.paymentMethod
                    })
                }
            },
            beforeSubmit: function () {},
            success: function (_resp) {
            },
            error: function (xhr, status, resp) {
                _self._showStatus(panel, "error", resp.message)
            }
        })
    })

})

$(function() {

    $(".view-virtual-cart-items").on("click", function (){
        var cartItems = this.jqObject.attr("cart-items")

        bm.renderSitePopup(app.baseUrl + "shop/viewVirtualCartItems", "Order Details", "", {cartItems: cartItems}, {
            clazz: "pay-remaining-amount-popup",
            events: {
                content_loaded: function (popup) {
                    var popupBody = popup.el
                    popupBody.find("button.cancel-button").on("click", function (){
                        popup.close()
                    })
                    popupBody.find("button.submit-button").on("click", function (){
                        var paymentData = popupBody.find(".pay-remain-wrapper-from").serializeObject()
                        location.href = app.baseUrl + "shop/duePayment?paymentMethod="+paymentData.paymentMethod
                    })
                }
            },
            beforeSubmit: function () {},
            success: function (_resp) {
            },
            error: function (xhr, status, resp) {
                _self._showStatus(panel, "error", resp.message)
            }
        })



    })

    $(".api-playground-login-logout.do-logout").on("click", function (event) {
        ['wc_client_email', 'wc_identity_code', 'wc_instance_url'].forEach(name => {
            document.cookie = `${name}=; path=/; domain=.webcommander.com; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
        });
        window.location.href = window.location.href;
    })

    $(".api-playground-login-logout.do-login").on("click", function (event) {
        var loginUrl = this.jqObject.attr("url");
        loginUrl = loginUrl + window.location.href
        window.location.href = loginUrl
    })

    var isNotEditor = !app.is_front_end_editor
    if(isNotEditor){
    } else {
    }

    // // Close menus on outside click
    $(document).on("click", function (event) {
        if($(event.target).is(".child-opener")){
            return
        }
        if (!$(event.target).closest(".menu-button.responsive-menu-btn").length) {
            if($(".menu-button.responsive-menu-btn.close").length){
                $(".menu-button.responsive-menu-btn.close").trigger("click")
            }
        }
    });


})


/* HWC-4750 — product quantity stepper: the "bare input" that keeps coming back.
 *
 * WHY IT KEPT COMING BACK. jquery.fs.stepper.js is NOT in the always-bundle: it ships inside the
 * lazy `commerce` chunk (ResourceList.siteFeatureJsChunks), and js-chunk-loader.js — which loads
 * before it — parks a stub on $.fn.stepper until the real file executes. Every script on a site
 * page is emitted `defer`, and a deferred script runs with document.readyState already
 * "interactive", so jQuery schedules its ready dispatch on a setTimeout instead of waiting for
 * DOMContentLoaded — the hazard ResourceList already documents above storeSwitcherSelect.js. That
 * timer can run BETWEEN two deferred files, i.e. before stepper.js has executed. In that window
 * BOTH recovery paths were silent no-ops:
 *
 *   - calling through the stub does nothing: its replay is guarded by
 *     `if ($.fn[method] && !$.fn[method].__wcChunkStub)`;
 *   - asking for the chunk does not help either, because a product page emits `commerce` EAGERLY
 *     (ApplicationTagLib.siteFeatureJs — `if (request.product)`), so it is absent from
 *     __wcJsChunkUrls, and wcLoadJsChunk takes its "chunk was emitted with the page — nothing to
 *     load" branch and fires the callback IMMEDIATELY, while the real plugin still has not run.
 *
 * So the previous attempt's `wcLoadJsChunk("commerce", cb)` fallback could not work on the one
 * page that shows the symptom: its callback fires against the stub and nothing ever retries. The
 * timing is what made it intermittent — a warm cache or a slow file flips it — and it is also why
 * the variation rows' steppers look fine on the same screen: those bind later, from
 * site.variation.js, by which time stepper.js HAS executed.
 *
 * A callback is therefore not proof the plugin exists. What follows waits for the plugin ITSELF,
 * the same intent as the bm.onReady($.prototype, "raty", …) idiom the review widgets use (bm.onReady
 * itself is not usable here: it tests `typeof obj[prop] == "undefined"`, and the stub IS defined).
 *
 * Two smaller failure paths are closed with it:
 *   - the bind is no longer reachable only from jQuery's ready queue. jQuery fires every ready
 *     callback from ONE list, so an unrelated throw in an earlier handler (this file opens a
 *     ~2000-line one at line 20) skips every later one — moving the call to its own $(function(){})
 *     never isolated it. site.js is deferred, so the document is already parsed when this executes
 *     and the inputs are there: bind straight away, with the event hooks as backstops.
 *   - one unreadable input can no longer abort the rest. The throw used to escape .each() and
 *     leave every later quantity box on the page plain.
 *
 * Kept in site.js rather than a new file because bindProductQuantitySpinner is a global this file's
 * own flying-cart and add-to-cart-popup callbacks (renderAddToCartPopup, adjustCartWidgetQuantity)
 * call — a separate file assigning a global that site.js depends on would be worse coupling.
 * Leading ';' per the ASI rule for appended top-level blocks.
 */
;(function () {
    var QUANTITY_SELECTOR = ".product-quantity-selector.text-type";
    var STEPPER_POLL_MS = 100;
    // ~10s. Bounded so a chunk that genuinely never defines the plugin settles into the old
    // no-op instead of polling for the life of the page.
    var STEPPER_MAX_ATTEMPTS = 100;

    var queuedContainers = [];
    var isPolling = false;

    function hasRealStepper() {
        return typeof $.fn.stepper === "function" && !$.fn.stepper.__wcChunkStub;
    }

    function initStepper(element) {
        var spin = $(element);

        // Already initialised. This matters more than before: several entry points plus the
        // retry below can all reach the same input.
        if (spin.hasClass("stepper-input") || spin.parent().hasClass("stepper")) {
            return;
        }

        // Per element, so one unreadable spin config cannot take the rest of the page's
        // quantity boxes down with it.
        try {
            var data = spin.config("spin");
            data.et_data = {
                up: {clazz: "et_cartp_increase_quantity", attr: {'et-category': 'button'}},
                down: {clazz: "et_cartp_decrease_quantity", attr: {'et-category': 'button'}}
            };
            spin.stepper(data)
        } catch (e) {
            if (window.console && console.error) {
                console.error("Quantity stepper failed for one input", element, e);
            }
        }
    }

    function bindNow(container) {
        var spinObj = container != null ? container.find(QUANTITY_SELECTOR) : $(QUANTITY_SELECTOR);
        spinObj.each(function () {
            initStepper(this)
        })
    }

    function flushQueued() {
        var queued = queuedContainers;
        queuedContainers = [];
        for (var i = 0; i < queued.length; i++) {
            // Containers are re-queried here rather than cached as jQuery sets: an ajax
            // re-render between queueing and the plugin landing would otherwise bind nodes
            // that are no longer on the page.
            bindNow(queued[i])
        }
    }

    function bindWhenStepperArrives(container) {
        queuedContainers.push(container);
        if (isPolling) {
            return;
        }
        isPolling = true;
        // No-op when the chunk was emitted with the page (the loader returns immediately); the
        // call is here for the page that really does have to download it.
        if (typeof window.wcLoadJsChunk === "function") {
            window.wcLoadJsChunk("commerce")
        }
        var attempts = 0;
        (function poll() {
            if (hasRealStepper()) {
                isPolling = false;
                flushQueued();
                return;
            }
            if (++attempts > STEPPER_MAX_ATTEMPTS) {
                isPolling = false;
                queuedContainers = [];
                if (window.console && console.warn) {
                    console.warn("jquery.fs.stepper never loaded — quantity inputs stay plain");
                }
                return;
            }
            setTimeout(poll, STEPPER_POLL_MS)
        })()
    }

    // Same signature and already-initialised behaviour as before, so every existing caller
    // (renderAddToCartPopup, initializeProductInfoView, fee.product.js, the variation files) is
    // unaffected — they simply no longer need the plugin to be loaded at the moment they call.
    bindProductQuantitySpinner = function (container) {
        if (hasRealStepper()) {
            bindNow(container);
            return;
        }
        bindWhenStepperArrives(container)
    };

    bindProductQuantitySpinner();

    // Backstops for the load paths where this file is NOT deferred (document still parsing) and
    // for markup that arrives during load. Both re-enter the already-initialised guard, so a
    // repeat pass over bound inputs costs nothing.
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            bindProductQuantitySpinner()
        });
    }
    window.addEventListener("load", function () {
        bindProductQuantitySpinner()
    });
})();

; /*! tooltipster v4.2.8 */!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){function b(a){this.$container,this.constraints=null,this.__$tooltip,this.__init(a)}function c(b,c){var d=!0;return a.each(b,function(a,e){return void 0===c[a]||b[a]!==c[a]?(d=!1,!1):void 0}),d}function d(b){var c=b.attr("id"),d=c?h.window.document.getElementById(c):null;return d?d===b[0]:a.contains(h.window.document.body,b[0])}function e(){if(!g)return!1;var a=g.document.body||g.document.documentElement,b=a.style,c="transition",d=["Moz","Webkit","Khtml","O","ms"];if("string"==typeof b[c])return!0;c=c.charAt(0).toUpperCase()+c.substr(1);for(var e=0;e<d.length;e++)if("string"==typeof b[d[e]+c])return!0;return!1}var f={animation:"fade",animationDuration:350,content:null,contentAsHTML:!1,contentCloning:!1,debug:!0,delay:300,delayTouch:[300,500],functionInit:null,functionBefore:null,functionReady:null,functionAfter:null,functionFormat:null,IEmin:6,interactive:!1,multiple:!1,parent:null,plugins:["sideTip"],repositionOnScroll:!1,restoration:"none",selfDestruction:!0,theme:[],timer:0,trackerInterval:500,trackOrigin:!1,trackTooltip:!1,trigger:"hover",triggerClose:{click:!1,mouseleave:!1,originClick:!1,scroll:!1,tap:!1,touchleave:!1},triggerOpen:{click:!1,mouseenter:!1,tap:!1,touchstart:!1},updateAnimation:"rotate",zIndex:9999999},g="undefined"!=typeof window?window:null,h={hasTouchCapability:!(!g||!("ontouchstart"in g||g.DocumentTouch&&g.document instanceof g.DocumentTouch||g.navigator.maxTouchPoints)),hasTransitions:e(),IE:!1,semVer:"4.2.8",window:g},i=function(){this.__$emitterPrivate=a({}),this.__$emitterPublic=a({}),this.__instancesLatestArr=[],this.__plugins={},this._env=h};i.prototype={__bridge:function(b,c,d){if(!c[d]){var e=function(){};e.prototype=b;var g=new e;g.__init&&g.__init(c),a.each(b,function(a,b){0!=a.indexOf("__")&&(c[a]?f.debug&&console.log("The "+a+" method of the "+d+" plugin conflicts with another plugin or native methods"):(c[a]=function(){return g[a].apply(g,Array.prototype.slice.apply(arguments))},c[a].bridged=g))}),c[d]=g}return this},__setWindow:function(a){return h.window=a,this},_getRuler:function(a){return new b(a)},_off:function(){return this.__$emitterPrivate.off.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_on:function(){return this.__$emitterPrivate.on.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_one:function(){return this.__$emitterPrivate.one.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_plugin:function(b){var c=this;if("string"==typeof b){var d=b,e=null;return d.indexOf(".")>0?e=c.__plugins[d]:a.each(c.__plugins,function(a,b){return b.name.substring(b.name.length-d.length-1)=="."+d?(e=b,!1):void 0}),e}if(b.name.indexOf(".")<0)throw new Error("Plugins must be namespaced");return c.__plugins[b.name]=b,b.core&&c.__bridge(b.core,c,b.name),this},_trigger:function(){var a=Array.prototype.slice.apply(arguments);return"string"==typeof a[0]&&(a[0]={type:a[0]}),this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate,a),this.__$emitterPublic.trigger.apply(this.__$emitterPublic,a),this},instances:function(b){var c=[],d=b||".tooltipstered";return a(d).each(function(){var b=a(this),d=b.data("tooltipster-ns");d&&a.each(d,function(a,d){c.push(b.data(d))})}),c},instancesLatest:function(){return this.__instancesLatestArr},off:function(){return this.__$emitterPublic.off.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},on:function(){return this.__$emitterPublic.on.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},one:function(){return this.__$emitterPublic.one.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},origins:function(b){var c=b?b+" ":"";return a(c+".tooltipstered").toArray()},setDefaults:function(b){return a.extend(f,b),this},triggerHandler:function(){return this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this}},a.tooltipster=new i,a.Tooltipster=function(b,c){this.__callbacks={close:[],open:[]},this.__closingTime,this.__Content,this.__contentBcr,this.__destroyed=!1,this.__$emitterPrivate=a({}),this.__$emitterPublic=a({}),this.__enabled=!0,this.__garbageCollector,this.__Geometry,this.__lastPosition,this.__namespace="tooltipster-"+Math.round(1e6*Math.random()),this.__options,this.__$originParents,this.__pointerIsOverOrigin=!1,this.__previousThemes=[],this.__state="closed",this.__timeouts={close:[],open:null},this.__touchEvents=[],this.__tracker=null,this._$origin,this._$tooltip,this.__init(b,c)},a.Tooltipster.prototype={__init:function(b,c){var d=this;if(d._$origin=a(b),d.__options=a.extend(!0,{},f,c),d.__optionsFormat(),!h.IE||h.IE>=d.__options.IEmin){var e=null;if(void 0===d._$origin.data("tooltipster-initialTitle")&&(e=d._$origin.attr("title"),void 0===e&&(e=null),d._$origin.data("tooltipster-initialTitle",e)),null!==d.__options.content)d.__contentSet(d.__options.content);else{var g,i=d._$origin.attr("data-tooltip-content");i&&(g=a(i)),g&&g[0]?d.__contentSet(g.first()):d.__contentSet(e)}d._$origin.removeAttr("title").addClass("tooltipstered"),d.__prepareOrigin(),d.__prepareGC(),a.each(d.__options.plugins,function(a,b){d._plug(b)}),h.hasTouchCapability&&a(h.window.document.body).on("touchmove."+d.__namespace+"-triggerOpen",function(a){d._touchRecordEvent(a)}),d._on("created",function(){d.__prepareTooltip()})._on("repositioned",function(a){d.__lastPosition=a.position})}else d.__options.disabled=!0},__contentInsert:function(){var a=this,b=a._$tooltip.find(".tooltipster-content"),c=a.__Content,d=function(a){c=a};return a._trigger({type:"format",content:a.__Content,format:d}),a.__options.functionFormat&&(c=a.__options.functionFormat.call(a,a,{origin:a._$origin[0]},a.__Content)),"string"!=typeof c||a.__options.contentAsHTML?b.empty().append(c):b.text(c),a},__contentSet:function(b){return b instanceof a&&this.__options.contentCloning&&(b=b.clone(!0)),this.__Content=b,this._trigger({type:"updated",content:b}),this},__destroyError:function(){throw new Error("This tooltip has been destroyed and cannot execute your method call.")},__geometry:function(){var b=this,c=b._$origin,d=b._$origin.is("area");if(d){var e=b._$origin.parent().attr("name");c=a('img[usemap="#'+e+'"]')}var f=c[0].getBoundingClientRect(),g=a(h.window.document),i=a(h.window),j=c,k={available:{document:null,window:null},document:{size:{height:g.height(),width:g.width()}},window:{scroll:{left:h.window.scrollX||h.window.document.documentElement.scrollLeft,top:h.window.scrollY||h.window.document.documentElement.scrollTop},size:{height:i.height(),width:i.width()}},origin:{fixedLineage:!1,offset:{},size:{height:f.bottom-f.top,width:f.right-f.left},usemapImage:d?c[0]:null,windowOffset:{bottom:f.bottom,left:f.left,right:f.right,top:f.top}}};if(d){var l=b._$origin.attr("shape"),m=b._$origin.attr("coords");if(m&&(m=m.split(","),a.map(m,function(a,b){m[b]=parseInt(a)})),"default"!=l)switch(l){case"circle":var n=m[0],o=m[1],p=m[2],q=o-p,r=n-p;k.origin.size.height=2*p,k.origin.size.width=k.origin.size.height,k.origin.windowOffset.left+=r,k.origin.windowOffset.top+=q;break;case"rect":var s=m[0],t=m[1],u=m[2],v=m[3];k.origin.size.height=v-t,k.origin.size.width=u-s,k.origin.windowOffset.left+=s,k.origin.windowOffset.top+=t;break;case"poly":for(var w=0,x=0,y=0,z=0,A="even",B=0;B<m.length;B++){var C=m[B];"even"==A?(C>y&&(y=C,0===B&&(w=y)),w>C&&(w=C),A="odd"):(C>z&&(z=C,1==B&&(x=z)),x>C&&(x=C),A="even")}k.origin.size.height=z-x,k.origin.size.width=y-w,k.origin.windowOffset.left+=w,k.origin.windowOffset.top+=x}}var D=function(a){k.origin.size.height=a.height,k.origin.windowOffset.left=a.left,k.origin.windowOffset.top=a.top,k.origin.size.width=a.width};for(b._trigger({type:"geometry",edit:D,geometry:{height:k.origin.size.height,left:k.origin.windowOffset.left,top:k.origin.windowOffset.top,width:k.origin.size.width}}),k.origin.windowOffset.right=k.origin.windowOffset.left+k.origin.size.width,k.origin.windowOffset.bottom=k.origin.windowOffset.top+k.origin.size.height,k.origin.offset.left=k.origin.windowOffset.left+k.window.scroll.left,k.origin.offset.top=k.origin.windowOffset.top+k.window.scroll.top,k.origin.offset.bottom=k.origin.offset.top+k.origin.size.height,k.origin.offset.right=k.origin.offset.left+k.origin.size.width,k.available.document={bottom:{height:k.document.size.height-k.origin.offset.bottom,width:k.document.size.width},left:{height:k.document.size.height,width:k.origin.offset.left},right:{height:k.document.size.height,width:k.document.size.width-k.origin.offset.right},top:{height:k.origin.offset.top,width:k.document.size.width}},k.available.window={bottom:{height:Math.max(k.window.size.height-Math.max(k.origin.windowOffset.bottom,0),0),width:k.window.size.width},left:{height:k.window.size.height,width:Math.max(k.origin.windowOffset.left,0)},right:{height:k.window.size.height,width:Math.max(k.window.size.width-Math.max(k.origin.windowOffset.right,0),0)},top:{height:Math.max(k.origin.windowOffset.top,0),width:k.window.size.width}};"html"!=j[0].tagName.toLowerCase();){if("fixed"==j.css("position")){k.origin.fixedLineage=!0;break}j=j.parent()}return k},__optionsFormat:function(){return"number"==typeof this.__options.animationDuration&&(this.__options.animationDuration=[this.__options.animationDuration,this.__options.animationDuration]),"number"==typeof this.__options.delay&&(this.__options.delay=[this.__options.delay,this.__options.delay]),"number"==typeof this.__options.delayTouch&&(this.__options.delayTouch=[this.__options.delayTouch,this.__options.delayTouch]),"string"==typeof this.__options.theme&&(this.__options.theme=[this.__options.theme]),null===this.__options.parent?this.__options.parent=a(h.window.document.body):"string"==typeof this.__options.parent&&(this.__options.parent=a(this.__options.parent)),"hover"==this.__options.trigger?(this.__options.triggerOpen={mouseenter:!0,touchstart:!0},this.__options.triggerClose={mouseleave:!0,originClick:!0,touchleave:!0}):"click"==this.__options.trigger&&(this.__options.triggerOpen={click:!0,tap:!0},this.__options.triggerClose={click:!0,tap:!0}),this._trigger("options"),this},__prepareGC:function(){var b=this;return b.__options.selfDestruction?b.__garbageCollector=setInterval(function(){var c=(new Date).getTime();b.__touchEvents=a.grep(b.__touchEvents,function(a,b){return c-a.time>6e4}),d(b._$origin)||b.close(function(){b.destroy()})},2e4):clearInterval(b.__garbageCollector),b},__prepareOrigin:function(){var a=this;if(a._$origin.off("."+a.__namespace+"-triggerOpen"),h.hasTouchCapability&&a._$origin.on("touchstart."+a.__namespace+"-triggerOpen touchend."+a.__namespace+"-triggerOpen touchcancel."+a.__namespace+"-triggerOpen",function(b){a._touchRecordEvent(b)}),a.__options.triggerOpen.click||a.__options.triggerOpen.tap&&h.hasTouchCapability){var b="";a.__options.triggerOpen.click&&(b+="click."+a.__namespace+"-triggerOpen "),a.__options.triggerOpen.tap&&h.hasTouchCapability&&(b+="touchend."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){a._touchIsMeaningfulEvent(b)&&a._open(b)})}if(a.__options.triggerOpen.mouseenter||a.__options.triggerOpen.touchstart&&h.hasTouchCapability){var b="";a.__options.triggerOpen.mouseenter&&(b+="mouseenter."+a.__namespace+"-triggerOpen "),a.__options.triggerOpen.touchstart&&h.hasTouchCapability&&(b+="touchstart."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){!a._touchIsTouchEvent(b)&&a._touchIsEmulatedEvent(b)||(a.__pointerIsOverOrigin=!0,a._openShortly(b))})}if(a.__options.triggerClose.mouseleave||a.__options.triggerClose.touchleave&&h.hasTouchCapability){var b="";a.__options.triggerClose.mouseleave&&(b+="mouseleave."+a.__namespace+"-triggerOpen "),a.__options.triggerClose.touchleave&&h.hasTouchCapability&&(b+="touchend."+a.__namespace+"-triggerOpen touchcancel."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){a._touchIsMeaningfulEvent(b)&&(a.__pointerIsOverOrigin=!1)})}return a},__prepareTooltip:function(){var b=this,c=b.__options.interactive?"auto":"";return b._$tooltip.attr("id",b.__namespace).css({"pointer-events":c,zIndex:b.__options.zIndex}),a.each(b.__previousThemes,function(a,c){b._$tooltip.removeClass(c)}),a.each(b.__options.theme,function(a,c){b._$tooltip.addClass(c)}),b.__previousThemes=a.merge([],b.__options.theme),b},__scrollHandler:function(b){var c=this;if(c.__options.triggerClose.scroll)c._close(b);else if(d(c._$origin)&&d(c._$tooltip)){var e=null;if(b.target===h.window.document)c.__Geometry.origin.fixedLineage||c.__options.repositionOnScroll&&c.reposition(b);else{e=c.__geometry();var f=!1;if("fixed"!=c._$origin.css("position")&&c.__$originParents.each(function(b,c){var d=a(c),g=d.css("overflow-x"),h=d.css("overflow-y");if("visible"!=g||"visible"!=h){var i=c.getBoundingClientRect();if("visible"!=g&&(e.origin.windowOffset.left<i.left||e.origin.windowOffset.right>i.right))return f=!0,!1;if("visible"!=h&&(e.origin.windowOffset.top<i.top||e.origin.windowOffset.bottom>i.bottom))return f=!0,!1}return"fixed"==d.css("position")?!1:void 0}),f)c._$tooltip.css("visibility","hidden");else if(c._$tooltip.css("visibility","visible"),c.__options.repositionOnScroll)c.reposition(b);else{var g=e.origin.offset.left-c.__Geometry.origin.offset.left,i=e.origin.offset.top-c.__Geometry.origin.offset.top;c._$tooltip.css({left:c.__lastPosition.coord.left+g,top:c.__lastPosition.coord.top+i})}}c._trigger({type:"scroll",event:b,geo:e})}return c},__stateSet:function(a){return this.__state=a,this._trigger({type:"state",state:a}),this},__timeoutsClear:function(){return clearTimeout(this.__timeouts.open),this.__timeouts.open=null,a.each(this.__timeouts.close,function(a,b){clearTimeout(b)}),this.__timeouts.close=[],this},__trackerStart:function(){var a=this,b=a._$tooltip.find(".tooltipster-content");return a.__options.trackTooltip&&(a.__contentBcr=b[0].getBoundingClientRect()),a.__tracker=setInterval(function(){if(d(a._$origin)&&d(a._$tooltip)){if(a.__options.trackOrigin){var e=a.__geometry(),f=!1;c(e.origin.size,a.__Geometry.origin.size)&&(a.__Geometry.origin.fixedLineage?c(e.origin.windowOffset,a.__Geometry.origin.windowOffset)&&(f=!0):c(e.origin.offset,a.__Geometry.origin.offset)&&(f=!0)),f||(a.__options.triggerClose.mouseleave?a._close():a.reposition())}if(a.__options.trackTooltip){var g=b[0].getBoundingClientRect();g.height===a.__contentBcr.height&&g.width===a.__contentBcr.width||(a.reposition(),a.__contentBcr=g)}}else a._close()},a.__options.trackerInterval),a},_close:function(b,c,d){var e=this,f=!0;if(e._trigger({type:"close",event:b,stop:function(){f=!1}}),f||d){c&&e.__callbacks.close.push(c),e.__callbacks.open=[],e.__timeoutsClear();var g=function(){a.each(e.__callbacks.close,function(a,c){c.call(e,e,{event:b,origin:e._$origin[0]})}),e.__callbacks.close=[]};if("closed"!=e.__state){var i=!0,j=new Date,k=j.getTime(),l=k+e.__options.animationDuration[1];if("disappearing"==e.__state&&l>e.__closingTime&&e.__options.animationDuration[1]>0&&(i=!1),i){e.__closingTime=l,"disappearing"!=e.__state&&e.__stateSet("disappearing");var m=function(){clearInterval(e.__tracker),e._trigger({type:"closing",event:b}),e._$tooltip.off("."+e.__namespace+"-triggerClose").removeClass("tooltipster-dying"),a(h.window).off("."+e.__namespace+"-triggerClose"),e.__$originParents.each(function(b,c){a(c).off("scroll."+e.__namespace+"-triggerClose")}),e.__$originParents=null,a(h.window.document.body).off("."+e.__namespace+"-triggerClose"),e._$origin.off("."+e.__namespace+"-triggerClose"),e._off("dismissable"),e.__stateSet("closed"),e._trigger({type:"after",event:b}),e.__options.functionAfter&&e.__options.functionAfter.call(e,e,{event:b,origin:e._$origin[0]}),g()};h.hasTransitions?(e._$tooltip.css({"-moz-animation-duration":e.__options.animationDuration[1]+"ms","-ms-animation-duration":e.__options.animationDuration[1]+"ms","-o-animation-duration":e.__options.animationDuration[1]+"ms","-webkit-animation-duration":e.__options.animationDuration[1]+"ms","animation-duration":e.__options.animationDuration[1]+"ms","transition-duration":e.__options.animationDuration[1]+"ms"}),e._$tooltip.clearQueue().removeClass("tooltipster-show").addClass("tooltipster-dying"),e.__options.animationDuration[1]>0&&e._$tooltip.delay(e.__options.animationDuration[1]),e._$tooltip.queue(m)):e._$tooltip.stop().fadeOut(e.__options.animationDuration[1],m)}}else g()}return e},_off:function(){return this.__$emitterPrivate.off.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_on:function(){return this.__$emitterPrivate.on.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_one:function(){return this.__$emitterPrivate.one.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_open:function(b,c){var e=this;if(!e.__destroying&&d(e._$origin)&&e.__enabled){var f=!0;if("closed"==e.__state&&(e._trigger({type:"before",event:b,stop:function(){f=!1}}),f&&e.__options.functionBefore&&(f=e.__options.functionBefore.call(e,e,{event:b,origin:e._$origin[0]}))),f!==!1&&null!==e.__Content){c&&e.__callbacks.open.push(c),e.__callbacks.close=[],e.__timeoutsClear();var g,i=function(){"stable"!=e.__state&&e.__stateSet("stable"),a.each(e.__callbacks.open,function(a,b){b.call(e,e,{origin:e._$origin[0],tooltip:e._$tooltip[0]})}),e.__callbacks.open=[]};if("closed"!==e.__state)g=0,"disappearing"===e.__state?(e.__stateSet("appearing"),h.hasTransitions?(e._$tooltip.clearQueue().removeClass("tooltipster-dying").addClass("tooltipster-show"),e.__options.animationDuration[0]>0&&e._$tooltip.delay(e.__options.animationDuration[0]),e._$tooltip.queue(i)):e._$tooltip.stop().fadeIn(i)):"stable"==e.__state&&i();else{if(e.__stateSet("appearing"),g=e.__options.animationDuration[0],e.__contentInsert(),e.reposition(b,!0),h.hasTransitions?(e._$tooltip.addClass("tooltipster-"+e.__options.animation).addClass("tooltipster-initial").css({"-moz-animation-duration":e.__options.animationDuration[0]+"ms","-ms-animation-duration":e.__options.animationDuration[0]+"ms","-o-animation-duration":e.__options.animationDuration[0]+"ms","-webkit-animation-duration":e.__options.animationDuration[0]+"ms","animation-duration":e.__options.animationDuration[0]+"ms","transition-duration":e.__options.animationDuration[0]+"ms"}),setTimeout(function(){"closed"!=e.__state&&(e._$tooltip.addClass("tooltipster-show").removeClass("tooltipster-initial"),e.__options.animationDuration[0]>0&&e._$tooltip.delay(e.__options.animationDuration[0]),e._$tooltip.queue(i))},0)):e._$tooltip.css("display","none").fadeIn(e.__options.animationDuration[0],i),e.__trackerStart(),a(h.window).on("resize."+e.__namespace+"-triggerClose",function(b){var c=a(document.activeElement);(c.is("input")||c.is("textarea"))&&a.contains(e._$tooltip[0],c[0])||e.reposition(b)}).on("scroll."+e.__namespace+"-triggerClose",function(a){e.__scrollHandler(a)}),e.__$originParents=e._$origin.parents(),e.__$originParents.each(function(b,c){a(c).on("scroll."+e.__namespace+"-triggerClose",function(a){e.__scrollHandler(a)})}),e.__options.triggerClose.mouseleave||e.__options.triggerClose.touchleave&&h.hasTouchCapability){e._on("dismissable",function(a){a.dismissable?a.delay?(m=setTimeout(function(){e._close(a.event)},a.delay),e.__timeouts.close.push(m)):e._close(a):clearTimeout(m)});var j=e._$origin,k="",l="",m=null;e.__options.interactive&&(j=j.add(e._$tooltip)),e.__options.triggerClose.mouseleave&&(k+="mouseenter."+e.__namespace+"-triggerClose ",l+="mouseleave."+e.__namespace+"-triggerClose "),e.__options.triggerClose.touchleave&&h.hasTouchCapability&&(k+="touchstart."+e.__namespace+"-triggerClose",l+="touchend."+e.__namespace+"-triggerClose touchcancel."+e.__namespace+"-triggerClose"),j.on(l,function(a){if(e._touchIsTouchEvent(a)||!e._touchIsEmulatedEvent(a)){var b="mouseleave"==a.type?e.__options.delay:e.__options.delayTouch;e._trigger({delay:b[1],dismissable:!0,event:a,type:"dismissable"})}}).on(k,function(a){!e._touchIsTouchEvent(a)&&e._touchIsEmulatedEvent(a)||e._trigger({dismissable:!1,event:a,type:"dismissable"})})}e.__options.triggerClose.originClick&&e._$origin.on("click."+e.__namespace+"-triggerClose",function(a){e._touchIsTouchEvent(a)||e._touchIsEmulatedEvent(a)||e._close(a)}),(e.__options.triggerClose.click||e.__options.triggerClose.tap&&h.hasTouchCapability)&&setTimeout(function(){if("closed"!=e.__state){var b="",c=a(h.window.document.body);e.__options.triggerClose.click&&(b+="click."+e.__namespace+"-triggerClose "),e.__options.triggerClose.tap&&h.hasTouchCapability&&(b+="touchend."+e.__namespace+"-triggerClose"),c.on(b,function(b){e._touchIsMeaningfulEvent(b)&&(e._touchRecordEvent(b),e.__options.interactive&&a.contains(e._$tooltip[0],b.target)||e._close(b))}),e.__options.triggerClose.tap&&h.hasTouchCapability&&c.on("touchstart."+e.__namespace+"-triggerClose",function(a){e._touchRecordEvent(a)})}},0),e._trigger("ready"),e.__options.functionReady&&e.__options.functionReady.call(e,e,{origin:e._$origin[0],tooltip:e._$tooltip[0]})}if(e.__options.timer>0){var m=setTimeout(function(){e._close()},e.__options.timer+g);e.__timeouts.close.push(m)}}}return e},_openShortly:function(a){var b=this,c=!0;if("stable"!=b.__state&&"appearing"!=b.__state&&!b.__timeouts.open&&(b._trigger({type:"start",event:a,stop:function(){c=!1}}),c)){var d=0==a.type.indexOf("touch")?b.__options.delayTouch:b.__options.delay;d[0]?b.__timeouts.open=setTimeout(function(){b.__timeouts.open=null,b.__pointerIsOverOrigin&&b._touchIsMeaningfulEvent(a)?(b._trigger("startend"),b._open(a)):b._trigger("startcancel")},d[0]):(b._trigger("startend"),b._open(a))}return b},_optionsExtract:function(b,c){var d=this,e=a.extend(!0,{},c),f=d.__options[b];return f||(f={},a.each(c,function(a,b){var c=d.__options[a];void 0!==c&&(f[a]=c)})),a.each(e,function(b,c){void 0!==f[b]&&("object"!=typeof c||c instanceof Array||null==c||"object"!=typeof f[b]||f[b]instanceof Array||null==f[b]?e[b]=f[b]:a.extend(e[b],f[b]))}),e},_plug:function(b){var c=a.tooltipster._plugin(b);if(!c)throw new Error('The "'+b+'" plugin is not defined');return c.instance&&a.tooltipster.__bridge(c.instance,this,c.name),this},_touchIsEmulatedEvent:function(a){for(var b=!1,c=(new Date).getTime(),d=this.__touchEvents.length-1;d>=0;d--){var e=this.__touchEvents[d];if(!(c-e.time<500))break;e.target===a.target&&(b=!0)}return b},_touchIsMeaningfulEvent:function(a){return this._touchIsTouchEvent(a)&&!this._touchSwiped(a.target)||!this._touchIsTouchEvent(a)&&!this._touchIsEmulatedEvent(a)},_touchIsTouchEvent:function(a){return 0==a.type.indexOf("touch")},_touchRecordEvent:function(a){return this._touchIsTouchEvent(a)&&(a.time=(new Date).getTime(),this.__touchEvents.push(a)),this},_touchSwiped:function(a){for(var b=!1,c=this.__touchEvents.length-1;c>=0;c--){var d=this.__touchEvents[c];if("touchmove"==d.type){b=!0;break}if("touchstart"==d.type&&a===d.target)break}return b},_trigger:function(){var b=Array.prototype.slice.apply(arguments);return"string"==typeof b[0]&&(b[0]={type:b[0]}),b[0].instance=this,b[0].origin=this._$origin?this._$origin[0]:null,b[0].tooltip=this._$tooltip?this._$tooltip[0]:null,this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate,b),a.tooltipster._trigger.apply(a.tooltipster,b),this.__$emitterPublic.trigger.apply(this.__$emitterPublic,b),this},_unplug:function(b){var c=this;if(c[b]){var d=a.tooltipster._plugin(b);d.instance&&a.each(d.instance,function(a,d){c[a]&&c[a].bridged===c[b]&&delete c[a]}),c[b].__destroy&&c[b].__destroy(),delete c[b]}return c},close:function(a){return this.__destroyed?this.__destroyError():this._close(null,a),this},content:function(a){var b=this;if(void 0===a)return b.__Content;if(b.__destroyed)b.__destroyError();else if(b.__contentSet(a),null!==b.__Content){if("closed"!==b.__state&&(b.__contentInsert(),b.reposition(),b.__options.updateAnimation))if(h.hasTransitions){var c=b.__options.updateAnimation;b._$tooltip.addClass("tooltipster-update-"+c),setTimeout(function(){"closed"!=b.__state&&b._$tooltip.removeClass("tooltipster-update-"+c)},1e3)}else b._$tooltip.fadeTo(200,.5,function(){"closed"!=b.__state&&b._$tooltip.fadeTo(200,1)})}else b._close();return b},destroy:function(){var b=this;if(b.__destroyed)b.__destroyError();else{"closed"!=b.__state?b.option("animationDuration",0)._close(null,null,!0):b.__timeoutsClear(),b._trigger("destroy"),b.__destroyed=!0,b._$origin.removeData(b.__namespace).off("."+b.__namespace+"-triggerOpen"),a(h.window.document.body).off("."+b.__namespace+"-triggerOpen");var c=b._$origin.data("tooltipster-ns");if(c)if(1===c.length){var d=null;"previous"==b.__options.restoration?d=b._$origin.data("tooltipster-initialTitle"):"current"==b.__options.restoration&&(d="string"==typeof b.__Content?b.__Content:a("<div></div>").append(b.__Content).html()),d&&b._$origin.attr("title",d),b._$origin.removeClass("tooltipstered"),b._$origin.removeData("tooltipster-ns").removeData("tooltipster-initialTitle")}else c=a.grep(c,function(a,c){return a!==b.__namespace}),b._$origin.data("tooltipster-ns",c);b._trigger("destroyed"),b._off(),b.off(),b.__Content=null,b.__$emitterPrivate=null,b.__$emitterPublic=null,b.__options.parent=null,b._$origin=null,b._$tooltip=null,a.tooltipster.__instancesLatestArr=a.grep(a.tooltipster.__instancesLatestArr,function(a,c){return b!==a}),clearInterval(b.__garbageCollector)}return b},disable:function(){return this.__destroyed?(this.__destroyError(),this):(this._close(),this.__enabled=!1,this)},elementOrigin:function(){return this.__destroyed?void this.__destroyError():this._$origin[0]},elementTooltip:function(){return this._$tooltip?this._$tooltip[0]:null},enable:function(){return this.__enabled=!0,this},hide:function(a){return this.close(a)},instance:function(){return this},off:function(){return this.__destroyed||this.__$emitterPublic.off.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},on:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.on.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},one:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.one.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},open:function(a){return this.__destroyed?this.__destroyError():this._open(null,a),this},option:function(b,c){return void 0===c?this.__options[b]:(this.__destroyed?this.__destroyError():(this.__options[b]=c,this.__optionsFormat(),a.inArray(b,["trigger","triggerClose","triggerOpen"])>=0&&this.__prepareOrigin(),"selfDestruction"===b&&this.__prepareGC()),this)},reposition:function(a,b){var c=this;return c.__destroyed?c.__destroyError():"closed"!=c.__state&&d(c._$origin)&&(b||d(c._$tooltip))&&(b||c._$tooltip.detach(),c.__Geometry=c.__geometry(),c._trigger({type:"reposition",event:a,helper:{geo:c.__Geometry}})),c},show:function(a){return this.open(a)},status:function(){return{destroyed:this.__destroyed,enabled:this.__enabled,open:"closed"!==this.__state,state:this.__state}},triggerHandler:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this}},a.fn.tooltipster=function(){var b=Array.prototype.slice.apply(arguments),c="You are using a single HTML element as content for several tooltips. You probably want to set the contentCloning option to TRUE.";if(0===this.length)return this;if("string"==typeof b[0]){var d="#*$~&";return this.each(function(){var e=a(this).data("tooltipster-ns"),f=e?a(this).data(e[0]):null;if(!f)throw new Error("You called Tooltipster's \""+b[0]+'" method on an uninitialized element');if("function"!=typeof f[b[0]])throw new Error('Unknown method "'+b[0]+'"');this.length>1&&"content"==b[0]&&(b[1]instanceof a||"object"==typeof b[1]&&null!=b[1]&&b[1].tagName)&&!f.__options.contentCloning&&f.__options.debug&&console.log(c);var g=f[b[0]](b[1],b[2]);return g!==f||"instance"===b[0]?(d=g,!1):void 0}),"#*$~&"!==d?d:this}a.tooltipster.__instancesLatestArr=[];var e=b[0]&&void 0!==b[0].multiple,g=e&&b[0].multiple||!e&&f.multiple,h=b[0]&&void 0!==b[0].content,i=h&&b[0].content||!h&&f.content,j=b[0]&&void 0!==b[0].contentCloning,k=j&&b[0].contentCloning||!j&&f.contentCloning,l=b[0]&&void 0!==b[0].debug,m=l&&b[0].debug||!l&&f.debug;return this.length>1&&(i instanceof a||"object"==typeof i&&null!=i&&i.tagName)&&!k&&m&&console.log(c),this.each(function(){var c=!1,d=a(this),e=d.data("tooltipster-ns"),f=null;e?g?c=!0:m&&(console.log("Tooltipster: one or more tooltips are already attached to the element below. Ignoring."),console.log(this)):c=!0,c&&(f=new a.Tooltipster(this,b[0]),e||(e=[]),e.push(f.__namespace),d.data("tooltipster-ns",e),d.data(f.__namespace,f),f.__options.functionInit&&f.__options.functionInit.call(f,f,{origin:this}),f._trigger("init")),a.tooltipster.__instancesLatestArr.push(f)}),this},b.prototype={__init:function(b){this.__$tooltip=b,this.__$tooltip.css({left:0,overflow:"hidden",position:"absolute",top:0}).find(".tooltipster-content").css("overflow","auto"),this.$container=a('<div class="tooltipster-ruler"></div>').append(this.__$tooltip).appendTo(h.window.document.body)},__forceRedraw:function(){var a=this.__$tooltip.parent();this.__$tooltip.detach(),this.__$tooltip.appendTo(a)},constrain:function(a,b){return this.constraints={width:a,height:b},this.__$tooltip.css({display:"block",height:"",overflow:"auto",width:a}),this},destroy:function(){this.__$tooltip.detach().find(".tooltipster-content").css({display:"",overflow:""}),this.$container.remove()},free:function(){return this.constraints=null,this.__$tooltip.css({display:"",height:"",overflow:"visible",width:""}),this},measure:function(){this.__forceRedraw();var a=this.__$tooltip[0].getBoundingClientRect(),b={size:{height:a.height||a.bottom-a.top,width:a.width||a.right-a.left}};if(this.constraints){var c=this.__$tooltip.find(".tooltipster-content"),d=this.__$tooltip.outerHeight(),e=c[0].getBoundingClientRect(),f={height:d<=this.constraints.height,width:a.width<=this.constraints.width&&e.width>=c[0].scrollWidth-1};b.fits=f.height&&f.width}return h.IE&&h.IE<=11&&b.size.width!==h.window.document.documentElement.clientWidth&&(b.size.width=Math.ceil(b.size.width)+1),b}};var j=navigator.userAgent.toLowerCase();-1!=j.indexOf("msie")?h.IE=parseInt(j.split("msie")[1]):-1!==j.toLowerCase().indexOf("trident")&&-1!==j.indexOf(" rv:11")?h.IE=11:-1!=j.toLowerCase().indexOf("edge/")&&(h.IE=parseInt(j.toLowerCase().split("edge/")[1]));var k="tooltipster.sideTip";return a.tooltipster._plugin({name:k,instance:{__defaults:function(){return{arrow:!0,distance:6,functionPosition:null,maxWidth:null,minIntersection:16,minWidth:0,position:null,side:"top",viewportAware:!0}},__init:function(a){var b=this;b.__instance=a,b.__namespace="tooltipster-sideTip-"+Math.round(1e6*Math.random()),b.__previousState="closed",b.__options,b.__optionsFormat(),b.__instance._on("state."+b.__namespace,function(a){"closed"==a.state?b.__close():"appearing"==a.state&&"closed"==b.__previousState&&b.__create(),b.__previousState=a.state}),b.__instance._on("options."+b.__namespace,function(){b.__optionsFormat()}),b.__instance._on("reposition."+b.__namespace,function(a){b.__reposition(a.event,a.helper)})},__close:function(){this.__instance.content()instanceof a&&this.__instance.content().detach(),this.__instance._$tooltip.remove(),this.__instance._$tooltip=null},__create:function(){var b=a('<div class="tooltipster-base tooltipster-sidetip"><div class="tooltipster-box"><div class="tooltipster-content"></div></div><div class="tooltipster-arrow"><div class="tooltipster-arrow-uncropped"><div class="tooltipster-arrow-border"></div><div class="tooltipster-arrow-background"></div></div></div></div>');this.__options.arrow||b.find(".tooltipster-box").css("margin",0).end().find(".tooltipster-arrow").hide(),this.__options.minWidth&&b.css("min-width",this.__options.minWidth+"px"),this.__options.maxWidth&&b.css("max-width",this.__options.maxWidth+"px"),
this.__instance._$tooltip=b,this.__instance._trigger("created")},__destroy:function(){this.__instance._off("."+self.__namespace)},__optionsFormat:function(){var b=this;if(b.__options=b.__instance._optionsExtract(k,b.__defaults()),b.__options.position&&(b.__options.side=b.__options.position),"object"!=typeof b.__options.distance&&(b.__options.distance=[b.__options.distance]),b.__options.distance.length<4&&(void 0===b.__options.distance[1]&&(b.__options.distance[1]=b.__options.distance[0]),void 0===b.__options.distance[2]&&(b.__options.distance[2]=b.__options.distance[0]),void 0===b.__options.distance[3]&&(b.__options.distance[3]=b.__options.distance[1])),b.__options.distance={top:b.__options.distance[0],right:b.__options.distance[1],bottom:b.__options.distance[2],left:b.__options.distance[3]},"string"==typeof b.__options.side){var c={top:"bottom",right:"left",bottom:"top",left:"right"};b.__options.side=[b.__options.side,c[b.__options.side]],"left"==b.__options.side[0]||"right"==b.__options.side[0]?b.__options.side.push("top","bottom"):b.__options.side.push("right","left")}6===a.tooltipster._env.IE&&b.__options.arrow!==!0&&(b.__options.arrow=!1)},__reposition:function(b,c){var d,e=this,f=e.__targetFind(c),g=[];e.__instance._$tooltip.detach();var h=e.__instance._$tooltip.clone(),i=a.tooltipster._getRuler(h),j=!1,k=e.__instance.option("animation");switch(k&&h.removeClass("tooltipster-"+k),a.each(["window","document"],function(d,k){var l=null;if(e.__instance._trigger({container:k,helper:c,satisfied:j,takeTest:function(a){l=a},results:g,type:"positionTest"}),1==l||0!=l&&0==j&&("window"!=k||e.__options.viewportAware))for(var d=0;d<e.__options.side.length;d++){var m={horizontal:0,vertical:0},n=e.__options.side[d];"top"==n||"bottom"==n?m.vertical=e.__options.distance[n]:m.horizontal=e.__options.distance[n],e.__sideChange(h,n),a.each(["natural","constrained"],function(a,d){if(l=null,e.__instance._trigger({container:k,event:b,helper:c,mode:d,results:g,satisfied:j,side:n,takeTest:function(a){l=a},type:"positionTest"}),1==l||0!=l&&0==j){var h={container:k,distance:m,fits:null,mode:d,outerSize:null,side:n,size:null,target:f[n],whole:null},o="natural"==d?i.free():i.constrain(c.geo.available[k][n].width-m.horizontal,c.geo.available[k][n].height-m.vertical),p=o.measure();if(h.size=p.size,h.outerSize={height:p.size.height+m.vertical,width:p.size.width+m.horizontal},"natural"==d?c.geo.available[k][n].width>=h.outerSize.width&&c.geo.available[k][n].height>=h.outerSize.height?h.fits=!0:h.fits=!1:h.fits=p.fits,"window"==k&&(h.fits?"top"==n||"bottom"==n?h.whole=c.geo.origin.windowOffset.right>=e.__options.minIntersection&&c.geo.window.size.width-c.geo.origin.windowOffset.left>=e.__options.minIntersection:h.whole=c.geo.origin.windowOffset.bottom>=e.__options.minIntersection&&c.geo.window.size.height-c.geo.origin.windowOffset.top>=e.__options.minIntersection:h.whole=!1),g.push(h),h.whole)j=!0;else if("natural"==h.mode&&(h.fits||h.size.width<=c.geo.available[k][n].width))return!1}})}}),e.__instance._trigger({edit:function(a){g=a},event:b,helper:c,results:g,type:"positionTested"}),g.sort(function(a,b){if(a.whole&&!b.whole)return-1;if(!a.whole&&b.whole)return 1;if(a.whole&&b.whole){var c=e.__options.side.indexOf(a.side),d=e.__options.side.indexOf(b.side);return d>c?-1:c>d?1:"natural"==a.mode?-1:1}if(a.fits&&!b.fits)return-1;if(!a.fits&&b.fits)return 1;if(a.fits&&b.fits){var c=e.__options.side.indexOf(a.side),d=e.__options.side.indexOf(b.side);return d>c?-1:c>d?1:"natural"==a.mode?-1:1}return"document"==a.container&&"bottom"==a.side&&"natural"==a.mode?-1:1}),d=g[0],d.coord={},d.side){case"left":case"right":d.coord.top=Math.floor(d.target-d.size.height/2);break;case"bottom":case"top":d.coord.left=Math.floor(d.target-d.size.width/2)}switch(d.side){case"left":d.coord.left=c.geo.origin.windowOffset.left-d.outerSize.width;break;case"right":d.coord.left=c.geo.origin.windowOffset.right+d.distance.horizontal;break;case"top":d.coord.top=c.geo.origin.windowOffset.top-d.outerSize.height;break;case"bottom":d.coord.top=c.geo.origin.windowOffset.bottom+d.distance.vertical}"window"==d.container?"top"==d.side||"bottom"==d.side?d.coord.left<0?c.geo.origin.windowOffset.right-this.__options.minIntersection>=0?d.coord.left=0:d.coord.left=c.geo.origin.windowOffset.right-this.__options.minIntersection-1:d.coord.left>c.geo.window.size.width-d.size.width&&(c.geo.origin.windowOffset.left+this.__options.minIntersection<=c.geo.window.size.width?d.coord.left=c.geo.window.size.width-d.size.width:d.coord.left=c.geo.origin.windowOffset.left+this.__options.minIntersection+1-d.size.width):d.coord.top<0?c.geo.origin.windowOffset.bottom-this.__options.minIntersection>=0?d.coord.top=0:d.coord.top=c.geo.origin.windowOffset.bottom-this.__options.minIntersection-1:d.coord.top>c.geo.window.size.height-d.size.height&&(c.geo.origin.windowOffset.top+this.__options.minIntersection<=c.geo.window.size.height?d.coord.top=c.geo.window.size.height-d.size.height:d.coord.top=c.geo.origin.windowOffset.top+this.__options.minIntersection+1-d.size.height):(d.coord.left>c.geo.window.size.width-d.size.width&&(d.coord.left=c.geo.window.size.width-d.size.width),d.coord.left<0&&(d.coord.left=0)),e.__sideChange(h,d.side),c.tooltipClone=h[0],c.tooltipParent=e.__instance.option("parent").parent[0],c.mode=d.mode,c.whole=d.whole,c.origin=e.__instance._$origin[0],c.tooltip=e.__instance._$tooltip[0],delete d.container,delete d.fits,delete d.mode,delete d.outerSize,delete d.whole,d.distance=d.distance.horizontal||d.distance.vertical;var l=a.extend(!0,{},d);if(e.__instance._trigger({edit:function(a){d=a},event:b,helper:c,position:l,type:"position"}),e.__options.functionPosition){var m=e.__options.functionPosition.call(e,e.__instance,c,l);m&&(d=m)}i.destroy();var n,o;"top"==d.side||"bottom"==d.side?(n={prop:"left",val:d.target-d.coord.left},o=d.size.width-this.__options.minIntersection):(n={prop:"top",val:d.target-d.coord.top},o=d.size.height-this.__options.minIntersection),n.val<this.__options.minIntersection?n.val=this.__options.minIntersection:n.val>o&&(n.val=o);var p;p=c.geo.origin.fixedLineage?c.geo.origin.windowOffset:{left:c.geo.origin.windowOffset.left+c.geo.window.scroll.left,top:c.geo.origin.windowOffset.top+c.geo.window.scroll.top},d.coord={left:p.left+(d.coord.left-c.geo.origin.windowOffset.left),top:p.top+(d.coord.top-c.geo.origin.windowOffset.top)},e.__sideChange(e.__instance._$tooltip,d.side),c.geo.origin.fixedLineage?e.__instance._$tooltip.css("position","fixed"):e.__instance._$tooltip.css("position",""),e.__instance._$tooltip.css({left:d.coord.left,top:d.coord.top,height:d.size.height,width:d.size.width}).find(".tooltipster-arrow").css({left:"",top:""}).css(n.prop,n.val),e.__instance._$tooltip.appendTo(e.__instance.option("parent")),e.__instance._trigger({type:"repositioned",event:b,position:d})},__sideChange:function(a,b){a.removeClass("tooltipster-bottom").removeClass("tooltipster-left").removeClass("tooltipster-right").removeClass("tooltipster-top").addClass("tooltipster-"+b)},__targetFind:function(a){var b={},c=this.__instance._$origin[0].getClientRects();if(c.length>1){var d=this.__instance._$origin.css("opacity");1==d&&(this.__instance._$origin.css("opacity",.99),c=this.__instance._$origin[0].getClientRects(),this.__instance._$origin.css("opacity",1))}if(c.length<2)b.top=Math.floor(a.geo.origin.windowOffset.left+a.geo.origin.size.width/2),b.bottom=b.top,b.left=Math.floor(a.geo.origin.windowOffset.top+a.geo.origin.size.height/2),b.right=b.left;else{var e=c[0];b.top=Math.floor(e.left+(e.right-e.left)/2),e=c.length>2?c[Math.ceil(c.length/2)-1]:c[0],b.right=Math.floor(e.top+(e.bottom-e.top)/2),e=c[c.length-1],b.bottom=Math.floor(e.left+(e.right-e.left)/2),e=c.length>2?c[Math.ceil((c.length+1)/2)-1]:c[c.length-1],b.left=Math.floor(e.top+(e.bottom-e.top)/2)}return b}}}),a});
; /**
 * Tooltipster 4 defaults that keep the timing we had on 3.x: 4.x waits 300ms before opening (3.x
 * 200ms), wiggles a tooltip whose content changes while open (3.x faded), and logs to the console
 * whenever an element is initialised twice, which jquery.chosen.js does on every selection.
 * Listed right after tooltipster.bundle.min.js in every ResourceList array that loads it.
 */
(function ($) {
    if (!$.tooltipster) {
        return;
    }
    $.tooltipster.setDefaults({
        delay: 200,
        updateAnimation: 'fade',
        debug: false
    });
})(jQuery);

; /**
 * Accessibility enhancements for user-authored content (Lighthouse audits).
 * Saved page HTML (snippets, embeds, legacy widgets) predates renderer-level fixes,
 * so the gaps are patched at runtime: images without alt, iframes without title,
 * icon-only links without an accessible name.
 */
(function () {
    "use strict";

    // The FEE preview iframe loads site JS and SERIALIZES the DOM on save — injected
    // attributes would silently persist into user content. Site-render only.
    function isEditorMode() {
        return document.body.classList.contains("fee-editor-active") ||
            (typeof app !== "undefined" && app.is_front_end_editor === true);
    }

    function labelFromUrl(url) {
        try {
            return new URL(url, location.href).hostname;
        } catch (e) {
            return "";
        }
    }

    // Combined-CSS tenants inline a DB-cached copy of the fixed bundle that only refreshes when
    // "Combine Fixed CSS" is re-run - if a deploy lands before that, .wc-sr-only would not exist
    // and the context suffixes would render VISIBLY. Define the rule here too; last-one-wins is
    // irrelevant (identical declarations).
    function ensureSrOnlyRule() {
        var style = document.createElement("style");
        style.textContent = ".wc-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}";
        document.head.appendChild(style);
    }

    function enhance(root) {
        if (isEditorMode()) {
            return;
        }
        if (!enhance.srOnlyEnsured) {
            enhance.srOnlyEnsured = true;
            ensureSrOnlyRule();
        }
        var scope = root || document;

        // Missing alt fails the audit outright; empty alt marks the image decorative
        scope.querySelectorAll("img:not([alt])").forEach(function (img) {
            img.setAttribute("alt", "");
        });

        scope.querySelectorAll("iframe:not([title])").forEach(function (frame) {
            var host = labelFromUrl(frame.getAttribute("src") || "");
            frame.setAttribute("title", host ? "Embedded content: " + host : "Embedded content");
        });

        // Icon-only links (legacy social bars, logo image links) with no text content.
        // User-authored snippet anchors often carry no class at all, so the platform is
        // derived from the href too, with the hostname as a last resort for external links.
        scope.querySelectorAll("a:not([aria-label]):not([title])").forEach(function (link) {
            if (link.textContent.trim() || link.querySelector("img[alt]:not([alt=''])")) {
                return;
            }
            var href = link.getAttribute("href") || "";
            var label = (link.className.match(SOCIAL_PLATFORMS) || [])[0] ||
                (href.match(SOCIAL_PLATFORMS) || [])[0];
            if (!label && href === "/") {
                label = "Home";
            }
            if (!label && /^https?:\/\//i.test(href)) {
                label = labelFromUrl(href).replace(/^www\./, "");
            }
            if (label) {
                link.setAttribute("aria-label", label.charAt(0).toUpperCase() + label.slice(1));
            }
        });

        // Lighthouse SEO "link-text": a link whose whole text is generic ("read more", "more",
        // "learn more") tells search engines nothing. Renderer templates now append a hidden
        // context span server-side; user-authored content (snippets, saved page HTML) can't be
        // fixed there, so derive a context here - card heading, title attr, or the URL slug -
        // and append it visually hidden (.wc-sr-only, site-base.css).
        scope.querySelectorAll("a[href]").forEach(function (link) {
            var text = link.textContent.trim().toLowerCase().replace(/\s+/g, " ");
            if (GENERIC_LINK_TEXT.indexOf(text) === -1 || link.querySelector(".wc-sr-only")) {
                return;
            }
            var context = descriptiveLinkContext(link);
            if (!context || context.toLowerCase() === text) {
                return;
            }
            var suffix = document.createElement("span");
            suffix.className = "wc-sr-only";
            // textContent keeps user data inert - never innerHTML here
            suffix.textContent = " - " + context;
            link.appendChild(suffix);
        });
    }

    var SOCIAL_PLATFORMS = /facebook|twitter|linkedin|instagram|youtube|pinterest|tiktok/;

    // Lighthouse's link-text blocklist (en) plus the storefront's common offenders
    var GENERIC_LINK_TEXT = ["click here", "click this", "go", "here", "this", "start",
        "right here", "more", "learn more", "why this", "more info", "more information",
        "read more", "view", "view more", "view all", "continue", "continue reading",
        "keep reading", "details", "see more", "shop now", "buy now", "click"];

    function descriptiveLinkContext(link) {
        var container = link.closest("article, li, [class*='post'], [class*='item'], [class*='card'], .widget") || link.parentElement;
        var heading = container ? container.querySelector("h1,h2,h3,h4,h5,h6,[class*='title']") : null;
        var text = heading ? heading.textContent.trim() : "";
        if (!text) {
            text = (link.getAttribute("title") || "").trim();
        }
        if (!text) {
            var path = (link.getAttribute("href") || "").split("?")[0].split("#")[0];
            var segment = path.split("/").filter(Boolean).pop() || "";
            try {
                segment = decodeURIComponent(segment);
            } catch (e) {
                // malformed escape in a user-authored href - use it as-is
            }
            text = segment.replace(/\.[a-z0-9]+$/i, "").replace(/[-_+]+/g, " ").trim();
        }
        return text.slice(0, 120);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () { enhance(); });
    } else {
        enhance();
    }
})();

; /**
 * HWC-5637 - Store Logo variants on the storefront.
 *
 * logoWidget.gsp marks the logo <img> with class `wc-logo-variants` plus data-logo-main / -dark / -sticky
 * ONLY when the store has at least one variant uploaded in Site Settings (no variant = untouched markup,
 * this file then does nothing). Per image, the variant is picked automatically unless the widget pins it with
 * data-logo-choice (StoreLogoWidgetVariant.groovy: "main" never picks dark, "dark" always does):
 *   1. the logo sits in a header whose sticky/fixed box is currently stuck  AND a sticky logo exists  -> sticky
 *   2. the logo's effective background has a WCAG relative luminance < 0.2  AND a dark logo exists     -> dark
 *      Effective background = the first background with alpha >= 0.5 painted beneath the logo centre
 *      (document.elementsFromPoint, so a transparent absolute/fixed header over a hero reads the hero) when the
 *      logo is on screen, else the first such DOM-ancestor background. Gradients = average of their colour
 *      stops; url() = canvas sample, falling back to that element's own background-color when the image cannot
 *      be read (404 / no CORS); still loading = unknown (main kept, re-picked on load); nothing found = white.
 *   3. otherwise                                                                                         -> main
 * Only the src of the SAME <img> is swapped (width/height/object-fit/alignment widget params stay on it),
 * and only after the target has preloaded, so there is never a broken-image flash. A variant that fails
 * to load is never shown - including a pinned dark logo the server rendered, which falls back to the main logo.
 *
 * Accepted flicker (HWC-5637 review #6): the server renders the MAIN logo unless dark is pinned; the swap happens
 * only after this deferred site bundle runs, so a page that needs the dark/sticky logo shows the main one briefly first
 * (measured ~60-360 ms). Variants should keep the main logo's proportions so the swap causes no layout shift.
 *
 * Re-runs: rAF-throttled scroll (bound only when a header carries a variant logo), debounced resize,
 * window load, an explicit window.wcStoreLogoVariants.refresh() (site.js calls it after cloning the logo
 * into the mobile nav drawer), and - inside the FEE editor iframe only - a debounced MutationObserver so
 * the canvas follows widget re-renders and section background edits. The editor tokenises every .widget
 * back to <wi:widget> on save (fee.editor.events.js _cleanSectionForSave), so a swapped src is never persisted.
 */
;(function (window, document) {
    "use strict";

    var IMG_SELECTOR = "img.wc-logo-variants";
    var HEADER_SELECTOR = "[section='header'], .header";
    var ATTR_MAIN = "data-logo-main";
    var ATTR_DARK = "data-logo-dark";
    var ATTR_STICKY = "data-logo-sticky";
    var ATTR_CHOICE = "data-logo-choice";
    // Which variant is showing - for QA / CSS hooks only; never read back as state.
    var ATTR_CURRENT = "data-logo-current";

    var VARIANT_MAIN = "main";
    var VARIANT_DARK = "dark";
    var VARIANT_STICKY = "sticky";

    var CHOICE_MAIN = "main";
    var CHOICE_DARK = "dark";

    var DARK_LUMINANCE_THRESHOLD = 0.2;
    var MIN_BACKGROUND_ALPHA = 0.5;
    var STUCK_TOLERANCE_PX = 1;
    var RESIZE_DEBOUNCE_MS = 150;
    var EDITOR_MUTATION_DEBOUNCE_MS = 200;
    var BACKGROUND_SAMPLE_PX = 16;

    var LOAD_LOADING = "loading";
    var LOAD_LOADED = "loaded";
    var LOAD_ERROR = "error";

    // Effective background could not be determined (url() not sampleable yet / tainted) -> keep the main logo.
    var UNKNOWN = null;
    var WHITE = {r: 255, g: 255, b: 255, a: 1};
    var REPLACED_CONTENT_TAGS = /^(IMG|VIDEO|CANVAS|IFRAME|PICTURE|SVG|OBJECT|EMBED)$/i;

    var urlLoadState = {};      // logo url -> LOAD_*
    var urlLoadWaiters = {};    // logo url -> [img, ...] waiting for that url to preload
    var backgroundSamples = {}; // background-image url -> {status: LOAD_*, rgba}
    var colourCache = {};
    var colourCanvas = null;

    var scrollBound = false;
    var scrollFrameQueued = false;
    var resizeBound = false;
    var errorBound = false;
    var resizeTimer = null;
    var editorObserver = null;
    var editorTimer = null;

    function attr(img, name) {
        var value = img.getAttribute(name);
        return value ? value : "";
    }

    function headerOf(img) {
        // Outermost header ancestor: sticky may sit on the inner `.header` row (LayoutService / PageService
        // inline position:sticky) or on the [section=header] wrapper itself (theme CSS).
        var header = img.closest(HEADER_SELECTOR);
        var outer = header;
        while (outer && outer.parentElement) {
            outer = outer.parentElement.closest(HEADER_SELECTOR);
            if (outer) {
                header = outer;
            }
        }
        return header;
    }

    function isEditorFrame() {
        var body = document.body;
        if (!body) {
            return false;
        }
        // body.fee = sitepage.gsp editMode && isFrontEndEditor (the universal FEE marker, see site.js _isFeeEditing).
        return body.classList.contains("fee") || body.classList.contains("fee-editor-active") ||
            body.classList.contains("fee-custom-scroll") ||
            (typeof window.app !== "undefined" && window.app && window.app.is_front_end_editor === true);
    }

    // ---------------------------------------------------------------- colours

    function colourContext() {
        if (!colourCanvas) {
            colourCanvas = document.createElement("canvas");
            colourCanvas.width = 1;
            colourCanvas.height = 1;
        }
        return colourCanvas.getContext("2d", {willReadFrequently: true});
    }

    function parseColour(value) {
        if (!value) {
            return null;
        }
        if (Object.prototype.hasOwnProperty.call(colourCache, value)) {
            return colourCache[value];
        }
        var result = null;
        var m = /^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)(?:\s*[,\/]\s*([\d.]+)(%?))?\s*\)$/i.exec(value);
        if (m) {
            var alpha = m[4] === undefined ? 1 : parseFloat(m[4]) / (m[5] ? 100 : 1);
            result = {r: +m[1], g: +m[2], b: +m[3], a: alpha};
        }
        else if (/^transparent$/i.test(value)) {
            result = {r: 0, g: 0, b: 0, a: 0};
        }
        else {
            // Modern syntaxes (oklch, color(), hsl ...) - let the browser rasterise one pixel.
            try {
                var ctx = colourContext();
                ctx.clearRect(0, 0, 1, 1);
                ctx.fillStyle = "rgba(0, 0, 0, 0)";
                ctx.fillStyle = value;
                ctx.fillRect(0, 0, 1, 1);
                var px = ctx.getImageData(0, 0, 1, 1).data;
                result = {r: px[0], g: px[1], b: px[2], a: px[3] / 255};
            } catch (e) {
                result = null;
            }
        }
        colourCache[value] = result;
        return result;
    }

    function averageColours(colours) {
        var r = 0, g = 0, b = 0, a = 0;
        for (var i = 0; i < colours.length; i++) {
            var c = colours[i];
            r += c.r * c.a;
            g += c.g * c.a;
            b += c.b * c.a;
            a += c.a;
        }
        if (!colours.length) {
            return null;
        }
        if (a === 0) {
            return {r: 0, g: 0, b: 0, a: 0};
        }
        return {r: r / a, g: g / a, b: b / a, a: a / colours.length};
    }

    function relativeLuminance(c) {
        function channel(v) {
            var s = v / 255;
            return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * channel(c.r) + 0.7152 * channel(c.g) + 0.0722 * channel(c.b);
    }

    // Splits a computed background-image into its layers (top-most first) on top-level commas.
    function splitLayers(value) {
        var layers = [], depth = 0, start = 0, quote = "";
        for (var i = 0; i < value.length; i++) {
            var ch = value.charAt(i);
            if (quote) {
                if (ch === quote && value.charAt(i - 1) !== "\\") {
                    quote = "";
                }
            }
            else if (ch === "\"" || ch === "'") {
                quote = ch;
            }
            else if (ch === "(") {
                depth++;
            }
            else if (ch === ")") {
                depth--;
            }
            else if (ch === "," && depth === 0) {
                layers.push(value.slice(start, i).trim());
                start = i + 1;
            }
        }
        layers.push(value.slice(start).trim());
        return layers;
    }

    function gradientColour(layer) {
        var stops = layer.match(/(?:rgba?|hsla?|hwb|lab|lch|oklab|oklch|color)\([^()]*\)|#[0-9a-f]{3,8}\b|\btransparent\b/gi) || [];
        var colours = [];
        for (var i = 0; i < stops.length; i++) {
            var c = parseColour(stops[i]);
            if (c) {
                colours.push(c);
            }
        }
        return averageColours(colours);
    }

    function cssUrl(layer) {
        var m = /^url\(\s*(['"]?)(.*?)\1\s*\)$/i.exec(layer);
        return m ? m[2] : "";
    }

    function sampleBackgroundImage(url) {
        var entry = backgroundSamples[url];
        if (entry) {
            return entry;
        }
        entry = {status: LOAD_LOADING, rgba: null};
        backgroundSamples[url] = entry;
        var image = new Image();
        var absolute;
        try {
            absolute = new URL(url, document.baseURI);
        } catch (e) {
            entry.status = LOAD_ERROR;
            return entry;
        }
        if (absolute.protocol !== "data:" && absolute.protocol !== "blob:" && absolute.origin !== window.location.origin) {
            // Cross-origin (S3 / CDN): only readable with CORS; a refusal lands in onerror -> unknown -> main logo.
            image.crossOrigin = "anonymous";
        }
        image.onload = function () {
            try {
                var canvas = document.createElement("canvas");
                canvas.width = BACKGROUND_SAMPLE_PX;
                canvas.height = BACKGROUND_SAMPLE_PX;
                var ctx = canvas.getContext("2d", {willReadFrequently: true});
                ctx.drawImage(image, 0, 0, BACKGROUND_SAMPLE_PX, BACKGROUND_SAMPLE_PX);
                var data = ctx.getImageData(0, 0, BACKGROUND_SAMPLE_PX, BACKGROUND_SAMPLE_PX).data;
                var colours = [];
                for (var i = 0; i < data.length; i += 4) {
                    colours.push({r: data[i], g: data[i + 1], b: data[i + 2], a: data[i + 3] / 255});
                }
                entry.rgba = averageColours(colours);
                entry.status = LOAD_LOADED;
            } catch (e) {
                // Tainted canvas (no CORS) - the background stays unknown, the main logo is kept.
                entry.status = LOAD_ERROR;
            }
            refresh();
        };
        image.onerror = function () {
            entry.status = LOAD_ERROR;
            // Re-pick: an unreadable layer now falls back to the element's own background-color.
            refresh();
        };
        image.src = absolute.href;
        return entry;
    }

    // Colour an element paints behind its content, `undefined` when it paints nothing opaque enough,
    // UNKNOWN when it paints an image we cannot read yet (still loading) or cannot read at all and has no
    // opaque background-color to fall back to.
    function elementBackground(style) {
        var image = style.backgroundImage;
        var unreadable = false;
        var pending = false;
        if (image && image !== "none") {
            var layers = splitLayers(image);
            for (var i = 0; i < layers.length; i++) {
                var layer = layers[i];
                if (/gradient\(/i.test(layer)) {
                    var g = gradientColour(layer);
                    if (g && g.a >= MIN_BACKGROUND_ALPHA) {
                        return g;
                    }
                }
                else if (/^url\(/i.test(layer)) {
                    var url = cssUrl(layer);
                    var sample = url ? sampleBackgroundImage(url) : {status: LOAD_ERROR, rgba: null};
                    if (sample.status === LOAD_LOADING) {
                        pending = true; // the sampler's onload / onerror refreshes
                        continue;
                    }
                    if (sample.status === LOAD_ERROR) {
                        unreadable = true;
                        continue;
                    }
                    if (sample.rgba && sample.rgba.a >= MIN_BACKGROUND_ALPHA) {
                        return sample.rgba;
                    }
                }
            }
        }
        if (pending) {
            return UNKNOWN;
        }
        // HWC-5637 review #7: an unreadable url() (404, no CORS, tainted canvas) falls back to the element's own
        // opaque background-color - what the browser paints when the image is missing. Trade-off: a light image
        // over a dark colour from a non-CORS host reads as dark.
        var colour = parseColour(style.backgroundColor);
        if (colour && colour.a >= MIN_BACKGROUND_ALPHA) {
            return colour;
        }
        return unreadable ? UNKNOWN : undefined;
    }

    // What is painted directly beneath the logo centre, in paint order (covers transparent absolute / fixed
    // headers over a hero). `undefined` when the logo is off screen or not hit-testable (then the DOM ancestors
    // are walked instead).
    function backgroundUnderLogo(img) {
        if (!document.elementsFromPoint) {
            return undefined;
        }
        var rect = img.getBoundingClientRect();
        var x = rect.left + rect.width / 2;
        var y = rect.top + rect.height / 2;
        if (rect.width <= 0 || rect.height <= 0 || x < 0 || y < 0 || x >= window.innerWidth || y >= window.innerHeight) {
            return undefined;
        }
        var stack = document.elementsFromPoint(x, y);
        var start = stack.indexOf(img);
        if (start === -1) {
            return undefined; // covered by another element or pointer-events:none
        }
        for (var i = start + 1; i < stack.length; i++) {
            // A photo / video / canvas / frame / inline svg under the logo paints content we cannot read as a colour:
            // unknown keeps the main logo, instead of looking THROUGH it to the section colour behind.
            if (REPLACED_CONTENT_TAGS.test(stack[i].tagName)) {
                return UNKNOWN;
            }
            var found = elementBackground(window.getComputedStyle(stack[i]));
            if (found !== undefined) {
                return found;
            }
        }
        return WHITE;
    }

    function effectiveBackground(img) {
        var underLogo = backgroundUnderLogo(img);
        if (underLogo !== undefined) {
            return underLogo;
        }
        for (var el = img; el && el.nodeType === 1; el = el.parentElement) {
            var found = elementBackground(window.getComputedStyle(el));
            if (found !== undefined) {
                return found;
            }
        }
        return WHITE;
    }

    // ---------------------------------------------------------------- sticky

    function pageScrolled(header) {
        if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 0) {
            return true;
        }
        // Editor canvases may scroll an inner container instead of the window.
        for (var el = header.parentElement; el && el.nodeType === 1; el = el.parentElement) {
            if (el.scrollTop > 0) {
                return true;
            }
        }
        return false;
    }

    function isHeaderStuck(img, header) {
        if (!header || !pageScrolled(header)) {
            return false;
        }
        var stop = header.parentElement;
        for (var el = img.parentElement; el && el !== stop; el = el.parentElement) {
            var style = window.getComputedStyle(el);
            var position = style.position;
            if (position !== "sticky" && position !== "fixed") {
                continue;
            }
            var top = parseFloat(style.top);
            if (isNaN(top)) {
                if (position === "sticky") {
                    continue; // top:auto never sticks vertically
                }
                top = 0;
            }
            var rect = el.getBoundingClientRect();
            // Stuck = pinned at its `top` offset while the page is scrolled. A sticky box whose wrapper is too
            // short to stick (PageService: "sticks within the [section=header] wrapper") scrolls away and
            // never matches, so its logo is not swapped for nothing.
            if (rect.bottom > 0 && Math.abs(rect.top - top) <= STUCK_TOLERANCE_PX) {
                return true;
            }
        }
        return false;
    }

    // ---------------------------------------------------------------- selection + swap

    function usable(url) {
        return !!url && urlLoadState[url] !== LOAD_ERROR;
    }

    function pickUrl(img) {
        var main = attr(img, ATTR_MAIN);
        var dark = attr(img, ATTR_DARK);
        var sticky = attr(img, ATTR_STICKY);
        if (usable(sticky) && isHeaderStuck(img, headerOf(img))) {
            return {variant: VARIANT_STICKY, url: sticky};
        }
        var choice = attr(img, ATTR_CHOICE);
        if (usable(dark) && (choice === CHOICE_DARK || (choice !== CHOICE_MAIN && isOnDarkBackground(img)))) {
            return {variant: VARIANT_DARK, url: dark};
        }
        return {variant: VARIANT_MAIN, url: main};
    }

    function isOnDarkBackground(img) {
        var background = effectiveBackground(img);
        return background !== UNKNOWN && relativeLuminance(background) < DARK_LUMINANCE_THRESHOLD;
    }

    function preload(url, img) {
        var waiters = urlLoadWaiters[url] || (urlLoadWaiters[url] = []);
        if (waiters.indexOf(img) === -1) {
            waiters.push(img);
        }
        if (urlLoadState[url] === LOAD_LOADING) {
            return;
        }
        urlLoadState[url] = LOAD_LOADING;
        var probe = new Image();
        var settle = function (state) {
            urlLoadState[url] = state;
            var pending = urlLoadWaiters[url] || [];
            delete urlLoadWaiters[url];
            // Re-pick rather than blindly swapping: the scroll/background state may have moved on meanwhile,
            // and a failed variant is now excluded by usable().
            for (var i = 0; i < pending.length; i++) {
                if (pending[i].isConnected) {
                    applyTo(pending[i]);
                }
            }
        };
        probe.onload = function () {
            settle(LOAD_LOADED);
        };
        probe.onerror = function () {
            settle(LOAD_ERROR);
        };
        probe.src = url;
    }

    function applyTo(img) {
        var main = attr(img, ATTR_MAIN);
        if (!main) {
            return;
        }
        var current = img.getAttribute("src") || "";
        // A src that is none of the three urls was set by someone else - the editor's Change-logo popup writes only
        // src. It is the new main logo: adopt it, or the next refresh would swap the replaced logo back in.
        if (current && current !== main && current !== attr(img, ATTR_DARK) && current !== attr(img, ATTR_STICKY)) {
            img.setAttribute(ATTR_MAIN, current);
            main = current;
        }
        // A server-rendered main logo that has painted needs no preload.
        if (current === main && img.complete && img.naturalWidth > 0) {
            urlLoadState[main] = LOAD_LOADED;
        }
        // A pinned dark logo the server rendered that failed before this ran is excluded like a failed preload.
        if (attr(img, ATTR_CHOICE) === CHOICE_DARK && current === attr(img, ATTR_DARK) &&
            img.complete && img.naturalWidth === 0) {
            urlLoadState[current] = LOAD_ERROR;
        }
        var pick = pickUrl(img);
        if (!pick.url) {
            return;
        }
        if (current === pick.url) {
            img.setAttribute(ATTR_CURRENT, pick.variant);
            return;
        }
        if (urlLoadState[pick.url] === LOAD_LOADED) {
            img.setAttribute("src", pick.url);
            img.setAttribute(ATTR_CURRENT, pick.variant);
            return;
        }
        if (urlLoadState[pick.url] === LOAD_ERROR) {
            return; // only reachable for a broken main logo - leave whatever is showing
        }
        preload(pick.url, img); // keeps the current src until the target is ready
    }

    function variantImages() {
        return document.querySelectorAll(IMG_SELECTOR);
    }

    function refresh() {
        var images = variantImages();
        var inHeader = false;
        for (var i = 0; i < images.length; i++) {
            applyTo(images[i]);
            if (!inHeader && headerOf(images[i])) {
                inHeader = true;
            }
        }
        if (images.length) {
            bindResize();
            bindImageErrors();
        }
        if (inHeader) {
            bindScroll();
        }
    }

    function refreshHeaderLogos() {
        var images = variantImages();
        for (var i = 0; i < images.length; i++) {
            if (headerOf(images[i])) {
                applyTo(images[i]);
            }
        }
    }

    // ---------------------------------------------------------------- listeners

    function bindScroll() {
        if (scrollBound) {
            return;
        }
        scrollBound = true;
        // Capture on document also sees inner scroll containers (editor canvas), whose scroll events do not bubble.
        document.addEventListener("scroll", function () {
            if (scrollFrameQueued) {
                return;
            }
            scrollFrameQueued = true;
            window.requestAnimationFrame(function () {
                scrollFrameQueued = false;
                refreshHeaderLogos();
            });
        }, {capture: true, passive: true});
    }

    function bindResize() {
        if (resizeBound) {
            return;
        }
        resizeBound = true;
        window.addEventListener("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(refresh, RESIZE_DEBOUNCE_MS);
        });
    }

    function bindEditorObserver() {
        if (editorObserver || typeof window.MutationObserver === "undefined" || !isEditorFrame()) {
            return;
        }
        // Widget re-renders (childList) and section background edits (class/style). src and data-* are not
        // observed, so this file's own swaps never re-trigger it.
        editorObserver = new MutationObserver(function () {
            clearTimeout(editorTimer);
            editorTimer = setTimeout(refresh, EDITOR_MUTATION_DEBOUNCE_MS);
        });
        editorObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "style"]
        });
    }

    function bindImageErrors() {
        if (errorBound) {
            return;
        }
        errorBound = true;
        // Image errors do not bubble; capture catches a server-rendered variant (pinned dark) failing after a refresh.
        document.addEventListener("error", function (event) {
            var img = event.target;
            if (!img || !img.matches || !img.matches(IMG_SELECTOR)) {
                return;
            }
            var failed = img.getAttribute("src") || "";
            if (failed && (failed === attr(img, ATTR_DARK) || failed === attr(img, ATTR_STICKY))) {
                urlLoadState[failed] = LOAD_ERROR;
                applyTo(img);
            }
        }, true);
    }

    function init() {
        refresh();
        bindEditorObserver();
        // Late layout / background images / web fonts can change both stuck state and backgrounds.
        if (document.readyState !== "complete") {
            window.addEventListener("load", refresh);
        }
    }

    window.wcStoreLogoVariants = {
        refresh: refresh
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    }
    else {
        init();
    }
})(window, document);
